
    /* eslint-disable max-len */
import { CodebaseProductData } from '@/features/Product/types/models';
export const codeProductData = new Map<string, CodebaseProductData>([
  [
    "10018-CC@colour-corrector",
    {
      "attributes": {
        "sku": "10018-CC",
        "productHandle": "colour-corrector",
        "categoryDetails": {
          "primaryCategory": "colour-corrector"
        },
        "age": 1
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01-V34ColourCorrector-PP.jpg?v=1759817336",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/a2f06b7d355b41f88ef393dfb5c05f49.mp4",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-3_a7237219-45b8-4c7b-9fe2-5603c693848f.jpg?v=1746740235",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-4_fb5dab33-b8df-429c-bd4c-9861f332f1d7.jpg?v=1746740248",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/05-V34-PP_3e81af6e-fdf8-48dc-9b3c-b9b1f36a7fa7.jpg?v=1746740253",
              "height": 1536,
              "width": 2160
            }
          ]
        }
      },
      "content": {
        "description": {
          "title": "Utilises colour correction technology",
          "body": "V34 Colour Corrector Serum is a teeth brightener that's peroxide-free, designed to work exactly like concealer, but for your teeth. Using colour correcting technology, it's designed to temporarily conceal the yellow tones in your teeth to reveal a perceivably whiter smile. The results are entirely on the tooth surface, and it's a non-invasive alternative to bleaching!",
          "bulletpoints": [
            "Uses colour correction technology",
            "Non-invasive brightening boost",
            "Want something more permanent? Try our <a style=\"text-decoration: underline\" href=\"/collections/whitening\">PAP+ range</a>"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/a4b3fd07d12bb98c276b9ee37f0b4a01.svg?v=1685928674",
              "height": 30,
              "width": 20
            },
            "text": "Colour correcting <br> technology"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1685928673",
              "height": 30,
              "width": 20
            },
            "text": "Brightening <br> boost"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Non-invasive <br> treatment"
          }
        ],
        "productAccordions": [
          {
            "title": "How does V34 Colour Corrector work?",
            "content": [
              {
                "body": "V34 Colour Corrector Serum is your go-to for a brightening and whitening boost, using colour correction to temporarily enhance the appearance of your smile! The results are entirely on the tooth surface, and it's a non-invasive alternative to bleaching. Re-apply the V34 Serum as needed, individual results may vary."
              }
            ]
          },
          {
            "title": "How and when should I use V34 Colour Corrector Serum?",
            "content": [
              {
                "body": "The best results are achieved with direct application of the V34 Serum through a tool such as a cotton swab or soft bristled toothbrush. It's important to gently polish the serum onto your teeth for 30 seconds, specifically focusing on the spots that are the most yellow, before wiping the leftover residue or rinsing with water if needed. V34 Serum can be reapplied as needed, and is recommended just before going out as a temporary concealer for yellow tones and a whitening boost to your smile."
              }
            ]
          },
          {
            "title": "What's included?",
            "content": [
              {
                "body": "1x V34 Colour Corrector Serum<br>Total Net Contents: 30ml | 1 fl oz"
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Glycerin, Aqua/Water, Sorbitol, Hydrated Silica, Xylitol, Polysorbate 80, Cellulose Gum, Mentha Piperita (Peppermint) Oil, Phenoxyethanol, Sucralose, Tetrasodium Pyrophosphate, CI17200/D&C Red No. 33, CI42090/FD&C Blue No.1, Ethylhexylglycerin."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "What is V34 Colour Corrector Serum?",
              "content": [
                {
                  "body": "V34 Serum is a temporary teeth whitener that's designed to work exactly like a concealer, but for your teeth. Using colour correcting technology, it's designed to conceal the yellow tones in your teeth to improve and enhance the perceived brightness of your smile.<br><br>V34 Serum is for people who have yellow tones in their teeth and are looking for a concealer that can be applied as often as needed to temporarily reduce the appearance of yellow tones, leaving you with a perceivably whiter smile. If you are looking for a longer term whitening product, check out our <a style=\"text-decoration: underline\" href=\"/products/whitening-strips\">PAP+ Whitening Strips</a>"
                }
              ]
            },
            {
              "title": "Can I use V34 with veneers, caps, implants, bridges, or bonded teeth?",
              "content": [
                {
                  "body": "V34 is perfectly safe to be used on dental work as it is a non-abrasive form of brightening, however we would recommend to avoid brushing it onto these teeth, as only natural teeth can be colour-corrected. We always advise checking with your dentist before using, to ensure it is a suitable product for you."
                }
              ]
            }
          ]
        },
        "customComponents": [
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "Heard of purple shampoo? Bet you haven't tried it for your teeth. Here's how it works:",
                      "description": "Colour correction all starts on the colour wheel, where purple and yellow are complementary colours opposite to each other. Using a similar concept to purple shampoo, applying purple onto your teeth can temporarily neutralise the yellow undertones to conceal them, revealing a perceptively whiter shade. Pretty cool right?"
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/v34_Toothbrush_Drip.mp4?v=1632715790",
                      "height": 560,
                      "width": 560,
                      "alt": "V34 Colour Corrector Serum on toothbrush"
                    }
                  },
                  {
                    "content": {
                      "title": "We developed the perfect shade of deep violet purple, that neutralises yellow.",
                      "description": "V34 Serum is the perfect non-invasive whitening boost designed to temporarily conceal those pesky yellow stains. The best part is that it acts entirely on the tooth surface!"
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/V34_-_Content_-_Block_-_1.jpg?v=1632715890",
                      "height": 560,
                      "width": 560,
                      "alt": "Colour corrected teeth covered in V34 Colour Corrector Serum and home teeth whitened"
                    }
                  },
                  {
                    "content": {
                      "title": "Want a daily brightener that works in 30-seconds? V34 is for you",
                      "description": "A convenient solution designed for daily use, the same way you would use a concealer for your skin. Re-apply as needed for your go-to temporary whitening boost!"
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/v34_UGC_Below_the_Fold.mp4?v=1632961072",
                      "height": 560,
                      "width": 560
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "10049-7P@whitening-strips",
    {
      "attributes": {
        "sku": "10049-7P",
        "productHandle": "whitening-strips",
        "categoryDetails": {
          "primaryCategory": "whitening-strips"
        },
        "age": 3
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/01-Strips-ProductPage_c6e30a8e-2561-4e75-8d76-238b52842a30.png?v=1748990376",
              "height": 512,
              "width": 352,
              "alt": "PAP+ Strips"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/02-PAP_Strips7PK-PP_893ab61a-544f-48f5-a4e9-1739d5c10023.jpg?v=1748990376",
              "height": 512,
              "width": 352,
              "alt": "Model smiling with PAP+ Strips"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/03-PAP_Strips7PK-PP_06988ca5-8e7c-4d89-8aeb-37f62a869a0e.jpg?v=1748990376",
              "height": 512,
              "width": 352,
              "alt": "Model applying PAP+ Strips"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/04-PAP_Strips7PK-PP_46feb57e-9d38-4093-b5f8-13cd644a3144.jpg?v=1748990376",
              "height": 512,
              "width": 352,
              "alt": "PAP+ Strips"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/05-PAP_Strips7PK-PP_62e67535-1c44-4aa4-afc6-856b29e9fbef.jpg?v=1748990376",
              "height": 414,
              "width": 656,
              "alt": "PAP+ Strips in a bag"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "description": {
          "title": "Convenient, on-the-go PAP+ Whitening Strips",
          "body": "Based on our best-selling whitening formula PAP+, we’ve designed strips as our most convenient way to whiten yet."
        },
        "pill": {
          "variant": "information",
          "text": "Best seller"
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Gently lift <br> stains"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/22927a2063a4b2b73b792e4c761468a6.svg?v=1684451614",
              "height": 30,
              "width": 20
            },
            "text": "Great for <br> on-the-go"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/b61f64479226187079c502eaccf16154_d29cc97b-7a6d-4e8d-8032-82d8ac083097.svg?v=1684284570",
              "height": 30,
              "width": 20
            },
            "text": "Hydrogen peroxide <br> free"
          }
        ],
        "productAccordions": [
          {
            "title": "How do PAP+ Strips whiten?",
            "content": [
              {
                "body": "When applied to your teeth, each strip firmly adheres to the tooth surface and releases the active ingredients of the PAP+ formula into the tooth's structure to whiten the tooth. Individual whitening results may vary, but in some cases, can be seen after just one use!"
              }
            ]
          },
          {
            "title": "Do PAP+ teeth whitening strips cause tooth sensitivity?",
            "content": [
              {
                "body": "When PAP+ whitens, it oxidises tooth stains without releasing molecules known as free radicals. These radicals are often a cause of sensitivity. During the whitening process with PAP+, there is no damage or erosion to the enamel, meaning the outer layers of the tooth remain intact and can continue to protect the nerves whilst being effectively whitened. Individual experiences may vary."
              }
            ]
          },
          {
            "title": "How and when should I use PAP+ Strips?",
            "content": [
              {
                "body": "Dry teeth thoroughly before use. Peel off the long strip and apply sticky side to top teeth. Press strip down firmly and fold over back of teeth to secure. Repeat for short strip on bottom teeth. Allow 30 minutes for whitening treatment. Remove strips and rinse mouth with water. Use PAP+ Strips as often as needed."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "head": "Phthalimidoperoxycaproic Acid (PAP)",
                "body": "A scientifically proven teeth whitening ingredient that is a safe alternative to peroxide. PAP has no negative side effects during the oxidation of tooth stains, which allows it to effectively whiten without pain or sensitivity."
              },
              {
                "head": "Full ingredients list",
                "body": "Glycerin, Aqua/Water, PVP, Ethylcellulose, Alcohol, Sodium Polyacrylate, Phthalimidoperoxycaproic Acid (PAP), Xylitol, Potassium Citrate, Hydroxyapatite, Rebaudioside A, Menthol, Sodium Citrate, Xanthan Gum, PVM/MA Copolymer, C12-15 Pareth-3."
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "Ready, set, smile!",
                      "description": "Each satchet comes with two strips, for your top and bottom teeth. Firmly apply a strip to both your upper & lower teeth. After 30 minutes, gently remove both strips from your teeth and say hello to a whiter & brighter smile."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/01-BTF_-_PAP_Whitneing_Strips_-_PP.jpg?v=1703138413",
                      "height": 560,
                      "width": 560
                    }
                  },
                  {
                    "content": {
                      "title": "Say goodbye to post-strip sensitivity.",
                      "description": "Our PAP+ formula has been designed to reduce the likelihood of sensitivity!"
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02-BTF_-_PAP_Whitneing_Strips_-_PP.jpg?v=1703138412",
                      "height": 560,
                      "width": 560
                    }
                  }
                ]
              }
            }
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "What’s the difference between the VIO405™ Teeth Whitening Kit and PAP+ Strips?",
              "content": [
                {
                  "body": "The VIO405 Teeth Whitening Kit offers a higher percentage of PAP, Hydroxyapatite, and Potassium Citrate for greater results with the addition of an LED Light activator. The PAP+ Strips are a clean and convenient on-the-go whitening solution for whitening wherever you are.\n            "
                }
              ]
            },
            {
              "title": "How does the PAP+ formula whiten?",
              "content": [
                {
                  "body": "When PAP+ whitens, it oxidises tooth stains without releasing molecules known as free radicals. These radicals are what can cause sensitivity for some people. \n            <br><br>\n            During the whitening process with PAP+, there is no damage or erosion to the enamel, meaning the outer layers of the tooth remain intact and can continue to protect the nerves whilst being effectively whitened.\n            <br><br>\n            The PAP+ whitening process targets a wide variety of tooth stains internally and externally. Based on our PAP+ formula, we've designed our PAP+ Pen as a gradual whitening product to use daily, or to touch up your whitening on the go.\n            "
                }
              ]
            },
            {
              "title": "How long does it take to see results from the PAP+ Strips?",
              "content": [
                {
                  "body": "The PAP+ Strips offer a 30 minute, clean residue-free whitening treatment. Whitening results vary, but can be seen after just one use of the PAP+ Strips."
                }
              ]
            },
            {
              "title": "Can Hismile be used with veneers, caps, implants, bridges, or bonded teeth?",
              "content": [
                {
                  "body": "Veneers, caps, implants, bonding or bridges aren’t designed to be whitened and require special care from your dentist. The PAP+ whitening formula works to oxidise stains from natural teeth, however, it may be helpful at keeping your surrounding teeth the same shade as the ones that have had dental work.\n            <br><br>\n            We always advise checking with your dentist before using, to ensure it is a suitable product for you.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "10058-SV@whitening-strips",
    {
      "attributes": {
        "sku": "10058-SV",
        "productHandle": "whitening-strips",
        "categoryDetails": {
          "primaryCategory": "whitening-strips"
        },
        "age": 3
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/01-PAP_Strips7pk-PP_a78be461-7a42-42de-907f-b2b9ce0ec48a.png?v=1773203231",
              "height": 512,
              "width": 352,
              "alt": "PAP+ Strips"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/02-PAP_Strips7PK-PP_893ab61a-544f-48f5-a4e9-1739d5c10023.jpg?v=1748990376",
              "height": 512,
              "width": 352,
              "alt": "Model smiling with PAP+ Strips"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/03-PAP_Strips7PK-PP_06988ca5-8e7c-4d89-8aeb-37f62a869a0e.jpg?v=1748990376",
              "height": 512,
              "width": 352,
              "alt": "Model applying PAP+ Strips"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/04-PAP_Strips7pk-PP.png?v=1773203231",
              "height": 512,
              "width": 352,
              "alt": "PAP+ Strips"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/05-PAP_Strips7PK-PP_62e67535-1c44-4aa4-afc6-856b29e9fbef.jpg?v=1748990376",
              "height": 414,
              "width": 656,
              "alt": "PAP+ Strips in a bag"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "description": {
          "title": "Convenient, on-the-go PAP+ Whitening Strips",
          "body": "Based on our best-selling whitening formula PAP+, we've designed strips as our most convenient way to whiten yet."
        },
        "pill": {
          "variant": "information",
          "text": "Best seller"
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Gently lift <br> stains"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/22927a2063a4b2b73b792e4c761468a6.svg?v=1684451614",
              "height": 30,
              "width": 20
            },
            "text": "Great for <br> on-the-go"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/b61f64479226187079c502eaccf16154_d29cc97b-7a6d-4e8d-8032-82d8ac083097.svg?v=1684284570",
              "height": 30,
              "width": 20
            },
            "text": "Hydrogen peroxide <br> free"
          }
        ],
        "productAccordions": [
          {
            "title": "How do PAP+ Strips whiten?",
            "content": [
              {
                "body": "When applied to your teeth, each strip firmly adheres to the tooth surface and releases the active ingredients of the PAP+ formula into the tooth's structure to whiten the tooth. Individual whitening results may vary, but in some cases, can be seen after just one use!"
              }
            ]
          },
          {
            "title": "Do PAP+ teeth whitening strips cause tooth sensitivity?",
            "content": [
              {
                "body": "When PAP+ whitens, it oxidises tooth stains without releasing molecules known as free radicals. These radicals are often a cause of sensitivity. During the whitening process with PAP+, there is no damage or erosion to the enamel, meaning the outer layers of the tooth remain intact and can continue to protect the nerves whilst being effectively whitened. Individual experiences may vary."
              }
            ]
          },
          {
            "title": "How and when should I use PAP+ Strips?",
            "content": [
              {
                "body": "Dry teeth thoroughly before use. Peel off the long strip and apply sticky side to top teeth. Press strip down firmly and fold over back of teeth to secure. Repeat for short strip on bottom teeth. Allow 30 minutes for whitening treatment. Remove strips and rinse mouth with water. Use PAP+ Strips as often as needed."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "head": "Phthalimidoperoxycaproic Acid (PAP)",
                "body": "A scientifically proven teeth whitening ingredient that is a safe alternative to peroxide. PAP has no negative side effects during the oxidation of tooth stains, which allows it to effectively whiten without pain or sensitivity."
              },
              {
                "head": "Full ingredients list",
                "body": "Glycerin, Aqua/Water, PVP, Ethylcellulose, Alcohol, Sodium Polyacrylate, Phthalimidoperoxycaproic Acid (PAP), Xylitol, Potassium Citrate, Hydroxyapatite, Rebaudioside A, Menthol, Sodium Citrate, Xanthan Gum, PVM/MA Copolymer, C12-15 Pareth-3."
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "Ready, set, smile!",
                      "description": "Each satchet comes with two strips, for your top and bottom teeth. Firmly apply a strip to both your upper & lower teeth. After 30 minutes, gently remove both strips from your teeth and say hello to a whiter & brighter smile."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/01-BTF_-_PAP_Whitneing_Strips_-_PP.jpg?v=1703138413",
                      "height": 560,
                      "width": 560
                    }
                  },
                  {
                    "content": {
                      "title": "Say goodbye to post-strip sensitivity.",
                      "description": "Our PAP+ formula has been designed to reduce the likelihood of sensitivity!"
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02-BTF_-_PAP_Whitneing_Strips_-_PP.jpg?v=1703138412",
                      "height": 560,
                      "width": 560
                    }
                  }
                ]
              }
            }
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "What’s the difference between the VIO405™ Teeth Whitening Kit and PAP+ Strips?",
              "content": [
                {
                  "body": "The VIO405 Teeth Whitening Kit offers a higher percentage of PAP, Hydroxyapatite, and Potassium Citrate for greater results with the addition of an LED Light activator. The PAP+ Strips are a clean and convenient on-the-go whitening solution for whitening wherever you are.\n            "
                }
              ]
            },
            {
              "title": "How does the PAP+ formula whiten?",
              "content": [
                {
                  "body": "When PAP+ whitens, it oxidises tooth stains without releasing molecules known as free radicals. These radicals are what can cause sensitivity for some people. \n            <br><br>\n            During the whitening process with PAP+, there is no damage or erosion to the enamel, meaning the outer layers of the tooth remain intact and can continue to protect the nerves whilst being effectively whitened.\n            <br><br>\n            The PAP+ whitening process targets a wide variety of tooth stains internally and externally. Based on our PAP+ formula, we've designed our PAP+ Pen as a gradual whitening product to use daily, or to touch up your whitening on the go.\n            "
                }
              ]
            },
            {
              "title": "How long does it take to see results from the PAP+ Strips?",
              "content": [
                {
                  "body": "The PAP+ Strips offer a 30 minute, clean residue-free whitening treatment. Whitening results vary, but can be seen after just one use of the PAP+ Strips."
                }
              ]
            },
            {
              "title": "Can Hismile be used with veneers, caps, implants, bridges, or bonded teeth?",
              "content": [
                {
                  "body": "Veneers, caps, implants, bonding or bridges aren’t designed to be whitened and require special care from your dentist. The PAP+ whitening formula works to oxidise stains from natural teeth, however, it may be helpful at keeping your surrounding teeth the same shade as the ones that have had dental work.\n            <br><br>\n            We always advise checking with your dentist before using, to ensure it is a suitable product for you.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "10060-VS@v34-whitening-strips",
    {
      "attributes": {
        "sku": "10060-VS",
        "productHandle": "v34-whitening-strips",
        "categoryDetails": {
          "primaryCategory": "v34-whitening-strips"
        },
        "age": 6
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_01_-_V34_Strips_no-badge_31_10_15.jpg?v=1769052226",
              "height": 512,
              "width": 352,
              "alt": "Best Selling V34 Whitening Strips"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_02_-_V34_Strips_e0285166-6b3f-4728-ab16-321fad14795b.png?v=1769052241",
              "height": 512,
              "width": 352,
              "alt": "In a study, 96% of participants had 2 or more shades whiter teeth*"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_03_-_V34_Strips_-_updated_22_10_25.png?v=1769052255",
              "height": 512,
              "width": 352,
              "alt": "Top teeth results"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_04_-_V34_Strips_-_updated_22_10_25.png?v=1769052262",
              "height": 512,
              "width": 352,
              "alt": "Amazon reviews"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_05_-_V34_Strips_-_updated_22_10_25.png?v=1769052285",
              "height": 414,
              "width": 656,
              "alt": "Before. Apply. After. Strips"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "styleTags": [
          "alt-bulletpoints",
          "selling-fast-pill",
          "blue-atc-button"
        ],
        "productOptionSelector": [
          {
            "sku": "10060-VS5"
          }
        ],
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/money-icon.png?v=1755142733",
              "height": 30,
              "width": 20
            },
            "text": "Money back<br>guarantee"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/application-icon.png?v=1755142734",
              "height": 30,
              "width": 20
            },
            "text": "$2.79 per<br> application"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Tooth.png?v=1750650505",
              "height": 30,
              "width": 20
            },
            "text": "Experts in whitening"
          }
        ],
        "description": {
          "title": "Whiter teeth after just one use.",
          "body": "",
          "bulletpoints": [
            "Whiter Teeth after <strong style=\"font-weight: 500\">Just One Use*</strong>",
            "Not Satisfied? <strong style=\"font-weight: 500\">Get Your Money Back^</strong>",
            "Whitening After <strong style=\"font-weight: 500\">30-minutes*</strong>"
          ]
        },
        "productAccordions": [
          {
            "title": "How do V34 Strips work",
            "content": [
              {
                "body": "This innovative dual-active technology is unlike your supermarket whitening products, it combines V34’s instant colour correction which delivers a temporary visual improvement with PAP+ whitening to target surface stains for visible results.<br><br>Includes 14 individual applications."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Glycerin, Aqua/Water, Cellulose Gum, Hydroxypropyl Methylcellulose, Phthalimidoperoxycaproic Acid, Disodium EDTA, Sodium Hydroxide, Menthol, Monosodium Citrate, Xanthan Gum, PVM/MA Copolymer, C12-15 Pareth-3, D&C Red No. 33 (CI 17200), FD&C Blue No. 1 (CI 42090)."
              }
            ]
          },
          {
            "title": "^Money Back Guarantee",
            "content": [
              {
                "body": "Hismile is offering a Money Back Guarantee for the V34 Whitening Strips. We’re confident you’ll love the product, but if you're not satisfied, we're offering a refund of the purchase price (excluding shipping), subject to the terms and conditions.<br><br>This offer applies only to purchases made via www.hismileteeth.com. Return requests must be submitted within seven (7) days of receiving your order. Customers are responsible for return shipping costs. This offer is in addition to any rights under applicable consumer protection laws.<br><br>Full terms & conditions, including instructions on how to claim, can be found <a style=\"text-decoration: underline\" href='/pages/terms-conditions'>here</a>."
              }
            ]
          },
          {
            "title": "*Tested for results",
            "content": [
              {
                "body": "\n                Hismile’s V34 Whitening Strips were tested in a blinded placebo controlled clinical study of 60 participants tested immediately and 24 hours after a 30-minute application. After application, all participants had 2 or more shades improvement. At 24 hours, 96% of participants had 2 or more shades improvement. Assessments were based on a VITA Bleachguide 3D-MASTER® assessment. \n                "
              },
              {
                "body": "\n                Results are not guaranteed for all individuals, and individual results may vary. Immediate results are temporary and whitening is not permanent.\n                "
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How many shades different should I see?",
              "content": [
                {
                  "body": "Results vary, some see a visible difference after one use being the temporary colour correction effects"
                }
              ]
            },
            {
              "title": "How do I use them?",
              "content": [
                {
                  "body": "Start by thoroughly drying your teeth. Apply the long V34 Strip to your upper teeth, pressing firmly for a secure fit. Repeat with short strip on bottom teeth. Leave strips on for 30 minutes to allow the dual-active formula to work. Remove strips and brush in any remaining purple residue and rinse if needed."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "10060-VS5@buy-two-get-three-free-v34-strips",
    {
      "attributes": {
        "sku": "10060-VS5",
        "productHandle": "buy-two-get-three-free-v34-strips",
        "categoryDetails": {
          "primaryCategory": "bulk-product"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_01_-_B2G3_-_CCWS.png?v=1789961628",
              "height": 512,
              "width": 352,
              "alt": "Best Selling V34 Whitening Strips"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_02_-_V34_Strips_e0285166-6b3f-4728-ab16-321fad14795b.png?v=1769052241",
              "height": 512,
              "width": 352,
              "alt": "In a study, 96% of participants had 2 or more shades whiter teeth*"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_03_-_V34_Strips_-_updated_22_10_25.png?v=1769052255",
              "height": 512,
              "width": 352,
              "alt": "Top teeth results"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_04_-_V34_Strips_-_updated_22_10_25.png?v=1769052262",
              "height": 512,
              "width": 352,
              "alt": "Amazon reviews"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_05_-_V34_Strips_-_updated_22_10_25.png?v=1769052285",
              "height": 414,
              "width": 656,
              "alt": "Before. Apply. After. Strips"
            }
          ]
        }
      },
      "content": {
        "disclaimer": "†Value based on full price of 5 boxes purchased separately.",
        "styleTags": [
          "show-value",
          "compare-dagger",
          "hide-badge",
          "alt-bulletpoints",
          "blue-atc-button"
        ],
        "valuePrice": [
          {
            "sku": "10060-VS",
            "quantity": 5
          }
        ],
        "productOptionSelectorDetails": {
          "productQuantity": 5,
          "productType": {
            "single": "box",
            "singleText": "1-month supply*",
            "plural": "boxes",
            "pluralText": "5-month supply*",
            "showIcons": true,
            "freeProducts": 3
          },
          "dealMessage": "Buy 2, get 3 free",
          "productTerms": "*Based on 1 box containing 14 applications, used once every 2 days, providing up to 30 days’ supply.",
          "showValuePrice": true,
          "valuePriceLabel": "Bundle valued at",
          "showPercentageOff": true
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/money-icon.png?v=1755142733",
              "height": 30,
              "width": 20
            },
            "text": "Money back<br>guarantee"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/application-icon.png?v=1755142734",
              "height": 30,
              "width": 20
            },
            "text": "$2.79 per<br> application"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Tooth.png?v=1750650505",
              "height": 30,
              "width": 20
            },
            "text": "Experts in whitening"
          }
        ],
        "description": {
          "title": "Whiter teeth after just one use.",
          "body": "Not after a value pack? You can buy a single pack of strips at full price <a href=\"/products/v34-whitening-strips\" style=\"text-decoration: underline;\">here</a>.",
          "bulletpoints": [
            "Whiter Teeth after <strong style=\"font-weight: 500\">Just One Use*</strong>",
            "Not Satisfied? <strong style=\"font-weight: 500\">Get Your Money Back^</strong>",
            "Whitening After <strong style=\"font-weight: 500\">30-minutes*</strong>"
          ]
        },
        "productAccordions": [
          {
            "title": "How do V34 Strips work",
            "content": [
              {
                "body": "This innovative dual-active technology is unlike your supermarket whitening products, it combines V34’s instant colour correction which delivers a temporary visual improvement with PAP+ whitening to target surface stains for visible results.<br><br>Includes 70 individual applications."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Glycerin, Aqua/Water, Cellulose Gum, Hydroxypropyl Methylcellulose, Phthalimidoperoxycaproic Acid, Disodium EDTA, Sodium Hydroxide, Menthol, Monosodium Citrate, Xanthan Gum, PVM/MA Copolymer, C12-15 Pareth-3, D&C Red No. 33 (CI 17200), FD&C Blue No. 1 (CI 42090)."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "5 x V34 Whitening Strips <br> Total Net Contents: 70 applications"
              }
            ]
          },
          {
            "title": "^Money Back Guarantee",
            "content": [
              {
                "body": "Hismile is offering a Money Back Guarantee for the V34 Whitening Strips. We’re confident you’ll love the product, but if you're not satisfied, we're offering a refund of the purchase price (excluding shipping), subject to the terms and conditions.<br><br>This offer applies only to purchases made via www.hismileteeth.com. Return requests must be submitted within seven (7) days of receiving your order. Customers are responsible for return shipping costs. This offer is in addition to any rights under applicable consumer protection laws.<br><br>Full terms & conditions, including instructions on how to claim, can be found <a style=\"text-decoration: underline\" href='/pages/terms-conditions'>here</a>."
              }
            ]
          },
          {
            "title": "*Tested for results",
            "content": [
              {
                "body": "Hismile’s V34 Whitening Strips were tested in a blinded placebo controlled clinical study of 60 participants tested immediately and 24 hours after a 30-minute application. After application, all participants had 2 or more shades improvement. At 24 hours, 96% of participants had 2 or more shades improvement. Assessments were based on a VITA Bleachguide 3D-MASTER® assessment."
              },
              {
                "body": "Results are not guaranteed for all individuals, and individual results may vary. Immediate results are temporary and whitening is not permanent."
              }
            ]
          }
        ]
      }
    }
  ],
  [
    "10065-TA@tooth-armour",
    {
      "attributes": {
        "sku": "10065-TA",
        "productHandle": "tooth-armour",
        "categoryDetails": {
          "primaryCategory": "tooth-armour"
        },
        "age": 10
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01-ToothArmour-PP_d1586a1f-3be8-411f-aba9-8aa1e2104f32.png?v=1774930437",
              "height": 512,
              "width": 352,
              "alt": "Tooth Armour Toothpaste Serum with Packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 512,
              "width": 352,
              "alt": "Visualisation of Tooth Armour Toothpaste Serum being applied to toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 512,
              "width": 352,
              "alt": "Microscopic Visualisation of Nano-Hydroxyapatite on teeth"
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/b7e01de4063d4e7cb868f4ea1225ff42.mp4",
              "height": 512,
              "width": 352,
              "alt": "Tooth Armour Toothpaste Serum video"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 414,
              "width": 656,
              "alt": "Key points about Tooth Armour Toothpaste Serum"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "styleTags": [
          "alt-bulletpoints"
        ],
        "productOptionSelector": [
          {
            "sku": "TOOTH_ARMOUR_BFGS"
          }
        ],
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Shield_Icon_d970d5d6-c449-40a3-81d3-ac30fc9a53d2.png?v=1774930587",
              "height": 45,
              "width": 30
            },
            "text": "Nano- <br>Hydroxyapatite",
            "customHeight": 45,
            "customWidth": 30
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Replace_Toothpaste_Icon_2.png?v=1774930580",
              "height": 45,
              "width": 30
            },
            "text": "Replace Your <br> Toothpaste",
            "customHeight": 45,
            "customWidth": 30
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/dna_emoji_png_6186eebf-e3f6-41b8-a69f-2a787d86b28b.png?v=1774934225",
              "height": 45,
              "width": 30
            },
            "text": "Supercharged <br> Vitamin Formula",
            "customHeight": 45,
            "customWidth": 30
          }
        ],
        "description": {
          "title": "White. Freshen. Rinse away the gunk.",
          "body": "<i>*Through mechanical action with regular brushing</i><br><br>\n      Tooth Armour elevates your oral care. Powered by NH-10, a concentrated blend of 6 actives including Nano-Hydroxyapatite, an ingredient engineered to mirror the mineral your enamel is mostly made of, together with Hydrated Silica, Xylitol, Hyaluronic Acid, Niacinamide (Vitamin B3) and Zinc Gluconate. Add Tooth Armour to your existing toothpaste or use it on its own. Either way, your routine just got a serious upgrade.",
          "bulletpoints": [
            "<strong>Powered with Nano-Hydroxyapatite</strong>, an ingredient engineered to mirror the mineral that makes up 97% of your enamel.",
            "<strong>6 actives.</strong> 1 serum.",
            "Helps maintain <strong>white teeth*</strong>"
          ]
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "Tooth Armour is a toothpaste serum, designed to be used as part of your daily brushing routine. Add to your regular toothpaste or use on its own. Brush for 2 minutes, then expel.<br><br>Use as directed as part of your oral care routine. Any benefits associated with Tooth Armour are derived from continued daily use, together with a good oral care routine."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, Glycerin, Hydrated Silica, Hydroxyapatite (nano), Xylitol, Sodium Hyaluronate, Niacinamide, Zinc Gluconate, Hydroxyethylcellulose, Silica, Caprylyl Glycol, 1,2-Hexanediol, Hydroxypropyl Methylcellulose, Potassium Chloride, Lauryl Glucoside, Flavour/Aroma, Sucralose, Carmine (CI 75470) , Menthol, Carvone, Mentha Piperita Oil, Anethole."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "1 x Tooth Armour Toothpaste Serum<br>Total Net Contents: 20 ml | 0.67 fl. oz."
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "The Upgrade Your Routine Wants",
                      "description": "A few drops directly to your brush, or layered over your regular toothpaste. Tooth Armour introduces advanced actives to your oral care routine - and it's never looked better for it."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_01_-_Tooth_Armour_6fff633b-4e8a-4e56-a2f7-e799007040a3.png?v=1774326787",
                      "height": 560,
                      "width": 560,
                      "alt": "Tooth Armour Toothpaste Serum"
                    }
                  },
                  {
                    "content": {
                      "title": "Advanced Enamel Support",
                      "description": "Tooth Armour includes Nano-Hydroxyapatite, an enamel-like mineral, mimicking a key component naturally found in your tooth's external structure."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_02_-_Tooth_Armour_51bfa066-2a18-4e2c-8e8d-bcb7987dd2f1.png?v=1774326788",
                      "height": 560,
                      "width": 560,
                      "alt": "Microscopic Visualisation of Nano-Hydroxyapatite on teeth"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "10065-TA5@tooth-armour-toothpaste-serum-5-pack",
    {
      "attributes": {
        "sku": "10065-TA5",
        "productHandle": "tooth-armour-toothpaste-serum-5-pack"
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "10068-PO@id-stain-mouthwash",
    {
      "attributes": {
        "sku": "10068-PO",
        "productHandle": "id-stain-mouthwash",
        "categoryDetails": {
          "primaryCategory": "id-stain-mouthwash"
        },
        "age": 7
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Stain_Mouthwash_-_Best_Seller_-_PP.png?v=1784759478",
              "height": 512,
              "width": 352,
              "alt": "iD Mouthwash bottle pictured, new product."
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Stain_Mouthwash_-_PP.png?v=1784864978",
              "height": 512,
              "width": 352,
              "alt": "New whitening mouthwash. Reveals buildup brushing may miss."
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04-Stain_Mouthwash-PP-20260127_86d7fc7b-1ef9-4c27-a4f7-207165db39c9.png?v=1771796961",
              "height": 512,
              "width": 352,
              "alt": "5 star Amazon review"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03-Stain_Mouthwash-PP_9e9530c6-4c66-4cb3-9caf-284f8796ff9d.jpg?v=1771983369",
              "height": 512,
              "width": 352,
              "alt": "Before and after image of mouthwash"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-05-Stain_Mouthwash_a18b98b9-8c9a-4dae-a069-bed46d0291a1.jpg?v=1771796961",
              "height": 414,
              "width": 656,
              "alt": "Model using mouthwash. Use as directed - results may variy, whitening results are not immediate, staff results"
            }
          ]
        },
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/mouthwashupsellimage.png?v=1776045233"
              }
            ]
          }
        }
      },
      "content": {
        "pill": {
          "variant": "information",
          "text": "Best Seller"
        },
        "styleTags": [
          "alt-bulletpoints"
        ],
        "productOptionSelector": [
          {
            "sku": "10068-PO8"
          }
        ],
        "textBelowProductTitle": "4.3 · 2,784 reviews on Amazon as at 22 September 2026",
        "belowTitleIcon": {
          "name": "five-stars",
          "props": {
            "color": "rgb(var(--dark-1))",
            "width": 13,
            "height": 13,
            "filled": 4
          }
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Detoxes_mouth.png?v=1765748912",
              "height": 30,
              "width": 20
            },
            "text": "Freshens <br> breath"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/application-icon.png?v=1755142734",
              "height": 30,
              "width": 20
            },
            "text": "Removes hidden gunk"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Tooth.png?v=1750650505",
              "height": 30,
              "width": 20
            },
            "text": "Helps maintain white teeth"
          }
        ],
        "description": {
          "title": "White. Freshen. Rinse away the gunk.",
          "body": "iD Stain Whitening Mouthwash targets the gunk your toothbrush left behind and pulls it into visible clumps you can actually see in the sink. Powered by hydrogen peroxide and essential oil actives, iD Stain helps maintain white teeth and leaves your mouth feeling seriously fresh from the first rinse.",
          "bulletpoints": [
            "Helps Maintain White Teeth",
            "Target gunk in the mouth",
            "Freshen breath at the source"
          ]
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "iD Stain is not your average mouthwash.<br><br>This oral rinse works with your routine to help maintain white teeth, freshen breath, and lift build-up from the areas brushing can miss. As you rinse, the formula interacts with oral debris, pulling them into visible particles you can actually see in the sink. That’s what your toothbrush didn’t catch.<br><br>Use as directed as part of your daily oral care routine. Visible residue is not guaranteed and depends on individual factors. Results may vary between individuals."
              }
            ]
          },
          {
            "title": "Our origin story",
            "content": [
              {
                "head": "Japanese-inspired. Reimagined for the Western world.",
                "body": "We took inspiration from Japan’s popular propolis-based rinses – a post-brushing swish loved for lifting the residue a toothbrush misses and revealing it right in the sink. That idea became our starting point, not our finish line. To make our formula 100% vegan, we removed the propolis and developed our own elevated blend instead, combining essential oil components for freshness, with hydrogen peroxide for whitening maintenance. The result? iD Stain Whitening Mouthwash – inspired by Japanese oral care, reimagined to target and reveal the gunk brushing leaves behind while helping maintain your white smile."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, PEG-40 Hydrogenated Castor Oil, Glycerin, Citric Acid, Sodium Benzoate, Sucralose, Menthol, Flavour/Aroma, Potassium Sorbate, Xylitol, Sodium Citrate, Eucalyptus Globulus Leaf Oil, Hydrogen Peroxide, Sodium Phytate, Thymol, Caramel, Methyl Salicylate."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "1 x iD Stain Whitening Mouthwash <br> Total Net Contents: 237 ml | 8 fl. oz."
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "What Brushing May Miss",
                      "description": "Stain iD Whitening Mouthwash lifts hidden debris from your mouth and shows it back to you. The opaque formula interacts with oral debris, forming visible particles when you spit the mouthwash out. It’s instant proof of what brushing can miss."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_01_-_Stain_Mouthwash.jpg?v=1765345193",
                      "height": 560,
                      "width": 560,
                      "alt": "Trapped impurities"
                    }
                  },
                  {
                    "content": {
                      "title": "Fresh Breath, Whitening Formula",
                      "description": "The formula lifts hidden debris so your mouth feels lighter, cleaner and noticeably fresher. Tongue, cheeks and gum line feel genuinely refreshed. Charged with hydrogen peroxide to help maintain your white smile."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_02_-_Stain_Mouthwash.jpg?v=1765345288",
                      "height": 560,
                      "width": 560,
                      "alt": "Stain ID Whitening Mouthwash"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "10068-PO8-landing@buy-three-get-five-mouthwash-landing",
    {
      "attributes": {
        "sku": "10068-PO8-landing",
        "productHandle": "buy-three-get-five-mouthwash-landing",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_01_-_Mouthwash_Value_Set_19ec4e40-ff31-4c0b-9977-e657675d2528.png?v=1789683594",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Stain_Mouthwash_-_PP.png?v=1784864978",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04-Stain_Mouthwash-PP-20260127_86d7fc7b-1ef9-4c27-a4f7-207165db39c9.png?v=1771796961",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03-Stain_Mouthwash-PP_9e9530c6-4c66-4cb3-9caf-284f8796ff9d.jpg?v=1771983369",
              "height": 512,
              "width": 352
            }
          ]
        }
      },
      "content": {
        "disclaimer": "*Value based on full price of 8 Mouthwashes purchased separately.",
        "styleTags": [
          "show-value",
          "hide-badge"
        ],
        "valuePrice": [
          {
            "sku": "10068-PO",
            "quantity": 8
          }
        ],
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Detoxes_mouth.png?v=1765748912",
              "height": 30,
              "width": 20
            },
            "text": "Freshens <br> breath"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/application-icon.png?v=1755142734",
              "height": 30,
              "width": 20
            },
            "text": "Removes hidden gunk"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Tooth.png?v=1750650505",
              "height": 30,
              "width": 20
            },
            "text": "Helps maintain white teeth"
          }
        ],
        "description": {
          "title": "GET MORE MOUTHWASH FREE THAN YOU ARE BUYING",
          "body": "iD Stain Whitening Mouthwash targets the gunk your toothbrush left behind and pulls it into visible clumps you can actually see in the sink. Powered by hydrogen peroxide and essential oil actives, iD Stain helps maintain white teeth and leaves your mouth feeling seriously fresh from the first rinse.<br><br>Not after a value pack? You can buy a single mouthwash at full price  <a href=\"/products/id-stain-mouthwash\" style=\"text-decoration: underline;\">here</a>.",
          "bulletpoints": [
            "Helps Maintain White Teeth",
            "Target gunk in the mouth",
            "Freshen breath at the source"
          ]
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "iD Stain is not your average mouthwash.<br><br>This oral rinse works with your routine to help maintain white teeth, freshen breath, and lift build-up from the areas brushing can miss. As you rinse, the formula interacts with oral debris, pulling them into visible particles you can actually see in the sink. That’s what your toothbrush didn’t catch.<br><br>Use as directed as part of your daily oral care routine. Visible residue is not guaranteed and depends on individual factors. Results may vary between individuals."
              }
            ]
          },
          {
            "title": "Our origin story",
            "content": [
              {
                "head": "Japanese-inspired. Reimagined for the Western world.",
                "body": "We took inspiration from Japan’s popular propolis-based rinses – a post-brushing swish loved for lifting the residue a toothbrush misses and revealing it right in the sink. That idea became our starting point, not our finish line. To make our formula 100% vegan, we removed the propolis and developed our own elevated blend instead, combining essential oil components for freshness, with hydrogen peroxide for whitening maintenance. The result? iD Stain Whitening Mouthwash – inspired by Japanese oral care, reimagined to target and reveal the gunk brushing leaves behind while helping maintain your white smile."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, PEG-40 Hydrogenated Castor Oil, Glycerin, Citric Acid, Sodium Benzoate, Sucralose, Menthol, Flavour/Aroma, Potassium Sorbate, Xylitol, Sodium Citrate, Eucalyptus Globulus Leaf Oil, Hydrogen Peroxide, Sodium Phytate, Thymol, Caramel, Methyl Salicylate."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "8 x iD Stain Whitening Mouthwash <br> Total Net Contents: 237 ml | 8 fl. oz."
              }
            ]
          }
        ]
      }
    }
  ],
  [
    "10068-PO8@buy-three-get-five-mouthwash",
    {
      "attributes": {
        "sku": "10068-PO8",
        "productHandle": "buy-three-get-five-mouthwash",
        "categoryDetails": {
          "primaryCategory": "bulk-product"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_01_-_Mouthwash_Value_Set_19ec4e40-ff31-4c0b-9977-e657675d2528.png?v=1789683594",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Stain_Mouthwash_-_PP.png?v=1784864978",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04-Stain_Mouthwash-PP-20260127_86d7fc7b-1ef9-4c27-a4f7-207165db39c9.png?v=1771796961",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03-Stain_Mouthwash-PP_9e9530c6-4c66-4cb3-9caf-284f8796ff9d.jpg?v=1771983369",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-05-Stain_Mouthwash_a18b98b9-8c9a-4dae-a069-bed46d0291a1.jpg?v=1771796961",
              "height": 414,
              "width": 656
            }
          ]
        }
      },
      "content": {
        "disclaimer": "*Value based on full price of 8 Mouthwashes purchased separately.",
        "styleTags": [
          "show-value",
          "hide-badge"
        ],
        "valuePrice": [
          {
            "sku": "10068-PO",
            "quantity": 8
          }
        ],
        "productOptionSelectorDetails": {
          "productQuantity": 8,
          "productType": {
            "single": "bottle",
            "singleText": "6-week supply*",
            "plural": "bottles",
            "pluralText": "12-month supply*",
            "showIcons": true,
            "freeProducts": 5
          },
          "dealMessage": "Buy 3, get 5 free",
          "productTerms": "*Based on 1 x 237mL bottle at 5mL once per day as directed, providing 45+ days’ supply.",
          "showValuePrice": true,
          "valuePriceLabel": "Bundle valued at",
          "showPercentageOff": true,
          "adDefault": true
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Detoxes_mouth.png?v=1765748912",
              "height": 30,
              "width": 20
            },
            "text": "Freshens <br> breath"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/application-icon.png?v=1755142734",
              "height": 30,
              "width": 20
            },
            "text": "Removes hidden gunk"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Tooth.png?v=1750650505",
              "height": 30,
              "width": 20
            },
            "text": "Helps maintain white teeth"
          }
        ],
        "description": {
          "title": "GET MORE MOUTHWASH FREE THAN YOU ARE BUYING",
          "body": "iD Stain Whitening Mouthwash targets the gunk your toothbrush left behind and pulls it into visible clumps you can actually see in the sink. Powered by hydrogen peroxide and essential oil actives, iD Stain helps maintain white teeth and leaves your mouth feeling seriously fresh from the first rinse.<br><br>Not after a value pack? You can buy a single mouthwash at full price  <a href=\"/products/id-stain-mouthwash\" style=\"text-decoration: underline;\">here</a>.",
          "bulletpoints": [
            "Helps Maintain White Teeth",
            "Target gunk in the mouth",
            "Freshen breath at the source"
          ]
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "iD Stain is not your average mouthwash.<br><br>This oral rinse works with your routine to help maintain white teeth, freshen breath, and lift build-up from the areas brushing can miss. As you rinse, the formula interacts with oral debris, pulling them into visible particles you can actually see in the sink. That’s what your toothbrush didn’t catch.<br><br>Use as directed as part of your daily oral care routine. Visible residue is not guaranteed and depends on individual factors. Results may vary between individuals."
              }
            ]
          },
          {
            "title": "Our origin story",
            "content": [
              {
                "head": "Japanese-inspired. Reimagined for the Western world.",
                "body": "We took inspiration from Japan’s popular propolis-based rinses – a post-brushing swish loved for lifting the residue a toothbrush misses and revealing it right in the sink. That idea became our starting point, not our finish line. To make our formula 100% vegan, we removed the propolis and developed our own elevated blend instead, combining essential oil components for freshness, with hydrogen peroxide for whitening maintenance. The result? iD Stain Whitening Mouthwash – inspired by Japanese oral care, reimagined to target and reveal the gunk brushing leaves behind while helping maintain your white smile."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, PEG-40 Hydrogenated Castor Oil, Glycerin, Citric Acid, Sodium Benzoate, Sucralose, Menthol, Flavour/Aroma, Potassium Sorbate, Xylitol, Sodium Citrate, Eucalyptus Globulus Leaf Oil, Hydrogen Peroxide, Sodium Phytate, Thymol, Caramel, Methyl Salicylate."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "8 x iD Stain Whitening Mouthwash <br> Total Net Contents: 237 ml | 8 fl. oz."
              }
            ]
          }
        ]
      }
    }
  ],
  [
    "10069-TW@exfoliating-tooth-wipes",
    {
      "attributes": {
        "sku": "10069-TW",
        "productHandle": "exfoliating-tooth-wipes",
        "categoryDetails": {
          "primaryCategory": "tooth-wipes"
        },
        "age": 12
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Tooth_Wipes_-_PP.png?v=1779940429",
              "height": 512,
              "width": 352,
              "alt": "Exfoliating tooth wipes"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_Tooth_Wipes_-_PP.png?v=1779940429",
              "height": 512,
              "width": 352,
              "alt": "Tooth wipe on finger"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_Tooth_Wipes_-_PP.png?v=1779940429",
              "height": 512,
              "width": 352,
              "alt": "Zoom in on tooth and tooth wipe"
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/c8ea21fa50ac45d186fd9afbf3d6a973.mp4",
              "height": 512,
              "width": 352,
              "alt": "Tooth wipe demonstration video"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_Tooth_Wipes_-_PP_14283ca8.png?v=1780525424",
              "height": 414,
              "width": 656,
              "alt": "Key points about tooth wipes"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "productOptionSelector": [
          {
            "sku": "10069-TW15"
          }
        ],
        "productImageBadge": {
          "position": "bottom-left",
          "media": "global"
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Hydroxyapatite_Icon_ef9bc6d9-dcf0-4a68-ac6b-b7973dbd103e.png?v=1779940436",
              "height": 30,
              "width": 20
            },
            "text": "Infused with<br>Hydroxyapatite"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Sprinter_icon_82a6cfa4-2d66-4710-9fca-f29b91d7ff51.png?v=1779940436",
              "height": 30,
              "width": 20
            },
            "text": "Brushing<br>On-The-Go"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Plane_Icon_1e26336e-bcc7-4bf3-b0c5-2dc5254de2f4.png?v=1779940436",
              "height": 30,
              "width": 20
            },
            "text": "Travel<br>Friendly"
          }
        ],
        "pill": {
          "variant": "information",
          "text": "NEW"
        },
        "description": {
          "title": "Exfoliating Tooth Wipes",
          "body": "\n      <ul>\n      <li>Engineered to physically lift the day's build-up off your teeth</li>\n      <li>Infused with hydroxyapatite and xylitol for that freshly-brushed feeling in the middle of your day</li> \n      <li>Designed to support your tooth surface in one easy wipe</li>\n      </ul>\n      Introducing Tooth Wipes, the convenient brush that allows you to wipe in the time where it actually matters - the 12 to 14 hours between regular brushing of untouched food build-up that can stain - that occurs to the surface layer of your teeth.<br><br>\n      That is what Tooth Wipes are built for. A wipe with an engineered textured surface that is designed to help to physically lift the surface build-up off your teeth. Wipe away the surface plaque. A similar mechanical action to brushing. No water. No paste. No sink.<br><br>\n      Infused with hydroxyapatite and xylitol, our Tooth Wipes are made to complement your everyday oral care routine. Easy to use anytime, anywhere, they leave your mouth feeling fresh and clean.<br><br>\n      Slide Tooth Wipes on your finger and wipe away stains before they set.",
          "bulletpoints": []
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "Tooth Wipes are designed to be used alongside your everyday oral care routine. Add to your daily regimen to assist with maintaining a healthy smile.<br><br>\n            Use as directed as part of your oral care routine. Any benefits associated with Tooth Wipes are derived from continued daily use, together with a good oral care routine.<br><br>\n            <i>Not designed to replace your toothbrush.</i>\n            "
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, Polysorbate 20, Xylitol, Pentasodium Triphosphate, Hydroxyapatite, Sodium Bicarbonate, Calcium Carbonate, Flavour/Aroma, Sodium Chloride, Caprylyl Glycol, Gluconolactone, Sucralose, Menthol, Hydroxyacetophenone, Citric Acid, Sodium Citrate, Anethole, Camphor, Carvone, Mentha Piperita Oil, Pinene."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "1 x 14pk Tooth Wipes<br>\n            Total Net Contents: 14 applications"
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "Wipe away the day's stains",
                      "description": "Use in between meals, after your morning coffee - our Tooth Wipes are designed with convenience in mind. Designed to help keep your teeth clean when it matters."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/BTF_-_01_-_Tooth_Wipes.png?v=1779940430",
                      "height": 560,
                      "width": 560,
                      "alt": "Tooth Armour Toothpaste Serum"
                    }
                  },
                  {
                    "content": {
                      "title": "Ingredients that matter",
                      "description": "Infused with hydroxyapatite and xylitol, our Tooth Wipes are designed to freshen your mouth and support your daily oral care routine. Compact and convenient, they're the perfect addition for freshness on the go."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/BTF_-_02_-_Tooth_Wipes.png?v=1779940429",
                      "height": 560,
                      "width": 560,
                      "alt": "Microscopic Visualisation of Nano-Hydroxyapatite on teeth"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "10069-TW15@buy-six-tooth-wipes-get-nine-free",
    {
      "attributes": {
        "sku": "10069-TW15",
        "productHandle": "buy-six-tooth-wipes-get-nine-free",
        "categoryDetails": {
          "primaryCategory": "bulk-product"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_01_-_B6G9_-_TW.png?v=1789961756",
              "height": 512,
              "width": 352,
              "alt": "Exfoliating tooth wipes"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_Tooth_Wipes_-_PP.png?v=1779940429",
              "height": 512,
              "width": 352,
              "alt": "Tooth wipe on finger"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_Tooth_Wipes_-_PP.png?v=1779940429",
              "height": 512,
              "width": 352,
              "alt": "Zoom in on tooth and tooth wipe"
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/c8ea21fa50ac45d186fd9afbf3d6a973.mp4",
              "height": 512,
              "width": 352,
              "alt": "Tooth wipe demonstration video"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_Tooth_Wipes_-_PP_14283ca8.png?v=1780525424",
              "height": 414,
              "width": 656,
              "alt": "Key points about tooth wipes"
            }
          ]
        }
      },
      "content": {
        "disclaimer": "*Value based on full price of 15 packets purchased separately.",
        "styleTags": [
          "show-value",
          "hide-badge"
        ],
        "valuePrice": [
          {
            "sku": "10069-TW",
            "quantity": 15
          }
        ],
        "productOptionSelectorDetails": {
          "productQuantity": 15,
          "productType": {
            "single": "packet",
            "singleText": "Up to 2-week supply*",
            "plural": "packets",
            "pluralText": "Up to 6+ month supply*",
            "showIcons": true,
            "freeProducts": 9
          },
          "dealMessage": "Buy 6, get 9 free",
          "productTerms": "*Based on 1 x 14-pack, providing up to 2 weeks’ supply when used as needed. Supply duration may vary depending on frequency of use.",
          "showValuePrice": true,
          "valuePriceLabel": "Bundle valued at",
          "showPercentageOff": true
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Hydroxyapatite_Icon_ef9bc6d9-dcf0-4a68-ac6b-b7973dbd103e.png?v=1779940436",
              "height": 30,
              "width": 20
            },
            "text": "Infused with<br>Hydroxyapatite"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Sprinter_icon_82a6cfa4-2d66-4710-9fca-f29b91d7ff51.png?v=1779940436",
              "height": 30,
              "width": 20
            },
            "text": "Brushing<br>On-The-Go"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Plane_Icon_1e26336e-bcc7-4bf3-b0c5-2dc5254de2f4.png?v=1779940436",
              "height": 30,
              "width": 20
            },
            "text": "Travel<br>Friendly"
          }
        ],
        "description": {
          "title": "Exfoliating Tooth Wipes",
          "body": "\n      <ul>\n      <li>Engineered to physically lift the day's build-up off your teeth</li>\n      <li>Infused with hydroxyapatite and xylitol for that freshly-brushed feeling in the middle of your day</li>\n      <li>Designed to support your tooth surface in one easy wipe</li>\n      </ul>\n      Introducing Tooth Wipes, the convenient brush that allows you to wipe in the time where it actually matters - the 12 to 14 hours between regular brushing of untouched food build-up that can stain - that occurs to the surface layer of your teeth.<br><br>\n      That is what Tooth Wipes are built for. A wipe with an engineered textured surface that is designed to help to physically lift the surface build-up off your teeth. Wipe away the surface plaque. A similar mechanical action to brushing. No water. No paste. No sink.<br><br>\n      Infused with hydroxyapatite and xylitol, our Tooth Wipes are made to complement your everyday oral care routine. Easy to use anytime, anywhere, they leave your mouth feeling fresh and clean.<br><br>\n      Slide Tooth Wipes on your finger and wipe away stains before they set.<br><br>\n      Not after a value pack? You can buy a single pack of Tooth Wipes at full price <a href=\"/products/exfoliating-tooth-wipes\" style=\"text-decoration: underline;\">here</a>.",
          "bulletpoints": []
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "Tooth Wipes are designed to be used alongside your everyday oral care routine. Add to your daily regimen to assist with maintaining a healthy smile.<br><br>\n            Use as directed as part of your oral care routine. Any benefits associated with Tooth Wipes are derived from continued daily use, together with a good oral care routine.<br><br>\n            <i>Not designed to replace your toothbrush.</i>\n            "
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, Polysorbate 20, Xylitol, Pentasodium Triphosphate, Hydroxyapatite, Sodium Bicarbonate, Calcium Carbonate, Flavour/Aroma, Sodium Chloride, Caprylyl Glycol, Gluconolactone, Sucralose, Menthol, Hydroxyacetophenone, Citric Acid, Sodium Citrate, Anethole, Camphor, Carvone, Mentha Piperita Oil, Pinene."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "15 x 14pk Tooth Wipes<br>\n            Total Net Contents: 210 applications"
              }
            ]
          }
        ]
      }
    }
  ],
  [
    "41001-ET-PI@pink-electric-toothbrush",
    {
      "attributes": {
        "sku": "41001-ET-PI",
        "productHandle": "pink-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "pink"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_Value_Pack_-_Pink_-_Upsell_Image_-_D.png?v=1785976245"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/2024-05-31_-_ETB_Pink_-_PP.png?v=1717113815",
              "height": 512,
              "width": 352,
              "alt": "Pink Electric Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Pink_-_PP.png?v=1716943929",
              "height": 512,
              "width": 352,
              "alt": "Pink Electric Toothbrush with packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_03_-_ETB_ETB_Head_Base.png?v=1721259858",
              "height": 512,
              "width": 352,
              "alt": "Model smiling"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/04_-_ETB_Pink_-_PP_0bf27ce6-7826-429c-98d0-6d24d805e3e6.png?v=1716943930",
              "height": 512,
              "width": 352,
              "alt": "Model smiling with hismile pink electric toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/05_-_ETB_Pink_-_PP.png?v=1716943929",
              "height": 414,
              "width": 656,
              "alt": "Hismile toothpaste being applied to pink electric toothrush"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Pink-selector-electric-toothbrush.png?v=1704927884",
            "height": 100,
            "width": 100,
            "alt": "Pink selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Brushing never looked this good.",
          "body": "Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41002-ET-HP@bright-pink-electric-toothbrush",
    {
      "attributes": {
        "sku": "41002-ET-HP",
        "productHandle": "bright-pink-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "bright-pink"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_Value_Pack_-_Bright_Pink_-_Upsell_Image_-_D.png?v=1785976245"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/2024-05-31_-_ETB_Bright_Pink_-_PP.png?v=1717113815",
              "height": 512,
              "width": 352,
              "alt": "Bright Pink Electric Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Bright_Pink_-_PP_99f43a81-457f-40b7-95fe-d88584128c79.jpg?v=1716943929",
              "height": 512,
              "width": 352,
              "alt": "Bright Pink Electric Toothbrush with packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Heads_Green_-_PP.jpg?v=1716935131",
              "height": 512,
              "width": 352,
              "alt": "Model smiling"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/04_-_ETB_Bright_Pink_-_PP_a159a033-61c3-4673-857d-6bec52ffda47.jpg?v=1716943929",
              "height": 512,
              "width": 352,
              "alt": "Model smiling with hismile bright pink electric toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/05_-_ETB_Bright_Pink_-_PP.jpg?v=1716943929",
              "height": 414,
              "width": 656,
              "alt": "Hismile toothpaste being applied to bright pink electric toothrush"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/bright_pink_selector.png?v=1716522594",
            "height": 100,
            "width": 100,
            "alt": "Bright Pink selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Brushing never looked this good.",
          "body": "Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-media",
            "location": "section-below-the-fold",
            "props": {
              "images": {
                "default": [
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/01_-_ETB_Bright_Pink_-_BTF_a0698c93-52ba-4c72-b0b3-bb95be08ac7b.jpg?v=1716943930",
                      "height": 600,
                      "width": 414,
                      "alt": "Bright Pink hismile Electric Toothbrush with packaging"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/01_-_ETB_Bright_Pink_-_BTF_a0698c93-52ba-4c72-b0b3-bb95be08ac7b.jpg?v=1716943930",
                      "height": 1000,
                      "width": 712,
                      "alt": "Bright Pink hismile Electric Toothbrush with packaging"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Bright_Pink_-_BTF_b68b093f-86b3-4dd7-99ff-067f4f766dc3.jpg?v=1716943930",
                      "height": 600,
                      "width": 414,
                      "alt": "Model with Bright Pink Electric Toothbrush"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Bright_Pink_-_BTF_b68b093f-86b3-4dd7-99ff-067f4f766dc3.jpg?v=1716943930",
                      "height": 1000,
                      "width": 712,
                      "alt": "Model with Bright Pink Electric Toothbrush"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/03_-_ETB_Bright_Pink_-_BTF_0c9ef31b-48d1-4182-aed4-d262dcdadab4.jpg?v=1716943930",
                      "height": 600,
                      "width": 414,
                      "alt": "Watermelon toothpaste being put onto the Bright Pink Electric Toothbrush"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/03_-_ETB_Bright_Pink_-_BTF_0c9ef31b-48d1-4182-aed4-d262dcdadab4.jpg?v=1716943930",
                      "height": 1000,
                      "width": 1440,
                      "alt": "Watermelon toothpaste being put onto the Bright Pink Electric Toothbrush"
                    }
                  }
                ]
              }
            }
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41003-ET-GR@green-electric-toothbrush",
    {
      "attributes": {
        "sku": "41003-ET-GR",
        "productHandle": "green-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "green"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_Value_Pack_-_Green_-_Upsell_Image_-_D.png?v=1785976245"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/2024-05-31_-_ETB_Green_-_PP.png?v=1717113815",
              "alt": "Green Electric Toothbrush",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Green_-_PP_e78b16e9-34b8-412f-a5e7-5df7913a2728.jpg?v=1716943928",
              "alt": "Green Electric Toothbrush out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Heads_Green_-_PP.jpg?v=1716935131",
              "alt": "Woman smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/04_-_ETB_Green_-_PP_2735014c-d79b-47c1-b149-4ace71ace250.jpg?v=1716943929",
              "alt": "Woman brushing teeth with Green Electric Toothbrush",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/05_-_ETB_Green_-_PP_5323232c-05e6-47fd-848c-3e16668ba40e.jpg?v=1716943928",
              "alt": "Toothpaste being pumped onto Green Electric Toothbrush",
              "height": 414,
              "width": 656
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-selector-electric-toothbrush.png?v=1704927884",
            "height": 100,
            "width": 100,
            "alt": "Green selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Brushing never looked this good.",
          "body": "Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41004-ET-PU@purple-electric-toothbrush",
    {
      "attributes": {
        "sku": "41004-ET-PU",
        "productHandle": "purple-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "purple"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_VALUE_PACK_PURPLE.png?v=1785127093"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/2024-05-31_-_ETB_Purple_-_PP.png?v=1717113815",
              "height": 512,
              "width": 352,
              "alt": "Purple Electric Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Purple_-_PP_8f9a3cb2-68ff-4dbc-8b9b-da274255a86c.jpg?v=1716943928",
              "height": 512,
              "width": 352,
              "alt": "Purple Electric Toothbrush with packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Heads_Green_-_PP.jpg?v=1716935131",
              "height": 512,
              "width": 352,
              "alt": "Model smiling"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/04_-_ETB_Purple_-_PP_50f0c251-2f77-442d-8694-4aebfe7c0a7a.jpg?v=1716943929",
              "height": 512,
              "width": 352,
              "alt": "Model smiling with hismile purple electric toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/05_-_ETB_Purple_-_PP_9b5aa638-80c4-4880-b84d-04722fa7fd4d.jpg?v=1716943929",
              "height": 414,
              "width": 656,
              "alt": "Hismile toothpaste being applied to purple electric toothrush"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Purple-selector-electric-toothbrush.png?v=1704927884",
            "height": 100,
            "width": 100,
            "alt": "Purple selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Brushing never looked this good.",
          "body": "Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-media",
            "location": "section-below-the-fold",
            "props": {
              "images": {
                "default": [
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/01_-_ETB_Purple_-_BTF_5f8643b6-e0d5-4b71-9b3c-8abed89a712e.jpg?v=1716943929",
                      "height": 600,
                      "width": 414,
                      "alt": "Purple hismile Electric Toothbrush with packaging"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/01_-_ETB_Purple_-_BTF_5f8643b6-e0d5-4b71-9b3c-8abed89a712e.jpg?v=1716943929",
                      "height": 1000,
                      "width": 712,
                      "alt": "Purple hismile Electric Toothbrush with packaging"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Purple_-_BTF_608859eb-dec7-477c-a0ba-44900f533f47.jpg?v=1716943930",
                      "height": 600,
                      "width": 414,
                      "alt": "Model with Purple Electric Toothbrush"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Purple_-_BTF_608859eb-dec7-477c-a0ba-44900f533f47.jpg?v=1716943930",
                      "height": 1000,
                      "width": 712,
                      "alt": "Model with Purple Electric Toothbrush"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/03_-_ETB_Purple_-_BTF_c8f0230b-9d10-4268-8cca-119ea567cd5c.jpg?v=1716943930",
                      "height": 600,
                      "width": 414,
                      "alt": "Grape Bubblegum toothpaste being put onto the Purple Electric Toothbrush"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/03_-_ETB_Purple_-_BTF_c8f0230b-9d10-4268-8cca-119ea567cd5c.jpg?v=1716943930",
                      "height": 1000,
                      "width": 1440,
                      "alt": "Grape Bubblegum toothpaste being put onto the Purple Electric Toothbrush"
                    }
                  }
                ]
              }
            }
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41008-ET-OR@bright-red-electric-toothbrush",
    {
      "attributes": {
        "sku": "41008-ET-OR",
        "productHandle": "bright-red-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "bright-red"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_Value_Pack_-_Bright_Red_-_Upsell_Image_-_D.png?v=1785976245"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETBBrightRed-Single-Collections_3393a481-4b81-4b4f-8acc-dbede6f7a578.png?v=1777518448",
              "height": 512,
              "width": 352,
              "alt": "Bright Red Electric Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/01_-_ETB_Bright_Red_-_BTF_e77938d9-84a7-4d56-9a61-025ce7c511cf.jpg?v=1716943930",
              "height": 512,
              "width": 352,
              "alt": "Bright Red Electric Toothbrush with packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Heads_Green_-_PP.jpg?v=1716935131",
              "height": 512,
              "width": 352,
              "alt": "Model smiling"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Bright_Red_-_BTF_86d835e2-6c4e-485e-9060-fa5a5a6b6fc2.jpg?v=1716943930",
              "height": 512,
              "width": 352,
              "alt": "Model smiling with hismile bright red electric toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/03_-_ETB_Bright_Red_-_BTF_2467be71-eb2c-4953-8fcb-70d9b0f08272.jpg?v=1716943930",
              "height": 414,
              "width": 656,
              "alt": "Hismile toothpaste being applied to bright red electric toothrush"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/bright_red_selector.png?v=1716522594",
            "height": 100,
            "width": 100,
            "alt": "Bright Red selector image"
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Brushing never looked this good.",
          "body": "Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-media",
            "location": "section-below-the-fold",
            "props": {
              "images": {
                "default": [
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/01_-_ETB_Bright_Red_-_BTF_e77938d9-84a7-4d56-9a61-025ce7c511cf.jpg?v=1716943930",
                      "height": 600,
                      "width": 414,
                      "alt": "Bright Pink hismile Electric Toothbrush with packaging"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/01_-_ETB_Bright_Red_-_BTF_e77938d9-84a7-4d56-9a61-025ce7c511cf.jpg?v=1716943930",
                      "height": 1000,
                      "width": 712,
                      "alt": "Bright Pink hismile Electric Toothbrush with packaging"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Bright_Red_-_BTF_86d835e2-6c4e-485e-9060-fa5a5a6b6fc2.jpg?v=1716943930",
                      "height": 600,
                      "width": 414,
                      "alt": "Model with Bright Pink Electric Toothbrush"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Bright_Red_-_BTF_86d835e2-6c4e-485e-9060-fa5a5a6b6fc2.jpg?v=1716943930",
                      "height": 1000,
                      "width": 712,
                      "alt": "Model with Bright Pink Electric Toothbrush"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/03_-_ETB_Bright_Red_-_BTF_2467be71-eb2c-4953-8fcb-70d9b0f08272.jpg?v=1716943930",
                      "height": 600,
                      "width": 414,
                      "alt": "Watermelon toothpaste being put onto the Bright Pink Electric Toothbrush"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/03_-_ETB_Bright_Red_-_BTF_2467be71-eb2c-4953-8fcb-70d9b0f08272.jpg?v=1716943930",
                      "height": 1000,
                      "width": 1440,
                      "alt": "Watermelon toothpaste being put onto the Bright Pink Electric Toothbrush"
                    }
                  }
                ]
              }
            }
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41009-ET-YE@yellow-electric-toothbrush",
    {
      "attributes": {
        "sku": "41009-ET-YE",
        "productHandle": "yellow-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "yellow"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_Value_Pack_-_Yellow_-_Upsell_Image_-_D.png?v=1785976246"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/2024-05-31_-_ETB_Yellow_-_PP.png?v=1717113815",
              "height": 512,
              "width": 352,
              "alt": "Yellow Electric Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Yellow_-_PP.jpg?v=1716943928",
              "height": 512,
              "width": 352,
              "alt": "Yellow Electric Toothbrush with packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_03_-_ETB_ETB_Head_Base.png?v=1721259858",
              "height": 512,
              "width": 352,
              "alt": "Model smiling"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/04_-_ETB_Yellow_-_PP.jpg?v=1716943929",
              "height": 512,
              "width": 352,
              "alt": "Model smiling with hismile yellow electric toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/05_-_ETB_Yellow_-_PP.jpg?v=1716943929",
              "height": 414,
              "width": 656,
              "alt": "Hismile toothpaste being applied to yellow electric toothrush"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/yellow_selector.png?v=1716522594",
            "height": 100,
            "width": 100,
            "alt": "Yellow selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Brushing never looked this good.",
          "body": "Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41010-ET-GG@bright-green-electric-toothbrush",
    {
      "attributes": {
        "sku": "41010-ET-GG",
        "productHandle": "bright-green-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "bright-green"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_Value_Pack_-_Bright_Green_-_Upsell_Image_-_D.png?v=1785976246"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/2024-05-31_-_ETB_Bright_Green_-_PP.png?v=1717113815",
              "height": 512,
              "width": 352,
              "alt": "Bright Green Electric Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Bright_Green_-_PP_d5216406-26f9-46e3-9fb4-3eeaedf03f4b.jpg?v=1716943928",
              "height": 512,
              "width": 352,
              "alt": "Bright Green Electric Toothbrush with packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_03_-_ETB_ETB_Head_Base.png?v=1721259858",
              "height": 512,
              "width": 352,
              "alt": "Model smiling"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/04_-_ETB_Bright_Pink_-_PP_1.jpg?v=1716943929",
              "height": 512,
              "width": 352,
              "alt": "Model smiling with hismile bright green electric toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/05_-_ETB_Bright_Pink_-_PP_1.jpg?v=1716943929",
              "height": 414,
              "width": 656,
              "alt": "Hismile toothpaste being applied to bright green electric toothrush"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/bright_green_selector.png?v=1716522594",
            "height": 100,
            "width": 100,
            "alt": "Bright Green selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Brushing never looked this good.",
          "body": "Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41011-ET-EB@bright-blue-electric-toothbrush",
    {
      "attributes": {
        "sku": "41011-ET-EB",
        "productHandle": "bright-blue-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "bright-blue"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_Value_Pack_-_Bright_Blue_-_Upsell_Image_-_D.png?v=1785976257"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/2024-05-31_-_ETB_Bright_Blue_-_PP.png?v=1717113815",
              "height": 512,
              "width": 352,
              "alt": "Bright Blue Electric Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Bright_Blue_-_PP_bfe93b3f-e029-4dec-a6ec-ec313c2967b5.jpg?v=1716943928",
              "height": 512,
              "width": 352,
              "alt": "Bright Blue Electric Toothbrush with packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_03_-_ETB_ETB_Head_Base.png?v=1721259858",
              "height": 512,
              "width": 352,
              "alt": "Model smiling"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/04_-_ETB_Bright_Blue_-_PP_da58e595-8c57-416a-98e7-e25ef947a459.jpg?v=1716943929",
              "height": 512,
              "width": 352,
              "alt": "Model smiling with hismile bright blue electric toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/05_-_ETB_Bright_Blue_-_PP_0294634e-d307-45b7-acbd-026b0c2e83c6.jpg?v=1716943929",
              "height": 414,
              "width": 656,
              "alt": "Hismile toothpaste being applied to bright blue electric toothrush"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/bright_blue_selector.png?v=1716522594",
            "height": 100,
            "width": 100,
            "alt": "Bright Blue selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Brushing never looked this good.",
          "body": "Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41013-RH-OR@replacement-heads-bright-red",
    {
      "attributes": {
        "sku": "41013-RH-OR",
        "productHandle": "replacement-heads-bright-red",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "bright-red"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_ETB_Heads_Bright_Red_-_PP.png?v=1716938608",
              "alt": "Bright Red Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_ETB_Heads_Bright_Red_-_PP.jpg?v=1716938607",
              "alt": "Bright Red Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Head_Bright_Pink_-_PP.jpg?v=1716934563",
              "alt": "Model smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04_-_ETB_Heads_Bright_Red_-_PP.jpg?v=1716938608",
              "alt": "Woman holding Electric Toothbrbush with Bright Red Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_ETB_Heads_Bright_Red_-_PP.jpg?v=1716938608",
              "alt": "Watermelon toothpaste being pumped onto Bright Red Toothbrush Head",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/bright_red_selector.jpg?v=1716878131",
            "height": 100,
            "width": 100,
            "alt": "Bright red selector image"
          }
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack Bright Red Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41014-RH-YE@yellow-replacement-heads",
    {
      "attributes": {
        "sku": "41014-RH-YE",
        "productHandle": "yellow-replacement-heads",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "yellow"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_ETB_Heads_Yellow_-_PP_47219d4e-d512-471c-8b45-23dca716e1e4.png?v=1716936899",
              "alt": "Yellow Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_ETB_Heads_Yellow_-_PP_086fe6a5-acfc-416b-9e9b-c2a16ba1852b.jpg?v=1716936898",
              "alt": "Yellow Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Head_Electric_Lime_-_PP.jpg?v=1716934107",
              "alt": "Model smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04_-_ETB_Heads_Yellow_-_PP_41bd6de9-3252-43bb-93a4-4db2949f36ef.jpg?v=1716936899",
              "alt": "Woman holding Electric Toothbrbush with Yellow Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Heads_Yellow_-_BTF.jpg?v=1716936899",
              "alt": "Watermelon toothpaste being pumped onto Yellow Toothbrush Head",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/yellow_selector.jpg?v=1716878131",
            "height": 100,
            "width": 100,
            "alt": "Yellow selector image"
          }
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A style for every smile.",
            "content": [
              {
                "body": "Time for you to replace your <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">toothbrush</a> head? Want to mix and match to brighten your brushing routine? We’ve got you covered with a style for every smile."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack Yellow Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41015-RH-GG@replacement-heads-bright-green",
    {
      "attributes": {
        "sku": "41015-RH-GG",
        "productHandle": "replacement-heads-bright-green",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "bright-green"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_ETB_Heads_Bright_Green_-_PP.png?v=1716938284",
              "alt": "Bright Green Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_ETB_Heads_Bright_Green_-_BTF.jpg?v=1716938284",
              "alt": "Bright Green Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Head_Bright_Pink_-_PP.jpg?v=1716934563",
              "alt": "Model smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04_-_ETB_Heads_Bright_Green_-_PP.jpg?v=1716938284",
              "alt": "Woman holding Electric Toothbrbush with Bright Green Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_ETB_Heads_Bright_Green_-_PP.jpg?v=1716938284",
              "alt": "Watermelon toothpaste being pumped onto Bright Green Toothbrush Head",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/bright_green_selector_3ed2aba1-b03f-4d27-b48c-ca418ea84b70.jpg?v=1716878131",
            "height": 100,
            "width": 100,
            "alt": "Purple selector image"
          }
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack Bright Green Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41016-BP-EB@replacement-heads-bright-blue",
    {
      "attributes": {
        "sku": "41016-BP-EB",
        "productHandle": "replacement-heads-bright-blue",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "bright-blue"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_ETB_Heads_Bright_Blue_-_PP.png?v=1716937939",
              "alt": "Bright Blue Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_ETB_Heads_Bright_Blue_-_PP.jpg?v=1716937939",
              "alt": "Bright Blue Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Head_Bright_Pink_-_PP.jpg?v=1716934563",
              "alt": "Model smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04_-_ETB_Heads_Bright_Blue_-_PP.jpg?v=1716937939",
              "alt": "Woman holding Electric Toothbrbush with Bright Blue Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_ETB_Heads_Bright_Blue_-_PP.jpg?v=1716937939",
              "alt": "Watermelon toothpaste being pumped onto Bright Blue Toothbrush Head",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/bright_blue_selector_6cafd312-6017-42eb-9375-34fe43aa911a.jpg?v=1716878130",
            "height": 100,
            "width": 100,
            "alt": "Purple selector image"
          }
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack Bright Blue Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41016-RH-EB@replacement-heads-bright-blue",
    {
      "attributes": {
        "sku": "41016-RH-EB",
        "productHandle": "replacement-heads-bright-blue",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "bright-blue"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_ETB_Heads_Bright_Blue_-_PP.png?v=1716937939",
              "alt": "Bright Blue Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_ETB_Heads_Bright_Blue_-_PP.jpg?v=1716937939",
              "alt": "Bright Blue Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Head_Bright_Pink_-_PP.jpg?v=1716934563",
              "alt": "Model smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04_-_ETB_Heads_Bright_Blue_-_PP.jpg?v=1716937939",
              "alt": "Woman holding Electric Toothbrbush with Bright Blue Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_ETB_Heads_Bright_Blue_-_PP.jpg?v=1716937939",
              "alt": "Watermelon toothpaste being pumped onto Bright Blue Toothbrush Head",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/bright_blue_selector_6cafd312-6017-42eb-9375-34fe43aa911a.jpg?v=1716878130",
            "height": 100,
            "width": 100,
            "alt": "Purple selector image"
          }
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack Bright Blue Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41017-ET-CR@cream-electric-toothbrush",
    {
      "attributes": {
        "sku": "41017-ET-CR",
        "productHandle": "cream-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "cream"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_Value_Pack_-_Cream_-_Upsell_Image_-_D.png?v=1785976244"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/2024-05-31_-_ETB_Cream_-_PP.png?v=1717113815",
              "height": 512,
              "width": 352,
              "alt": "Cream Electric Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Cream_-_PP_d29eb4bc-6c41-4006-8b6f-d5d39e26b0a6.jpg?v=1716943929",
              "height": 512,
              "width": 352,
              "alt": "Cream Electric Toothbrush with packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_03_-_ETB_ETB_Head_Base.png?v=1721259858",
              "height": 512,
              "width": 352,
              "alt": "Model smiling"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/04_-_ETB_Cream_-_PP_b0b847ce-4596-4cac-a59e-0d6ba960bd0c.jpg?v=1716943929",
              "height": 512,
              "width": 352,
              "alt": "Model smiling with hismile cream electric toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/05_-_ETB_Cream_-_PP_db6be433-0da1-4909-ae7d-412ce384d046.jpg?v=1716943928",
              "height": 414,
              "width": 656,
              "alt": "Hismile toothpaste being applied to cream electric toothrush"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/cream_selector.png?v=1716522594",
            "height": 100,
            "width": 100,
            "alt": "Cream selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Brushing never looked this good.",
          "body": "Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41018-ET-BB@barbie-electric-toothbrush",
    {
      "attributes": {
        "sku": "41018-ET-BB",
        "productHandle": "barbie-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "barbie"
        },
        "productTags": [
          "variant-family-electric-toothbrush"
        ]
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_Value_Pack_-_Barbie_Pink_-_Upsell_Image_-_D.png?v=1785976245"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB-BarbiePink-Single-Collections_2007d9c2-b9a5-4776-9bea-3af340744970.png?v=1777518733",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/ETB_-_BTF_-_01_-_ETB_Barbie_Pink.png?v=1720071363",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Heads_Green_-_PP.jpg?v=1716935131",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/ETB_-_BTF_-_02_-_ETB_Barbie_Pink.png?v=1720071365",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/ETB_-_BTF_-_03_-_ETB_Barbie_Pink.png?v=1720071365",
              "height": 414,
              "width": 656
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/ETB_-_Barbie_Selector.png?v=1720071360",
            "height": 100,
            "width": 100,
            "alt": "Barbie selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Brushing never looked this good.",
          "body": "Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ],
          "customBlurb": {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/MAT21BG_LOGO_TM_01.png?v=1719980056",
              "height": 40,
              "width": 40,
              "alt": "©2024 Mattel.",
              "customWidth": "3rem"
            },
            "text": "©2024 Mattel."
          }
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-media",
            "location": "section-below-the-fold",
            "props": {
              "images": {
                "default": [
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/ETB_-_BTF_-_01_-_ETB_Barbie_Pink.png?v=1720071363",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie Pink hismile Electric Toothbrush with packaging"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/ETB_-_BTF_-_01_-_ETB_Barbie_Pink.png?v=1720071363",
                      "height": 1000,
                      "width": 712,
                      "alt": "Barbie Pink hismile Electric Toothbrush with packaging"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/ETB_-_BTF_-_02_-_ETB_Barbie_Pink.png?v=1720071365",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/ETB_-_BTF_-_02_-_ETB_Barbie_Pink.png?v=1720071365",
                      "height": 1000,
                      "width": 712,
                      "alt": "Barbie"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/ETB_-_BTF_-_03_-_ETB_Barbie_Pink.png?v=1720071365",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie Pink Bubblegum Toothpaste being put onto the Barbie Pink Electric Toothbrush"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/ETB_-_BTF_-_03_-_ETB_Barbie_Pink.png?v=1720071365",
                      "height": 1000,
                      "width": 1440,
                      "alt": "Barbie Pink Bubblegum Toothpaste being put onto the Barbie Pink Electric Toothbrush"
                    }
                  }
                ]
              }
            }
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41022-ET-KP@khaki-pink-electric-toothbrush",
    {
      "attributes": {
        "sku": "41022-ET-KP",
        "productHandle": "khaki-pink-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "khaki-pink"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_Value_Pack_-_Kahaki_Pink_-_Upsell_Image_-_D.png?v=1785976244"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/01_-_ETB_Khaki_Pink_-_PP.png?v=1718755134",
              "height": 512,
              "width": 352,
              "alt": "Khaki Pink Electric Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Khaki_Pink_-_PP.jpg?v=1718755134",
              "height": 512,
              "width": 352,
              "alt": "Khaki Pink Electric Toothbrush with packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_03_-_ETB_ETB_Head_Base.png?v=1721259858",
              "height": 512,
              "width": 352,
              "alt": "Model smiling"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/04_-_ETB_Head_Khaki_Pink_-_PP.jpg?v=1718755134",
              "height": 512,
              "width": 352,
              "alt": "Model smiling with hismile khaki pink electric toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/05_-_ETB_Head_Khaki_Pink_-_PP.jpg?v=1718755134",
              "height": 414,
              "width": 656,
              "alt": "Hismile toothpaste being applied to khaki pink electric toothrush"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/khaki_pink_selector.jpg?v=1718760337",
            "height": 100,
            "width": 100,
            "alt": "Khaki Pink selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Brushing never looked this good.",
          "body": "Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41023-ET-BL@black-electric-toothbrush",
    {
      "attributes": {
        "sku": "41023-ET-BL",
        "productHandle": "black-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "black"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_VALUE_PACK_BLACK.png?v=1785127096"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/01_-_ETB_Black_-_PP.png?v=1717566233",
              "height": 512,
              "width": 352,
              "alt": "Black Electric Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/02_-_ETB_Black_-_PP.jpg?v=1717566233",
              "height": 512,
              "width": 352,
              "alt": "Black Electric Toothbrush with packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_03_-_ETB_ETB_Head_Base.png?v=1721259858",
              "height": 512,
              "width": 352,
              "alt": "Model smiling"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/04_-_ETB_Black_-_PP.jpg?v=1717566233",
              "height": 512,
              "width": 352,
              "alt": "Model smiling with hismile black electric toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/05_-_ETB_Head_Black_-_PP.jpg?v=1717566234",
              "height": 414,
              "width": 656,
              "alt": "Hismile toothpaste being applied to black electric toothrush"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/black_selector_540fd1b0-407e-4b2a-857e-4f73ba3e522e.png?v=1717733456",
            "height": 100,
            "width": 100,
            "alt": "Black selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Brushing never looked this good.",
          "body": "Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41024-BP-PI@replacement-heads-pink",
    {
      "attributes": {
        "sku": "41024-BP-PI",
        "productHandle": "replacement-heads-pink",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "pink"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_ETB_Head_Pink_-_PP.png?v=1716866939",
              "alt": "Pink Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_ETB_Head_Pink_-_PP.jpg?v=1716866938",
              "alt": "Pink Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Head_Pink_-_PP.jpg?v=1716866938",
              "alt": "Model smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04_-_ETB_Head_Pink_-_PP.jpg?v=1716866938",
              "alt": "Woman holding Electric Toothbrbush with Pink Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_ETB_Head_Pink_-_PP.jpg?v=1716866938",
              "alt": "Watermelon toothpaste being pumped onto Pink Toothbrush Head",
              "height": 352,
              "width": 560
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/pink_selector_5442f1f7-82ce-4420-b2c7-3fe12de0be9c.jpg?v=1716878130",
            "height": 100,
            "width": 100,
            "alt": "Pink selector image"
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack Pink Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41024-ET-BM@stone-marble-electric-toothbrush",
    {
      "attributes": {
        "sku": "41024-ET-BM",
        "productHandle": "stone-marble-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "stone-marble"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_Value_Pack_-_Stone_Marble_-_Upsell_Image_-_D.png?v=1785976244"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_01_-_ETB_Stone_Marble.png?v=1721257793",
              "height": 512,
              "width": 352,
              "alt": "Stone Marble Electric Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_02_-_ETB_Stone_Marble.png?v=1721341973",
              "height": 512,
              "width": 352,
              "alt": "Stone Marble Electric Toothbrush with packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_03_-_ETB_ETB_Head_Base.png?v=1721259858",
              "height": 512,
              "width": 352,
              "alt": "Model smiling"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_04_-_ETB_Stone_Marble.png?v=1721257794",
              "height": 512,
              "width": 352,
              "alt": "Model smiling with hismile stone marble electric toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_05_-_ETB_Stone_Marble.png?v=1721257793",
              "height": 414,
              "width": 656,
              "alt": "Hismile toothpaste being applied to stone marble electric toothrush"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Selector_Stone-Marble.png?v=1721257792",
            "height": 100,
            "width": 100,
            "alt": "Stone Marble selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Brushing never looked this good.",
          "body": "Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41024-RH-PI@replacement-heads-pink",
    {
      "attributes": {
        "sku": "41024-RH-PI",
        "productHandle": "replacement-heads-pink",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "pink"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_ETB_Head_Pink_-_PP.png?v=1716866939",
              "alt": "Pink Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_ETB_Head_Pink_-_PP.jpg?v=1716866938",
              "alt": "Pink Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Head_Pink_-_PP.jpg?v=1716866938",
              "alt": "Model smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04_-_ETB_Head_Pink_-_PP.jpg?v=1716866938",
              "alt": "Woman holding Electric Toothbrbush with Pink Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_ETB_Head_Pink_-_PP.jpg?v=1716866938",
              "alt": "Watermelon toothpaste being pumped onto Pink Toothbrush Head",
              "height": 352,
              "width": 560
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/pink_selector_5442f1f7-82ce-4420-b2c7-3fe12de0be9c.jpg?v=1716878130",
            "height": 100,
            "width": 100,
            "alt": "Pink selector image"
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack Pink Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41025-BP-GR@replacement-heads-green",
    {
      "attributes": {
        "sku": "41025-BP-GR",
        "productHandle": "replacement-heads-green",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "green"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_ETB_Heads_Green_-_PP.png?v=1716935131",
              "alt": "Green Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_ETB_Heads_Green_-_PP.jpg?v=1716935131",
              "alt": "Green Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Heads_Green_-_PP.jpg?v=1716935131",
              "alt": "Model smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04_-_ETB_Heads_Green_-_PP.jpg?v=1716935131",
              "alt": "Woman holding Electric Toothbrbush with Green Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_ETB_Heads_Green_-_PP.jpg?v=1716935131",
              "alt": "Watermelon toothpaste being pumped onto Green Toothbrush Head",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/green_selector_e35f6925-50bc-43c9-b7b2-0aadffee2d23.jpg?v=1716878130",
            "height": 100,
            "width": 100,
            "alt": "Green selector image"
          }
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack Green Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41025-RH-GR@replacement-heads-green",
    {
      "attributes": {
        "sku": "41025-RH-GR",
        "productHandle": "replacement-heads-green",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "green"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_ETB_Heads_Green_-_PP.png?v=1716935131",
              "alt": "Green Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_ETB_Heads_Green_-_PP.jpg?v=1716935131",
              "alt": "Green Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Heads_Green_-_PP.jpg?v=1716935131",
              "alt": "Model smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04_-_ETB_Heads_Green_-_PP.jpg?v=1716935131",
              "alt": "Woman holding Electric Toothbrbush with Green Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_ETB_Heads_Green_-_PP.jpg?v=1716935131",
              "alt": "Watermelon toothpaste being pumped onto Green Toothbrush Head",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/green_selector_e35f6925-50bc-43c9-b7b2-0aadffee2d23.jpg?v=1716878130",
            "height": 100,
            "width": 100,
            "alt": "Green selector image"
          }
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack Green Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41026-BP-PU@replacement-heads-purple",
    {
      "attributes": {
        "sku": "41026-BP-PU",
        "productHandle": "replacement-heads-purple",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "purple"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_ETB_Heads_Purple_-_PP.png?v=1716934911",
              "alt": "Purple Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_ETB_Heads_Purple_-_PP.jpg?v=1716934910",
              "alt": "Purple Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Heads_Purple_-_PP.jpg?v=1716934910",
              "alt": "Model smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04_-_ETB_Heads_Purple_-_PP.jpg?v=1716934910",
              "alt": "Woman holding Electric Toothbrbush with Purple Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_ETB_Heads_Purple_-_PP.jpg?v=1716934910",
              "alt": "Watermelon toothpaste being pumped onto Purple Toothbrush Head",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/purple_selector_8c341f82-5a13-4eef-b8c9-e2548dc523f8.jpg?v=1716878130",
            "height": 100,
            "width": 100,
            "alt": "Purple selector image"
          }
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack Purple Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41026-ET-SO@the-simpsons-electric-toothbrush",
    {
      "attributes": {
        "sku": "41026-ET-SO",
        "productHandle": "the-simpsons-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "the-simpsons"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_Value_Pack_-_Simpsons_-_Upsell_Image_-_D.png?v=1785976245"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_01_-_ETB_Simpsons.png?v=1739144302",
              "alt": "The Simpsons Electric Toothbrush",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_02_-_ETB_Simpsons.png?v=1739144302",
              "alt": "The Simpsons Electric Toothbrush out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_03_-_ETB_Simpsons.png?v=1739144302",
              "alt": "The Simpsons Electric Toothbrush out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_04_-_ETB_Simpsons.png?v=1739144302",
              "alt": "The Simpsons Electric Toothbrush",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_05_-_ETB_Simpsons.png?v=1739144303",
              "alt": "The Simpson Purple Squishee Toothpaste being pumped onto The Simpsons Electric Toothbrush",
              "height": 414,
              "width": 656
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Selector_ETB_Simpsons.png?v=1739144302",
            "height": 100,
            "width": 100,
            "alt": "The Simpsons selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Brush the Simpsons Way",
          "body": "Styled in classic Simpsons yellow, this electric toothbrush is not just iconic but packs a punch with three dynamic cleaning modes, soft-tapered bristles, and a built-in timer. It’s the perfect mix of fun and function for the ultimate smile!",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ],
          "customBlurb": {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/simpsons_disclaimer_black.png?v=1758073791",
              "height": 45,
              "width": 192,
              "alt": "The Simpsons disclaimer"
            }
          }
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What's included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41026-RH-PU@replacement-heads-purple",
    {
      "attributes": {
        "sku": "41026-RH-PU",
        "productHandle": "replacement-heads-purple",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "purple"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_ETB_Heads_Purple_-_PP.png?v=1716934911",
              "alt": "Purple Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_ETB_Heads_Purple_-_PP.jpg?v=1716934910",
              "alt": "Purple Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Heads_Purple_-_PP.jpg?v=1716934910",
              "alt": "Model smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04_-_ETB_Heads_Purple_-_PP.jpg?v=1716934910",
              "alt": "Woman holding Electric Toothbrbush with Purple Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_ETB_Heads_Purple_-_PP.jpg?v=1716934910",
              "alt": "Watermelon toothpaste being pumped onto Purple Toothbrush Head",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/purple_selector_8c341f82-5a13-4eef-b8c9-e2548dc523f8.jpg?v=1716878130",
            "height": 100,
            "width": 100,
            "alt": "Purple selector image"
          }
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack Purple Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41027-ET-MI@miffy-electric-toothbrush",
    {
      "attributes": {
        "sku": "41027-ET-MI",
        "productHandle": "miffy-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "miffy"
        },
        "productTags": [
          "variant-family-electric-toothbrush"
        ]
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "41027-RH-CR@replacement-heads-cream",
    {
      "attributes": {
        "sku": "41027-RH-CR",
        "productHandle": "replacement-heads-cream",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "cream"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_ETB_Heads_Cream_-_PP_cd75aba5-c212-40f3-9325-423d1c0e9b59.png?v=1716935916",
              "alt": "Cream Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_ETB_Heads_Cream_-_PP_1303c8ba-a40c-4573-8732-5a0fe90d3f50.jpg?v=1716935915",
              "alt": "Cream Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Head_Electric_Lime_-_PP.jpg?v=1716934107",
              "alt": "Model smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04_-_ETB_Heads_Cream_-_PP_8be64d30-2350-409c-8759-5b5d8c827b89.jpg?v=1716935916",
              "alt": "Woman holding Electric Toothbrbush with Cream Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_ETB_Heads_Cream_-_PP_cf7f76bb-b563-4636-9e25-df4a0d11ff0c.jpg?v=1716935916",
              "alt": "Watermelon toothpaste being pumped onto Cream Toothbrush Head",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/cream_selector_c8d684ce-7840-458d-8161-bde5706d98c7.jpg?v=1716878130",
            "height": 100,
            "width": 100,
            "alt": "Cream selector image"
          }
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack Cream Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41028-BP-BB@replacement-heads-barbie",
    {
      "attributes": {
        "sku": "41028-BP-BB",
        "productHandle": "replacement-heads-barbie",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "barbie"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Head_Product_Page_-_PP_-_01_-_ETB_Head_Barbie_Pink.png?v=1720072153",
              "alt": "Barbie Electric Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Head_Product_Page_-_PP_-_02_-_ETB_Head_Barbie_Pink.png?v=1720072153",
              "alt": "Barbie Electric Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Head_Product_Page_-_PP_-_03_-_ETB_Head_Barbie_Pink.png?v=1720072153",
              "alt": "Barbie",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Head_Product_Page_-_PP_-_04_-_ETB_Barbie_Pink.png?v=1720072153",
              "alt": "Barbie Electric Toothbrush",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Head_Product_Page_-_PP_-_05_-_ETB_Head_Barbie_Pink.png?v=1720072154",
              "alt": "Hismile Toothpaste being applied onto Barbie Electric Toothbrush head",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/BAB_Selector_-_Barbie_selector.png?v=1720072205",
            "height": 100,
            "width": 100,
            "alt": "Barbie selector image"
          }
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ],
          "customBlurb": {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/MAT21BG_LOGO_TM_01.png?v=1719980056",
              "height": 40,
              "width": 40,
              "alt": "©2024 Mattel.",
              "customWidth": "3rem"
            },
            "text": "©2024 Mattel."
          }
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A style for every smile.",
            "content": [
              {
                "body": "Time for you to replace your <a href=\"/products/electric-toothbrush\">toothbrush</a> head? Want to mix and match to brighten your brushing routine? We’ve got you covered with a style for every smile."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack Barbie Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41028-RH-BB@replacement-heads-barbie",
    {
      "attributes": {
        "sku": "41028-RH-BB",
        "productHandle": "replacement-heads-barbie",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "barbie"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Head_Product_Page_-_PP_-_01_-_ETB_Head_Barbie_Pink.png?v=1720072153",
              "alt": "Barbie Electric Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Head_Product_Page_-_PP_-_02_-_ETB_Head_Barbie_Pink.png?v=1720072153",
              "alt": "Barbie Electric Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Head_Product_Page_-_PP_-_03_-_ETB_Head_Barbie_Pink.png?v=1720072153",
              "alt": "Barbie",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Head_Product_Page_-_PP_-_04_-_ETB_Barbie_Pink.png?v=1720072153",
              "alt": "Barbie Electric Toothbrush",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Head_Product_Page_-_PP_-_05_-_ETB_Head_Barbie_Pink.png?v=1720072154",
              "alt": "Hismile Toothpaste being applied onto Barbie Electric Toothbrush head",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/BAB_Selector_-_Barbie_selector.png?v=1720072205",
            "height": 100,
            "width": 100,
            "alt": "Barbie selector image"
          }
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ],
          "customBlurb": {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/MAT21BG_LOGO_TM_01.png?v=1719980056",
              "height": 40,
              "width": 40,
              "alt": "©2024 Mattel.",
              "customWidth": "3rem"
            },
            "text": "©2024 Mattel."
          }
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A style for every smile.",
            "content": [
              {
                "body": "Time for you to replace your <a href=\"/products/electric-toothbrush\">toothbrush</a> head? Want to mix and match to brighten your brushing routine? We’ve got you covered with a style for every smile."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack Barbie Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "41029-ET-MM@moss-marble-electric-toothbrush",
    {
      "attributes": {
        "sku": "41029-ET-MM",
        "productHandle": "moss-marble-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "moss-marble"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_Value_Pack_-_Moss_Marble_-_Upsell_Image_-_D.png?v=1785976245"
              }
            ]
          }
        },
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_01_-_ETB_Moss_Marble.png?v=1721257535",
              "height": 512,
              "width": 352,
              "alt": "Moss Marble Electric Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_02_-_ETB_Moss_Marble.png?v=1721341973",
              "height": 512,
              "width": 352,
              "alt": "Moss Marble Electric Toothbrush with packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_ETB_Heads_Green_-_PP.jpg?v=1716935131",
              "height": 512,
              "width": 352,
              "alt": "Model smiling"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_04_-_ETB_Moss_Marble.png?v=1721257536",
              "height": 512,
              "width": 352,
              "alt": "Model smiling with hismile Moss Marble electric toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_05_-_ETB_Moss_Marble.png?v=1721257536",
              "height": 414,
              "width": 656,
              "alt": "Hismile toothpaste being applied to moss marble electric toothrush"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Selector_Moss-Marble.png?v=1721257535",
            "height": 100,
            "width": 100,
            "alt": "Moss Marble selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Brushing never looked this good.",
          "body": "Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.",
          "bulletpoints": [
            "Three powerful cleaning modes",
            "Built-in timer for convenience",
            "Soft-tapered bristles for effective cleaning",
            "Mode memory to suit your brushing needs"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "3 intensity settings"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/special-features-charger-plug.png?v=1716869317",
              "height": 30,
              "width": 20
            },
            "text": "USB-C<br>Rechargeable"
          }
        ],
        "productAccordions": [
          {
            "title": "A powerful and effective clean.",
            "content": [
              {
                "body": "Whether you are after a Gentle, Intense or Everyday Clean, the Hismile Electric Toothbrush includes a combination of brushing settings to give you the most effective clean."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Electric Toothbrush\n                                <br>1x Toothbrush head\n                                <br>1x USB to USB-C charging cable"
              }
            ]
          },
          {
            "title": "Terms & Conditions",
            "content": [
              {
                "body": "We reserve the right to reject any personalised messages that are offensive, inappropriate, or violate our terms and conditions. The availability to personalise electric toothbrushes is limited. Available colours are also limited - check website for available colours. <br/><br/>Subject to relevant Consumer Protection Laws, personalised electric toothbrushes are exempt from our Change of Mind Policy, are non-refundable, and cannot be exchanged or returned. \n<br/><br/>See full terms & conditions <a style=\"text-decoration: underline\" href=\"/pages/terms-conditions#returns-policy\">here</a>."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br> \n\n            To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>\n\n            A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>\n\n            The toothbrush is designed with mode memory and will default to the last used setting on next use."
                }
              ]
            },
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothbrush is not suitable for 3 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "43037-BP-SO@the-simpsons-replacement-heads",
    {
      "attributes": {
        "sku": "43037-BP-SO",
        "productHandle": "the-simpsons-replacement-heads",
        "categoryDetails": {
          "primaryCategory": "replacement-heads",
          "type": "colour",
          "typeValue": "the-simpsons"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_01_-_ETB_Head_Simpsons.jpg?v=1739220859",
              "alt": "The Simpsons Electric Toothbrush Head",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_02_-_ETB_Head_Simpsons.jpg?v=1739220859",
              "alt": "The Simpsons Electric Toothbrush Head out of packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/PP_-_03_-_ETB_Head_Simpsons.jpg?v=1739220859",
              "alt": "The Simpson Purple Squishee Toothpaste being pumped onto The Simpsons Electric Toothbrush",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Selector_Head_Simpsons.png?v=1739753107",
            "height": 100,
            "width": 100,
            "alt": "The Simpsons selector image"
          }
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "description": {
          "title": "Mix and match your style.",
          "body": "",
          "bulletpoints": [
            "Soft-tapered bristles for effective cleaning",
            "Includes one coloured toothbrush head",
            "Compatible with Hismile 3 mode Electric Toothbrush - <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">here</a>"
          ],
          "customBlurb": {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/simpsons_disclaimer_black.png?v=1758073791",
              "height": 45,
              "width": 192,
              "alt": "The Simpsons disclaimer"
            }
          }
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/rainbow-special-features.png?v=1704941518",
              "height": 30,
              "width": 20
            },
            "text": "Fun<br> colours"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Green-puzzle-emoji-sspecial-features.png?v=1706146852",
              "height": 30,
              "width": 20
            },
            "text": "Mix &<br>match"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1686627944",
              "height": 30,
              "width": 20
            },
            "text": "Gentle &<br>effective"
          }
        ],
        "productAccordions": [
          {
            "title": "A style for every smile.",
            "content": [
              {
                "body": "Time for you to replace your <a href=\"/products/electric-toothbrush\" style=\"text-decoration: underline\">toothbrush</a> head? Want to mix and match to brighten your brushing routine? We’ve got you covered with a style for every smile."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 1 Pack The Simpsons Toothbrush Head"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How often do I need to replace the toothbrush head?",
              "content": [
                {
                  "body": "We recommend replacing the toothbrush head every 3 months, or when the head becomes worn, with a relevant, Hismile Toothbrush fitted head."
                }
              ]
            },
            {
              "title": "How do I use the Hismile Electric Toothbrush?",
              "content": [
                {
                  "body": "Charge the toothbrush prior to use. Wet toothbrush head and apply toothpaste, ensuring the toothbrush head is in contact with teeth before powering on the toothbrush.<br><br>To cycle through modes, press the power button until desired mode is selected. Brush for 2 minutes. <br><br>A short pause at 30-second intervals acts as a reminder to brush all 4 quadrants of the mouth equally. The toothbrush will power down after the recommended 2-minute brushing time. To turn the toothbrush off at any time, press and hold the mode button. <br><br>The toothbrush is designed with mode memory and will default to the last used setting on next use.\n            "
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "46001-BT-PI@pink-battery-electric-toothbrush",
    {
      "attributes": {
        "sku": "46001-BT-PI",
        "productHandle": "pink-battery-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "pink"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_01_-_BT_Pink.png?v=1752465190",
              "alt": "Pink Battery Electric Toothbrush",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_02_-_BT_Pink.png?v=1752465190",
              "alt": "Pink Battery Electric Toothbrush packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_03_-_BT_Pink.png?v=1752465191",
              "alt": "Model smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_04_-_BT_Pink.png?v=1752465191",
              "alt": "Pink battery electric toothbrush with X-1 Sonic Technology features on a pink background",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_05_-_BT_Pink.png?v=1752465190",
              "alt": "Pink Hismile Toothpaste being pumped onto the Pink Battery Electric Toothbrush",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Selector_BT_Pink.png?v=1752465190",
            "height": 100,
            "width": 100,
            "alt": "Pink Battery ETB selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Smart brushing, made simple",
          "body": "Combining three intelligent cleaning modes, the Hismile Battery Toothbrush gives you an effortless, effective clean, wherever you are.",
          "bulletpoints": [
            "Three smart brushing modes",
            "Built-in 2-minute timer",
            "A gentle, effective clean",
            "4-SYNC smart timer for guided brushing"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Easy_To_Use_Emoji_f1d29879-17e8-465f-b793-0a71b166ec60.png?v=1752792418",
              "height": 30,
              "width": 20
            },
            "text": "Easy to use"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Smart_Brushing_Modes_Emoji.png?v=1752715075",
              "height": 30,
              "width": 20
            },
            "text": "Smart brushing modes"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Guided_Clean_Emoji.png?v=1752715079",
              "height": 30,
              "width": 20
            },
            "text": "Guided clean"
          }
        ],
        "productAccordions": [
          {
            "title": "A custom clean, every time.",
            "content": [
              {
                "body": "Whether you prefer a Gentle, Intense or Everyday clean, the Hismile Battery Toothbrush features three tailored modes to suit your brushing needs. With X1 Sonic Technology, it gently cleans your teeth, elevating your daily routine. The built-in timer powers down after 2 minutes, and the 4-SYNC smart timer pauses every 30 seconds to help you move across each quadrant of your mouth, making sure no spot gets missed."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Battery Toothbrush Pink<br>1x Replaceable Toothbrush head<br>2x AAA Batteries (included)"
              }
            ]
          }
        ]
      }
    }
  ],
  [
    "46002-BT-PU@purple-battery-electric-toothbrush",
    {
      "attributes": {
        "sku": "46002-BT-PU",
        "productHandle": "purple-battery-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush",
          "type": "colour",
          "typeValue": "purple"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_01_-_BT_Purple.png?v=1752465708",
              "alt": "Purple Battery Electric Toothbrush",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_02_-_BT_Purple.png?v=1752465709",
              "alt": "Purple Battery Electric Toothbrush packaging",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_03_-_BT_Purple.png?v=1752465709",
              "alt": "Model smiling",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_04_-_BT_Purple.png?v=1752465709",
              "alt": "Purple battery electric toothbrush with X-1 Sonic Technology features on a pink background",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_05_-_BT_Purple.png?v=1752465709",
              "alt": "Pink Hismile Toothpaste being pumped onto the Purple Battery Electric Toothbrush",
              "height": 352,
              "width": 560
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Selector_BT_Purple.png?v=1752465708",
            "height": 100,
            "width": 100,
            "alt": "Purple Battery ETB selector image"
          }
        }
      },
      "content": {
        "description": {
          "title": "Smart brushing, made simple",
          "body": "Combining three intelligent cleaning modes, the Hismile Battery Toothbrush gives you an effortless, effective clean, wherever you are.",
          "bulletpoints": [
            "Three smart brushing modes",
            "Built-in 2-minute timer",
            "A gentle, effective clean",
            "4-SYNC smart timer for guided brushing"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Easy_To_Use_Emoji_f1d29879-17e8-465f-b793-0a71b166ec60.png?v=1752792418",
              "height": 30,
              "width": 20
            },
            "text": "Easy to use"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Smart_Brushing_Modes_Emoji.png?v=1752715075",
              "height": 30,
              "width": 20
            },
            "text": "Smart brushing modes"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Guided_Clean_Emoji.png?v=1752715079",
              "height": 30,
              "width": 20
            },
            "text": "Guided clean"
          }
        ],
        "productAccordions": [
          {
            "title": "A custom clean, every time.",
            "content": [
              {
                "body": "Whether you prefer a Gentle, Intense or Everyday clean, the Hismile Battery Toothbrush features three tailored modes to suit your brushing needs. With X1 Sonic Technology, it gently cleans your teeth, elevating your daily routine. The built-in timer powers down after 2 minutes, and the 4-SYNC smart timer pauses every 30 seconds to help you move across each quadrant of your mouth, making sure no spot gets missed."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Hismile Battery Toothbrush Purple<br>1x Replaceable Toothbrush head<br>2x AAA Batteries (included)"
              }
            ]
          }
        ]
      }
    }
  ],
  [
    "46101-2P-WH@battery-electric-toothbrush-heads",
    {
      "attributes": {
        "sku": "46101-2P-WH",
        "productHandle": "battery-electric-toothbrush-heads",
        "categoryDetails": {
          "primaryCategory": "replacement-heads"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-01-2P-WH_WhiteRefill.png?v=1752807790",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-02-2P-WH_WhiteRefill.png?v=1752807790",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-03-2P-WH_WhiteRefill.png?v=1752807790",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_04_-_2P-WH_White_Refill_c4c49e61-e664-4ff6-8940-44be0a57a126.png?v=1781658347",
              "height": 621,
              "width": 492
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-05-2P-WH_WhiteRefill.png?v=1752807790",
              "height": 1536,
              "width": 2160
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "description": {
          "title": "Fresh head. Fresh feel.",
          "body": "",
          "bulletpoints": [
            "A gentle, effective clean",
            "Compatible with the Hismile Battery Electric Toothbrush, found <a href=\"/products/battery-electric-toothbrush\" style=\"text-decoration: underline\">here</a>",
            "Freshen up your bathroom shelf with a new replacement head"
          ]
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Clean_Look_Emoji.png?v=1752721256",
              "height": 30,
              "width": 20
            },
            "text": "Clean look"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Soft_Bristles_Emoji.png?v=1752721262",
              "height": 30,
              "width": 20
            },
            "text": "Complete clean"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Easy_Swap_Emoji.png?v=1752721269",
              "height": 30,
              "width": 20
            },
            "text": "Easy swap"
          }
        ],
        "productAccordions": [
          {
            "title": "Time for a refresh?",
            "content": [
              {
                "body": "Keep your brushing on point with our replacement heads, keeping things fresh, fun, and functional."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x 2 Pack Battery Electric Toothbrush Head"
              }
            ]
          }
        ]
      }
    }
  ],
  [
    "50001-TF-WH@tru-fit-manual-toothbrush",
    {
      "attributes": {
        "sku": "50001-TF-WH",
        "productHandle": "tru-fit-manual-toothbrush",
        "categoryDetails": {
          "primaryCategory": "manual-toothbrush"
        }
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "50001-TF-WH@white-tru-fit-manual-toothbrush",
    {
      "attributes": {
        "sku": "50001-TF-WH",
        "productHandle": "white-tru-fit-manual-toothbrush",
        "categoryDetails": {
          "primaryCategory": "manual-toothbrush"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Tru-fit_-_PP.png?v=1789683086",
              "height": 512,
              "width": 352,
              "alt": "Hismile Tru-Fit Toothbrush in its packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_Tru-fit_-_PP.png?v=1789683086",
              "height": 512,
              "width": 352,
              "alt": "Tru-Fit three-sided brush head cleaning the front, back and biting surface of a tooth",
              "disclaimer": {
                "text": "*Refers to bristle coverage based on angled bristles and contoured head design. Up to 3X the bristle contact area of a standard flat-trim toothbrush.",
                "colour": "dark"
              }
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_Tru-fit_-_PP.png?v=1789683086",
              "height": 512,
              "width": 352,
              "alt": "Close-up of the Tru-Fit TriFlex brush head with three flexible brushes"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/BTF_-_Tru-fit_-_PP.png?v=1789683087",
              "height": 512,
              "width": 352,
              "alt": "Woman smiling while holding the Tru-Fit Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_Tru-fit_-_PP.png?v=1789683086",
              "height": 1536,
              "width": 2160,
              "alt": "Tru-Fit brush wrapping around a tooth compared with a traditional flat brush"
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/cream_selector.png?v=1716522594",
            "height": 100,
            "width": 100,
            "alt": "Cream selector image"
          }
        }
      },
      "content": {
        "productOptionSelector": [
          {
            "sku": "50001-TF-WH5"
          }
        ],
        "description": {
          "title": "Every side, in one stroke",
          "body": "Tru-Fit's three-sided head hugs the tooth as you brush, targeting the front, the back and the biting surface in a single stroke including the side you can't see.<br><br>Ask most people where they brush least, and they won't know, because you can't see the back of your own teeth. It's the hardest surface to angle a brush against, with more grooves and curves that can be tricky to reach, and it's an area where build-up can be harder to reach.<br><br>Tru-Fit is built for that. The centre brush sits on the biting surface while two angled side brushes hug the outer and inner faces at once, so every stroke reaches all three surfaces without you having to tilt, twist or guess. 42 tufts across the three faces mean more bristle contact with every stroke, and the double-tapered bristles — thinner at the tips — are designed to reach along the gumline and between teeth.<br><br>Run your tongue along the back of your bottom front teeth. If it feels rough, that's the surface Tru-Fit was designed for.",
          "bulletpoints": [
            "Three brushes in one head",
            "Double-tapered bristles designed to reach the gumline",
            "Soft-grip handle, for ages 3 and up"
          ]
        },
        "productAccordions": [
          {
            "title": "What's included?",
            "content": [
              {
                "body": "1x Hismile Tru-Fit Manual Toothbrush"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Tru-Fit Toothbrush?",
              "content": [
                {
                  "body": "Apply toothpaste to the brush head. Place the head over your teeth so the centre brush sits on the biting surface and the two side brushes sit against the front and back. Move gently along the row, working through all four quadrants of your mouth for two minutes. Because the angles are built into the head, you don't need to tilt the brush to reach the gumline."
                }
              ]
            },
            {
              "title": "How often should I replace it?",
              "content": [
                {
                  "body": "Every 3 months, or sooner if the bristles start to fray."
                }
              ]
            },
            {
              "title": "Can my children use it?",
              "content": [
                {
                  "body": "Yes — Tru-Fit is suitable for ages 3 and up. We recommend supervision for children under 6."
                }
              ]
            },
            {
              "title": "Is it suitable for braces or permanent retainers?",
              "content": [
                {
                  "body": "Tru-Fit isn't designed specifically for braces or retainers, but the angled side brushes cover the inner surface of the teeth in the same stroke as the outer."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "50001-TF-WH5@buy-two-get-three-free-trufit",
    {
      "attributes": {
        "sku": "50001-TF-WH5",
        "productHandle": "buy-two-get-three-free-trufit",
        "categoryDetails": {
          "primaryCategory": "bulk-product"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_01_-_Tru_Fit_-_YSB.png?v=1792474152",
              "height": 512,
              "width": 352,
              "alt": "Buy 2 Hismile Tru-Fit Toothbrushes, get 3 free"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_Tru-fit_-_PP.png?v=1789683086",
              "height": 512,
              "width": 352,
              "alt": "Tru-Fit three-sided brush head cleaning the front, back and biting surface of a tooth",
              "disclaimer": {
                "text": "*Refers to bristle coverage based on angled bristles and contoured head design. Up to 3X the bristle contact area of a standard flat-trim toothbrush.",
                "colour": "dark"
              }
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_Tru-fit_-_PP.png?v=1789683086",
              "height": 512,
              "width": 352,
              "alt": "Close-up of the Tru-Fit TriFlex brush head with three flexible brushes"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/BTF_-_Tru-fit_-_PP.png?v=1789683087",
              "height": 512,
              "width": 352,
              "alt": "Woman smiling while holding the Tru-Fit Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_Tru-fit_-_PP.png?v=1789683086",
              "height": 1536,
              "width": 2160,
              "alt": "Tru-Fit brush wrapping around a tooth compared with a traditional flat brush"
            }
          ]
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/cream_selector.png?v=1716522594",
            "height": 100,
            "width": 100,
            "alt": "Cream selector image"
          }
        }
      },
      "content": {
        "disclaimer": "*Value based on full price of 5 Tru-Fit Manual Toothbrushes purchased separately.",
        "styleTags": [
          "show-value",
          "hide-badge"
        ],
        "valuePrice": [
          {
            "sku": "50001-TF-WH",
            "quantity": 5
          }
        ],
        "productOptionSelectorDetails": {
          "productQuantity": 5,
          "productType": {
            "single": "toothbrush",
            "singleText": "Up to 3-month supply^",
            "plural": "toothbrushes",
            "pluralText": "Up to 15-month supply^",
            "showIcons": true,
            "freeProducts": 3
          },
          "dealMessage": "Buy 2, get 3 free",
          "productTerms": "^Based on one manual toothbrush providing up to three-month's of use, in line with the recommendation to replace your toothbrush every three months.",
          "showValuePrice": true,
          "valuePriceLabel": "Bundle valued at",
          "showPercentageOff": true
        },
        "description": {
          "title": "Every side, in one stroke",
          "body": "Tru-Fit's three-sided head hugs the tooth as you brush, targeting the front, the back and the biting surface in a single stroke including the side you can't see.<br><br>Ask most people where they brush least, and they won't know, because you can't see the back of your own teeth. It's the hardest surface to angle a brush against, with more grooves and curves that can be tricky to reach, and it's an area where build-up can be harder to reach.<br><br>Tru-Fit is built for that. The centre brush sits on the biting surface while two angled side brushes hug the outer and inner faces at once, so every stroke reaches all three surfaces without you having to tilt, twist or guess. 42 tufts across the three faces mean more bristle contact with every stroke, and the double-tapered bristles — thinner at the tips — are designed to reach along the gumline and between teeth.<br><br>Run your tongue along the back of your bottom front teeth. If it feels rough, that's the surface Tru-Fit was designed for.<br><br>Not after a value pack? You can buy a single Tru-Fit toothbrush at full price <a href=\"/products/tru-fit-manual-toothbrush\" style=\"text-decoration: underline;\">here</a>.",
          "bulletpoints": [
            "Three brushes in one head",
            "Double-tapered bristles designed to reach the gumline",
            "Soft-grip handle, for ages 3 and up"
          ]
        },
        "productAccordions": [
          {
            "title": "What's included?",
            "content": [
              {
                "body": "5x Hismile Tru-Fit Manual Toothbrush"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How do I use the Tru-Fit Toothbrush?",
              "content": [
                {
                  "body": "Apply toothpaste to the brush head. Place the head over your teeth so the centre brush sits on the biting surface and the two side brushes sit against the front and back. Move gently along the row, working through all four quadrants of your mouth for two minutes. Because the angles are built into the head, you don't need to tilt the brush to reach the gumline."
                }
              ]
            },
            {
              "title": "How often should I replace it?",
              "content": [
                {
                  "body": "Every 3 months, or sooner if the bristles start to fray."
                }
              ]
            },
            {
              "title": "Can my children use it?",
              "content": [
                {
                  "body": "Yes — Tru-Fit is suitable for ages 3 and up. We recommend supervision for children under 6."
                }
              ]
            },
            {
              "title": "Is it suitable for braces or permanent retainers?",
              "content": [
                {
                  "body": "Tru-Fit isn't designed specifically for braces or retainers, but the angled side brushes cover the inner surface of the teeth in the same stroke as the outer."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "61001-LB-BR@blue-raspberry-lip-balm",
    {
      "attributes": {
        "sku": "61001-LB-BR",
        "productHandle": "blue-raspberry-lip-balm",
        "categoryDetails": {
          "primaryCategory": "lip-balm",
          "type": "flavour",
          "typeValue": "blue-raspberry"
        },
        "productTags": [
          "lip-balm"
        ]
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "61003-LB-WM@watermelon-lip-balm",
    {
      "attributes": {
        "sku": "61003-LB-WM",
        "productHandle": "watermelon-lip-balm",
        "categoryDetails": {
          "primaryCategory": "lip-balm",
          "type": "flavour",
          "typeValue": "watermelon"
        },
        "productTags": [
          "lip-balm"
        ]
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "61004-LB-SC@salted-caramel-lip-balm",
    {
      "attributes": {
        "sku": "61004-LB-SC",
        "productHandle": "salted-caramel-lip-balm",
        "categoryDetails": {
          "primaryCategory": "lip-balm",
          "type": "flavour",
          "typeValue": "salted-caramel"
        },
        "productTags": [
          "lip-balm"
        ]
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "61005-LB-GU@gummy-bear-lip-balm",
    {
      "attributes": {
        "sku": "61005-LB-GU",
        "productHandle": "gummy-bear-lip-balm",
        "categoryDetails": {
          "primaryCategory": "lip-balm",
          "type": "flavour",
          "typeValue": "gummy-bear"
        },
        "productTags": [
          "lip-balm"
        ]
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "61006-LB-MA@matcha-lip-balm",
    {
      "attributes": {
        "sku": "61006-LB-MA",
        "productHandle": "matcha-lip-balm",
        "categoryDetails": {
          "primaryCategory": "lip-balm",
          "type": "flavour",
          "typeValue": "matcha"
        },
        "productTags": [
          "lip-balm"
        ]
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "61007-LB-BB@barbie-pink-bubblegum-lip-balm",
    {
      "attributes": {
        "sku": "61007-LB-BB",
        "productHandle": "barbie-pink-bubblegum-lip-balm",
        "categoryDetails": {
          "primaryCategory": "lip-balm",
          "type": "flavour",
          "typeValue": "barbie-pink-bubblegum"
        },
        "productTags": [
          "lip-balm"
        ]
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "61008-LB-SA@sour-apple-lip-balm",
    {
      "attributes": {
        "sku": "61008-LB-SA",
        "productHandle": "sour-apple-lip-balm",
        "categoryDetails": {
          "primaryCategory": "lip-balm",
          "type": "flavour",
          "typeValue": "sour-apple"
        },
        "productTags": [
          "lip-balm"
        ]
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "61009-LB-SS@sour-strawberry-lip-balm",
    {
      "attributes": {
        "sku": "61009-LB-SS",
        "productHandle": "sour-strawberry-lip-balm",
        "categoryDetails": {
          "primaryCategory": "lip-balm",
          "type": "flavour",
          "typeValue": "sour-strawberry"
        },
        "productTags": [
          "lip-balm"
        ]
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "61012-LB-CH@juicy-cherry-lip-tint",
    {
      "attributes": {
        "sku": "61012-LB-CH",
        "productHandle": "juicy-cherry-lip-tint",
        "categoryDetails": {
          "primaryCategory": "lip-balm",
          "type": "flavour",
          "typeValue": "juicy-cherry"
        },
        "productTags": [
          "lip-balm"
        ]
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "61013-LB-HC@hot-cocoa-lip-tint",
    {
      "attributes": {
        "sku": "61013-LB-HC",
        "productHandle": "hot-cocoa-lip-tint",
        "categoryDetails": {
          "primaryCategory": "lip-balm",
          "type": "flavour",
          "typeValue": "hot-cocoa"
        },
        "productTags": [
          "lip-balm"
        ]
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "61015-LB-VC@vanilla-cream-lip-tint",
    {
      "attributes": {
        "sku": "61015-LB-VC",
        "productHandle": "vanilla-cream-lip-tint",
        "categoryDetails": {
          "primaryCategory": "lip-balm",
          "type": "flavour",
          "typeValue": "vanilla-cream"
        },
        "productTags": [
          "lip-balm"
        ]
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "90001-WM@watermelon-toothpaste",
    {
      "attributes": {
        "sku": "90001-WM",
        "productHandle": "watermelon-toothpaste",
        "categoryDetails": {
          "primaryCategory": "toothpaste",
          "type": "flavour",
          "typeValue": "watermelon"
        },
        "productTags": [
          "toothpaste",
          "fluoride"
        ]
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_01_-_Watermelon.png?v=1771813809",
              "height": 900,
              "width": 900,
              "alt": "Watermelon Flavour Toothpaste"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_02_-_Watermelon.png?v=1771813810",
              "height": 900,
              "width": 900,
              "alt": "Watermelon Toothpaste on Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_03_-_Watermelon.png?v=1771813810",
              "alt": "Watermelon Flavour Toothpaste",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_04_-_Watermelon.png?v=1771813812",
              "alt": "Watermelon",
              "height": 900,
              "width": 900
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/Selector_-_Watermelon.png?v=1771813081",
            "height": 100,
            "width": 100,
            "alt": "Watermelon selector image"
          }
        },
        "customProductAsset": {
          "bundleImage": {
            "default": {
              "src": "",
              "height": 500,
              "width": 500
            }
          }
        }
      },
      "content": {
        "styleTags": [
          "themed"
        ],
        "description": {
          "title": "Wild about watermelon?",
          "body": "From the second it melts in your mouth, a wave of watermelon will sweep you upwards towards the highest heights of hydration. So grab a slice, strap yourself in and look forward to flavour in full flow. You’ll wonder how you ever went without.",
          "bulletpoints": [
            "Flavour with a burst of freshness",
            "Fluoride+ formula for an effective clean",
            "Long-lasting smile-care"
          ]
        },
        "colourScheme": {
          "backgroundColour": "rgba(255, 228, 248, 1)",
          "primaryColour": "rgba(147, 209, 94, 1)",
          "secondaryFontColour": "rgba(255, 255, 255, 1)"
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/a80cefa531cb932fba17ed1726958132.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Fluoride+ <br> formula"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/b61f64479226187079c502eaccf16154.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Sensitivity <br> free"
          }
        ],
        "productAccordions": [
          {
            "title": "What makes this toothpaste different?",
            "content": [
              {
                "body": "Hismile Flavoured Toothpaste feels and tastes like a treat for your teeth - 2 minutes will never be enough. Multiple protection - our Fluoride+ formula has been developed with ingredients for a long lasting smile."
              }
            ]
          },
          {
            "title": "*What’s included?",
            "content": [
              {
                "body": "1x Watermelon Toothpaste.\n                  <br> Total Net Contents: 100g | 3.5 oz.<br><br>*Based on a 65% increase in net product weight when compared to our previous Hismile Fluoride+ Flavoured Toothpaste 60g bottle."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": {
              "us": [
                {
                  "head": "New Tube Formula | 100g",
                  "body": "Active ingredient: Sodium Fluoride 0.243% (0.14% w/v fluoride ion)<br>Purpose: Anticavity<br><br>Inactive Ingredients: Water, Glycerin, Hydrated Silica, Xylitol, Sorbitol, Flavor, Cellulose Gum, 1,2-Hexanediol, Sodium Phosphate, Sodium Lauroyl Sarcosinate, Tetrapotassium Pyrophosphate, Sucralose, Caprylyl Glycol, Lauryl Glucoside, Methyl Diisopropyl Propionamide, Sodium Gluconate, Zinc Lactate. "
                },
                {
                  "head": "Airless Pump Formula | 60g",
                  "body": "Aqua (Water), Sorbitol, Hydrated Silica, Xylitol, Glycerin, Flavour (Aroma), Disodium Phosphate, Sodium Lauroyl Sarcosinate, Calcium Glycerophosphate, Xanthan Gum, Cellulose Gum, Tetrapotassium Pyrophosphate, Benzyl Alcohol, Caprylyl Glycol, Sucralose, Menthol, Sodium Fluoride, Sodium Gluconate, Pentylene Glycol, Zinc Lactate, Methyl Diisopropyl Propionamide, Benzoic Acid."
                }
              ],
              "default": [
                {
                  "head": "New Tube Formula | 100g",
                  "body": "Aqua/Water, Glycerin, Hydrated Silica, Xylitol, Sorbitol, Flavour/Aroma, Cellulose Gum, 1,2-Hexanediol, Sodium Lauroyl Sarcosinate, Tetrapotassium Pyrophosphate, Sucralose, Caprylyl Glycol, Sodium Phosphate, Zinc Gluconate, Lauryl Glucoside, Sodium Fluoride, Methyl Diisopropyl Propionamide."
                },
                {
                  "head": "Airless Pump Formula | 60g",
                  "body": "Aqua (Water), Sorbitol, Hydrated Silica, Xylitol, Glycerin, Flavour (Aroma), Disodium Phosphate, Sodium Lauroyl Sarcosinate, Calcium Glycerophosphate, Xanthan Gum, Cellulose Gum, Tetrapotassium Pyrophosphate, Benzyl Alcohol, Caprylyl Glycol, Sucralose, Menthol, Sodium Fluoride, Sodium Gluconate, Pentylene Glycol, Zinc Lactate, Methyl Diisopropyl Propionamide, Benzoic Acid."
                },
                {
                  "body": "Contains: Sodium fluoride 0.243% W/W (eq. 1100 ppm f.)"
                }
              ]
            }
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "What makes this toothpaste different?",
              "content": [
                {
                  "body": "Hismile Toothpaste feels and tastes like a treat for your teeth - 2 minutes will never be enough. Multiple protection - our Fluoride+ formula has been developed with ingredients for a long lasting smile."
                }
              ]
            },
            {
              "title": "Can I use this as my everyday Toothpaste?",
              "content": [
                {
                  "body": "Yes, all of our Hismile Toothpastes are perfect to be used as your everyday toothpaste! We have included the highest quality ingredients to provide clean and long-lasting smile-care."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothpaste is not recommended for children 6 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "90002-GB@grape-bubblegum-toothpaste",
    {
      "attributes": {
        "sku": "90002-GB",
        "productHandle": "grape-bubblegum-toothpaste",
        "categoryDetails": {
          "primaryCategory": "toothpaste",
          "type": "flavour",
          "typeValue": "grape-bubblegum"
        },
        "productTags": [
          "toothpaste",
          "fluoride"
        ]
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_01_-_Grape_Bubblegum.png?v=1771813915",
              "alt": "Grape Bubblegum Flavour Toothpaste",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_02_-_Grape_Bubblegum.png?v=1771813914",
              "alt": "Grape Bubblegum Toothpaste on Toothbrush",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_03_-_Grape_Bubblegum.png?v=1771813914",
              "alt": "Grape Bubblegum Flavour Toothpaste",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_04_-_Grape_Bubblegum.png?v=1771813916",
              "alt": "Grape Bubblegum",
              "height": 900,
              "width": 900
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/Selector_-_Grape_Bubblegum.png?v=1771813156",
            "height": 100,
            "width": 100,
            "alt": "Grape Bubblegum selector image"
          }
        },
        "customProductAsset": {
          "bundleImage": {
            "default": {
              "src": "",
              "height": 500,
              "width": 500
            }
          }
        }
      },
      "content": {
        "styleTags": [
          "themed"
        ],
        "description": {
          "title": "Bubbling for Grape?",
          "body": "Bursting with hyper-hydrating freshness, even the smallest pop of Grape Bubblegum can freshen up the dullest smile. And don’t get us started on the flavour. An uber-delicious, ego-inflating taste that stretches on hour after hour, without chewing for a second. It’s just a shame you have to spit it out.",
          "bulletpoints": [
            "Flavour with a burst of freshness",
            "Fluoride+ formula for an effective clean",
            "Long-lasting smile-care"
          ]
        },
        "colourScheme": {
          "backgroundColour": "rgba(241, 218, 255, 1)",
          "primaryColour": "rgba(230, 249, 81, 1)",
          "secondaryFontColour": "rgba(168, 68, 199, 1)"
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/a80cefa531cb932fba17ed1726958132.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Fluoride+ <br> formula"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/b61f64479226187079c502eaccf16154.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Sensitivity <br> free"
          }
        ],
        "productAccordions": [
          {
            "title": "What makes this toothpaste different?",
            "content": [
              {
                "body": "Hismile Flavoured Toothpaste feels and tastes like a treat for your teeth - 2 minutes will never be enough. Multiple protection - our Fluoride+ formula has been developed with ingredients for a long lasting smile."
              }
            ]
          },
          {
            "title": "*What’s included?",
            "content": [
              {
                "body": "1x Grape Bubblegum Toothpaste.\n                  <br> Total Net Contents: 100g | 3.5 oz.<br><br>*Based on a 65% increase in net product weight when compared to our previous Hismile Fluoride+ Flavoured Toothpaste 60g bottle."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": {
              "us": [
                {
                  "head": "New Tube Formula | 100g",
                  "body": "Active ingredient: Sodium Fluoride 0.243% (0.14% w/v fluoride ion)<br>Purpose: Anticavity<br><br>Inactive Ingredients: Water, Glycerin, Hydrated Silica, Xylitol, Sorbitol, Cellulose Gum, Flavor, 1,2-Hexanediol, Sodium Phosphate, Sodium Lauroyl Sarcosinate, Tetrapotassium Pyrophosphate, Sucralose, Caprylyl Glycol, Lauryl Glucoside, Methyl Diisopropyl Propionamide, Sodium Gluconate, Zinc Lactate, Red 40, Blue 1. "
                },
                {
                  "head": "Airless Pump Formula | 60g",
                  "body": "Aqua (Water), Sorbitol, Hydrated Silica, Xylitol, Glycerin, Disodium Phosphate, Flavour (Aroma), Sodium Lauroyl Sarcosinate, Xanthan Gum, Cellulose Gum, Tetrapotassium Pyrophosphate, Caprylyl Glycol, Pentylene Glycol, Benzyl Alcohol, Sucralose, Sodium Fluoride, Methyl Diisopropyl Propionamide, Sodium Gluconate, Zinc Lactate, Benzoic Acid, FD&C Red No. 40 (CI 16035), FD&C Blue No. 1 (CI 42090)."
                }
              ],
              "default": [
                {
                  "head": "New Tube Formula | 100g",
                  "body": "Aqua/Water, Glycerin, Hydrated Silica, Xylitol, Sorbitol, Cellulose Gum, Flavour/Aroma, 1,2-Hexanediol, Sodium Lauroyl Sarcosinate, Tetrapotassium Pyrophosphate, Sucralose, Caprylyl Glycol, Zinc Gluconate, Lauryl Glucoside, Sodium Fluoride, Methyl Diisopropyl Propionamide, Sodium Phosphate, FD&C Red No. 40 (CI 16035), FD&C Blue No. 1 (CI 42090)."
                },
                {
                  "head": "Airless Pump Formula | 60g",
                  "body": "Aqua (Water), Sorbitol, Hydrated Silica, Xylitol, Glycerin, Disodium Phosphate, Flavour (Aroma), Sodium Lauroyl Sarcosinate, Xanthan Gum, Cellulose Gum, Tetrapotassium Pyrophosphate, Caprylyl Glycol, Pentylene Glycol, Benzyl Alcohol, Sucralose, Sodium Fluoride, Methyl Diisopropyl Propionamide, Sodium Gluconate, Zinc Lactate, Benzoic Acid, FD&C Red No. 40 (CI 16035), FD&C Blue No. 1 (CI 42090)."
                },
                {
                  "body": "Contains: Sodium fluoride 0.243% W/W (eq. 1100 ppm f.)"
                }
              ]
            }
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "What makes this toothpaste different?",
              "content": [
                {
                  "body": "Hismile Toothpaste feels and tastes like a treat for your teeth - 2 minutes will never be enough. Multiple protection - our Fluoride+ formula has been developed with ingredients for a long lasting smile."
                }
              ]
            },
            {
              "title": "Can I use this as my everyday Toothpaste?",
              "content": [
                {
                  "body": "Yes, all of our Hismile Toothpastes are perfect to be used as your everyday toothpaste! We have included the highest quality ingredients to provide clean and long-lasting smile-care."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothpaste is not recommended for children 6 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "90003-ST@strawberry-toothpaste",
    {
      "attributes": {
        "sku": "90003-ST",
        "productHandle": "strawberry-toothpaste",
        "categoryDetails": {
          "primaryCategory": "toothpaste",
          "type": "flavour",
          "typeValue": "strawberry"
        },
        "productTags": [
          "toothpaste",
          "fluoride"
        ]
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_01_-_Strawberry.png?v=1771814024",
              "alt": "Strawberry Flavour Toothpaste",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_02_-_Strawberry.png?v=1771814025",
              "alt": "Strawberry Toothpaste on Toothbrush",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_03_-_Strawberry.png?v=1771814027",
              "alt": "Strawberry Flavour Toothpaste",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_04_-_Strawberry.png?v=1771814028",
              "alt": "Strawberry",
              "height": 900,
              "width": 900
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/Selector_-_Strawberry.png?v=1771813243",
            "height": 100,
            "width": 100,
            "alt": "Strawberry selector image"
          }
        },
        "customProductAsset": {
          "bundleImage": {
            "default": {
              "src": "",
              "height": 500,
              "width": 500
            }
          }
        }
      },
      "content": {
        "styleTags": [
          "themed"
        ],
        "description": {
          "title": "A sucker for Strawberry?",
          "body": "The sweet taste of strawberry, combined with a dollop of creamy deliciousness, this flavour will satisfy your tastebuds. Pucker up for a taste oh-so sweet, that you’ll be head over heels with this flavour after just one brush.",
          "bulletpoints": [
            "Flavour with a burst of freshness",
            "Fluoride+ formula for an effective clean",
            "Long-lasting smile-care"
          ]
        },
        "colourScheme": {
          "backgroundColour": "rgba(255, 206, 226, 1)",
          "primaryColour": "rgba(255, 60, 84, 1)",
          "secondaryFontColour": "rgba(255, 206, 226, 1)"
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/a80cefa531cb932fba17ed1726958132.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Fluoride+ <br> formula"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/b61f64479226187079c502eaccf16154.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Sensitivity <br> free"
          }
        ],
        "productAccordions": [
          {
            "title": "What makes this toothpaste different?",
            "content": [
              {
                "body": "Hismile Flavoured Toothpaste feels and tastes like a treat for your teeth - 2 minutes will never be enough. Multiple protection - our Fluoride+ formula has been developed with ingredients for a long lasting smile."
              }
            ]
          },
          {
            "title": "*What’s included?",
            "content": [
              {
                "body": "1x Strawberry Toothpaste.<br> Total Net Contents: 100g | 3.5 oz.<br><br>*Based on a 65% increase in net product weight when compared to our previous Hismile Fluoride+ Flavoured Toothpaste 60g bottle."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": {
              "us": [
                {
                  "head": "New Tube Formula | 100g",
                  "body": "Active ingredient: Sodium Fluoride 0.243% (0.14% w/v fluoride ion)<br>Purpose: Anticavity<br><br>Inactive Ingredients: Water, Glycerin, Hydrated Silica, Xylitol, Sorbitol, Cellulose Gum, Flavor, 1,2-Hexanediol, Sodium Phosphate, Sodium Lauroyl Sarcosinate, Tetrapotassium Pyrophosphate, Sucralose, Caprylyl Glycol, Lauryl Glucoside, Methyl Diisopropyl Propionamide, Sodium Gluconate, Zinc Lactate, Red 33."
                },
                {
                  "head": "Airless Pump Formula | 60g",
                  "body": "Aqua (Water), Sorbitol, Hydrated Silica, Xylitol, Glycerin, Disodium Phosphate, Flavour (Aroma), Sodium Lauroyl Sarcosinate, Xanthan Gum, Cellulose Gum, Tetrapotassium Pyrophosphate, Caprylyl Glycol, Pentylene Glycol, Benzyl Alcohol, Sucralose, Sodium Fluoride, Methyl Diisopropyl Propionamide, Sodium Gluconate, Zinc Lactate, Benzoic Acid, D&C Red No. 33 (CI 17200)."
                }
              ],
              "default": [
                {
                  "head": "New Tube Formula | 100g",
                  "body": "Aqua/Water, Glycerin, Hydrated Silica, Xylitol, Sorbitol, Cellulose Gum, Flavour/Aroma, 1,2-Hexanediol, Sodium Lauroyl Sarcosinate, Tetrapotassium Pyrophosphate, Sucralose, Caprylyl Glycol, Sodium Phosphate, Zinc Gluconate, Lauryl Glucoside, Sodium Fluoride, Methyl Diisopropyl Propionamide, D&C Red No. 33 (CI 17200)"
                },
                {
                  "head": "Airless Pump Formula | 60g",
                  "body": "Aqua (Water), Sorbitol, Hydrated Silica, Xylitol, Glycerin, Disodium Phosphate, Flavour (Aroma), Sodium Lauroyl Sarcosinate, Xanthan Gum, Cellulose Gum, Tetrapotassium Pyrophosphate, Caprylyl Glycol, Pentylene Glycol, Benzyl Alcohol, Sucralose, Sodium Fluoride, Methyl Diisopropyl Propionamide, Sodium Gluconate, Zinc Lactate, Benzoic Acid, D&C Red No. 33 (CI 17200)."
                },
                {
                  "body": "Contains: Sodium fluoride 0.243% W/W (eq. 1100 ppm f.)"
                }
              ]
            }
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "What makes this toothpaste different?",
              "content": [
                {
                  "body": "Hismile Toothpaste feels and tastes like a treat for your teeth - 2 minutes will never be enough. Multiple protection - our Fluoride+ formula has been developed with ingredients for a long lasting smile."
                }
              ]
            },
            {
              "title": "Can I use this as my everyday Toothpaste?",
              "content": [
                {
                  "body": "Yes, all of our Hismile Toothpastes are perfect to be used as your everyday toothpaste! We have included the highest quality ingredients to provide clean and long-lasting smile-care."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothpaste is not recommended for children 6 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "90004-MN@classic-mint-toothpaste",
    {
      "attributes": {
        "sku": "90004-MN",
        "productHandle": "classic-mint-toothpaste",
        "categoryDetails": {
          "primaryCategory": "toothpaste",
          "type": "flavour",
          "typeValue": "classic-mint"
        },
        "productTags": [
          "toothpaste",
          "fluoride"
        ],
        "age": 2
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_01_-_Classic_Mint.png?v=1771814132",
              "alt": "Classic Mint Flavour Toothpaste",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_02_-_Classic_Mint.png?v=1771814133",
              "alt": "Classic Mint Toothpaste on Toothbrush",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_04_-_Classic_Mint.png?v=1771814135",
              "alt": "Classic Mint Flavour Toothpaste",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_03_-_Classic_Mint.png?v=1771814136",
              "height": 900,
              "width": 900
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/Selector_-_Classic_Mint.png?v=1771813297",
            "height": 100,
            "width": 100,
            "alt": "Classic Mint selector image"
          }
        },
        "customProductAsset": {
          "bundleImage": {
            "default": {
              "src": "",
              "height": 500,
              "width": 500
            }
          }
        }
      },
      "content": {
        "styleTags": [
          "themed"
        ],
        "description": {
          "title": "Committed to mint?",
          "body": "What's it like when you brush with Classic Mint? It's clean, cool and exactly what brushing should feel like. A timeless burst of freshness that wakes you up, clears you out and leaves your mouth feeling like it just hit reset.",
          "bulletpoints": [
            "Flavour with a burst of freshness",
            "Fluoride+ formula for an effective clean",
            "Long-lasting smile-care"
          ]
        },
        "colourScheme": {
          "backgroundColour": "rgba(217, 238, 255, 1)",
          "primaryColour": "rgba(60, 122, 242, 1)",
          "secondaryFontColour": "rgba(217, 238, 255, 1)"
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/a80cefa531cb932fba17ed1726958132.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Fluoride+ <br> formula"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/b61f64479226187079c502eaccf16154.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Sensitivity <br> free"
          }
        ],
        "productAccordions": [
          {
            "title": "What makes this toothpaste different?",
            "content": [
              {
                "body": "It's the mint you know, done better. Crisp, clean and refreshing from the first brush to the last, because some classics exist for a reason. No fuss, no gimmicks. Just a smooth, cooling mint flavour that makes every brush feel effortless."
              }
            ]
          },
          {
            "title": "*What’s included?",
            "content": [
              {
                "body": "1x Classic Mint Toothpaste.\n              <br> Total Net Contents: 100g | 3.5 oz.<br><br>*Based on a 65% increase in net product weight when compared to our previous Hismile Fluoride+ Flavoured Toothpaste 60g bottle."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": {
              "us": [
                {
                  "head": "New Tube Formula (Classic Mint) | 100g",
                  "body": "Active ingredient: Sodium Fluoride 0.243% (0.14% w/v fluoride ion)<br>Purpose: Anticavity<br><br>Inactive Ingredients: Water, Glycerin, Hydrated Silica, Xylitol, Sorbitol, Cellulose Gum, Flavor, Sodium Methyl Cocoyl Taurate, 1,2-Hexanediol, Sodium Phosphate, Sodium Lauroyl Sarcosinate, Tetrapotassium Pyrophosphate, Sucralose, Caprylyl Glycol, Lauryl Glucoside, Methyl Diisopropyl Propionamide, Sodium Gluconate, Zinc Lactate."
                },
                {
                  "head": "Airless Pump Formula (Smooth Mint) | 60g",
                  "body": "Aqua (Water), Sorbitol, Hydrated Silica, Xylitol, Glycerin, Flavour (Aroma), Disodium Phosphate, Sodium Lauroyl Sarcosinate, Calcium Glycerophosphate, Xanthan Gum, Cellulose Gum, Tetrapotassium Pyrophosphate, Benzyl Alcohol, Caprylyl Glycol, Sucralose, Menthol, Sodium Fluoride, Sodium Gluconate, Pentylene Glycol, Zinc Lactate, Benzoic Acid, Methyl Diisopropyl Propionamide, d-Limonene, Eugenol."
                }
              ],
              "default": [
                {
                  "head": "New Tube Formula (Classic Mint) | 100g",
                  "body": "Aqua/Water, Glycerin, Hydrated Silica, Xylitol, Sorbitol, Cellulose Gum, Sodium Methyl Cocoyl Taurate, 1,2-Hexanediol, Sodium Lauroyl Sarcosinate, Tetrapotassium Pyrophosphate, Sodium Phosphate, Caprylyl Glycol, Sucralose, Zinc Gluconate, Mentha Viridis (Spearmint) Leaf Oil, Menthol, Lauryl Glucoside, Sodium Fluoride, Methyl Diisopropyl Propionamide, Carvone, Limonene."
                },
                {
                  "head": "Airless Pump Formula (Smooth Mint) | 60g",
                  "body": "Aqua (Water), Sorbitol, Hydrated Silica, Xylitol, Glycerin, Flavour (Aroma), Disodium Phosphate, Sodium Lauroyl Sarcosinate, Calcium Glycerophosphate, Xanthan Gum, Cellulose Gum, Tetrapotassium Pyrophosphate, Benzyl Alcohol, Caprylyl Glycol, Sucralose, Menthol, Sodium Fluoride, Sodium Gluconate, Pentylene Glycol, Zinc Lactate, Benzoic Acid, Methyl Diisopropyl Propionamide, d-Limonene, Eugenol."
                },
                {
                  "body": "Contains: Sodium fluoride 0.243% W/W (eq. 1100 ppm f.)"
                }
              ]
            }
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "What makes this toothpaste different?",
              "content": [
                {
                  "body": "Hismile Toothpaste feels and tastes like a treat for your teeth - 2 minutes will never be enough. Multiple protection - our Fluoride+ formula has been developed with ingredients for a long lasting smile."
                }
              ]
            },
            {
              "title": "Can I use this as my everyday Toothpaste?",
              "content": [
                {
                  "body": "Yes, all of our Hismile Toothpastes are perfect to be used as your everyday toothpaste! We have included the highest quality ingredients to provide clean and long-lasting smile-care."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothpaste is not recommended for children 6 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "90005-BR@blue-raspberry-toothpaste",
    {
      "attributes": {
        "sku": "90005-BR",
        "productHandle": "blue-raspberry-toothpaste",
        "categoryDetails": {
          "primaryCategory": "toothpaste",
          "type": "flavour",
          "typeValue": "blue-raspberry"
        },
        "productTags": [
          "toothpaste",
          "fluoride"
        ]
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_01_-_Blue_Raspberry.png?v=1771814489",
              "alt": "Blue Raspberry Flavour Toothpaste",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_02_-_Blue_Raspberry.png?v=1771814491",
              "alt": "Blue Raspberry Toothpaste on Toothbrush",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_03_-_Blue_Raspberry.png?v=1771814492",
              "alt": "Blue Raspberry Flavour Toothpaste",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/PP_-_04_-_Blue_Raspberry.png?v=1771814495",
              "alt": "Blue Raspberry",
              "height": 900,
              "width": 900
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/Selector_-_Blue_Raspberry.png?v=1771813342",
            "height": 100,
            "width": 100,
            "alt": "Blue Raspberry selector image"
          }
        },
        "customProductAsset": {
          "bundleImage": {
            "default": {
              "src": "",
              "height": 500,
              "width": 500
            }
          }
        }
      },
      "content": {
        "styleTags": [
          "themed",
          "light-text"
        ],
        "description": {
          "title": "Bursting for some Blue Raspberry?",
          "body": "Our most-hyped flavour is here, and it has to be tasted to be believed. Enjoy the perfect mix of a delicious burst of flavour, and surprise your tastebuds with Blue Raspberry. This irresistible blend of your favourite berries will keep you coming back for more.",
          "bulletpoints": [
            "Flavour with a burst of freshness",
            "Fluoride+ formula for an effective clean",
            "Long-lasting smile-care"
          ]
        },
        "colourScheme": {
          "backgroundColour": "rgba(4, 77, 207, 1)",
          "primaryColour": "rgba(178, 241, 222, 1)",
          "secondaryFontColour": "rgba(4, 77, 207, 1)"
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/a80cefa531cb932fba17ed1726958132.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Fluoride+ <br> formula"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/b61f64479226187079c502eaccf16154.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Sensitivity <br> free"
          }
        ],
        "productAccordions": [
          {
            "title": "What makes this toothpaste different?",
            "content": [
              {
                "body": "Hismile Flavoured Toothpaste feels and tastes like a treat for your teeth - 2 minutes will never be enough. Multiple protection - our Fluoride+ formula has been developed with ingredients for a long lasting smile."
              }
            ]
          },
          {
            "title": "*What’s included?",
            "content": [
              {
                "body": "1x Blue Raspberry Toothpaste.\n                               <br> Total Net Contents: 100g | 3.5 oz.<br><br>*Based on a 65% increase in net product weight when compared to our previous Hismile Fluoride+ Flavoured Toothpaste 60g bottle."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": {
              "us": [
                {
                  "head": "New Tube Formula | 100g",
                  "body": "Active ingredient: Sodium Fluoride 0.243% (0.14% w/v fluoride ion)<br>Purpose: Anticavity<br><br>Inactive Ingredients: Water, Glycerin, Hydrated Silica, Xylitol, Sorbitol, Cellulose Gum, Flavor, 1,2-Hexanediol, Sodium Lauroyl Sarcosinate, Tetrapotassium Pyrophosphate, Sucralose, Caprylyl Glycol, Sodium Phosphate, Lauryl Glucoside, Methyl Diisopropyl Propionamide, Sodium Gluconate, Zinc Lactate, Blue 1."
                },
                {
                  "head": "Airless Pump Formula | 60g",
                  "body": "Aqua/Water, Sorbitol, Glycerin, Hydrated Silica, Xylitol, Flavour/Aroma, Sodium Lauroyl Sarcosinate, Sodium Phosphate, Xanthan Gum, Cellulose Gum, Sucralose, Tetrapotassium Pyrophosphate, Pentylene Glycol, Lauryl Glucoside, Sodium Fluoride, Methyl Diisopropyl Propionamide, Sodium Gluconate, Zinc Lactate, FD&C Blue No. 1 (CI 42090), Alpha-terpinene, Limonene."
                }
              ],
              "default": [
                {
                  "head": "New Tube Formula | 100g",
                  "body": "Aqua/Water, Glycerin, Hydrated Silica, Xylitol, Sorbitol, Cellulose Gum, Flavour/Aroma, 1,2-Hexanediol, Sucralose, Sodium Lauroyl Sarcosinate, Tetrapotassium Pyrophosphate, Caprylyl Glycol, Zinc Gluconate, Lauryl Glucoside, Sodium Fluoride, Methyl Diisopropyl Propionamide, Sodium Phosphate, FD&C Blue No. 1 (CI 42090), Limonene, Alpha-Terpinene."
                },
                {
                  "head": "Airless Pump Formula | 60g",
                  "body": "Aqua/Water, Sorbitol, Glycerin, Hydrated Silica, Xylitol, Flavour/Aroma, Sodium Lauroyl Sarcosinate, Sodium Phosphate, Xanthan Gum, Cellulose Gum, Sucralose, Tetrapotassium Pyrophosphate, Pentylene Glycol, Lauryl Glucoside, Sodium Fluoride, Methyl Diisopropyl Propionamide, Sodium Gluconate, Zinc Lactate, FD&C Blue No. 1 (CI 42090), Alpha-terpinene, Limonene."
                },
                {
                  "body": "Contains: Sodium fluoride 0.243% W/W (eq. 1100 ppm f.)"
                }
              ]
            }
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "What makes this toothpaste different?",
              "content": [
                {
                  "body": "Hismile Toothpaste feels and tastes like a treat for your teeth - 2 minutes will never be enough. Multiple protection - our Fluoride+ formula has been developed with ingredients for a long lasting smile."
                }
              ]
            },
            {
              "title": "Can I use this as my everyday Toothpaste?",
              "content": [
                {
                  "body": "Yes, all of our Hismile Toothpastes are perfect to be used as your everyday toothpaste! We have included the highest quality ingredients to provide clean and long-lasting smile-care."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothpaste is not recommended for children 6 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "90008-RP@reeses-peanut-butter-cup-toothpaste",
    {
      "attributes": {
        "sku": "90008-RP",
        "productHandle": "reeses-peanut-butter-cup-toothpaste",
        "categoryDetails": {
          "primaryCategory": "toothpaste",
          "type": "flavour",
          "typeValue": "reeses-peanut-butter-cup"
        },
        "productTags": [
          "toothpaste",
          "fluoride"
        ]
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_01_-_Reese_s_Peanut_Buter_Cup.png?v=1771798646",
              "height": 900,
              "width": 900,
              "alt": "Reeses Peanut Butter Cup Flavour Toothpaste"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_02_-_Reese_s_Peanut_Buter_Cup.png?v=1771798646",
              "height": 900,
              "width": 900,
              "alt": "Reeses Peanut Butter Cup Toothpaste on Toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_03_-_Reese_s_Peanut_Buter_Cup.png?v=1771798646",
              "height": 900,
              "width": 900,
              "alt": "Reeses Peanut Butter Cup Flavour Toothpaste"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_04_-_Reese_s_Peanut_Buter_Cup.png?v=1771798646",
              "height": 900,
              "width": 900,
              "alt": "Reeses Peanut Butter Cup"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Selector_-_Reese_s_Peanut_Buter_Cup.png?v=1771797744",
            "height": 100,
            "width": 100,
            "alt": "Reese's Peanut Butter Cup selector image"
          }
        },
        "customProductAsset": {
          "bundleImage": {
            "default": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9782/files/FBB_-_Reese_s_Peanut_Buter_Cup_100g.png?v=1771815214",
              "height": 500,
              "width": 500
            }
          }
        }
      },
      "content": {
        "styleTags": [
          "themed"
        ],
        "description": {
          "title": "Unwrap the flavour, get the best of both worlds.",
          "body": "This is brushing, but better. Reese's Peanut Butter Cup Toothpaste takes the iconic combo of rich milk chocolate and creamy peanut butter and turns it into a smooth, indulgent flavour hit. Sweet, nutty and unmistakably Reese's, it's the ultimate treat for your tastebuds. Every squeeze delivers that perfect chocolate and peanut butter balance you know and love, now made for your smile.<br><br>Sweet chocolate and peanut butter flavour inspired by Reese's Peanut Butter Cups",
          "bulletpoints": [
            "Fluoride+ formula for a superior clean",
            "Long-lasting smile-care that’s fun to use",
            "REESE’S and the trade dress are used under licence."
          ],
          "customBlurb": {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Hershey_Badge.png?v=1771800164",
              "height": 20,
              "width": 38,
              "alt": "REESE'S trademark",
              "customWidth": "7rem"
            },
            "text": "REESE'S trademark and trade dress and the REESE’S Orange Color are used under license.",
            "flexDirection": "column"
          }
        },
        "pill": {
          "variant": "information",
          "text": "New"
        },
        "colourScheme": {
          "backgroundColour": "rgba(254, 221, 0, 1)",
          "primaryColour": "rgba(255, 82, 0, 1)",
          "secondaryColour": "rgba(242, 198, 94, 1)",
          "secondaryFontColour": "rgba(254, 221, 0, 1)"
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/a80cefa531cb932fba17ed1726958132.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Fluoride+ <br> formula"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/b61f64479226187079c502eaccf16154.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Sensitivity <br> free"
          }
        ],
        "productAccordions": [
          {
            "title": "What makes this toothpaste different?",
            "content": [
              {
                "body": "It's everything you love about Reese's, reimagined for brushing. The rich chocolate and creamy peanut butter flavour blend together for a smooth, dessert-like twist on your daily routine. It's nostalgic, indulgent and guaranteed to make brushing feel like a treat."
              }
            ]
          },
          {
            "title": "*What’s included?",
            "content": [
              {
                "body": "1x Reese's Peanut Butter Cup Toothpaste. <br> Total Net Contents: 100g | 3.5 oz <br><br> *Based on a 65% increase in net product weight when compared to our previous Hismile Fluoride+ Flavoured Toothpaste 60g bottle."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, Glycerin, Hydrated Silica, Xylitol, Sorbitol, Cellulose Gum, Flavour/Aroma, Sucralose, Sodium Phosphate, 1,2-Hexanediol, Sodium Lauroyl Sarcosinate, Tetrapotassium Pyrophosphate, Caprylyl Glycol, Zinc Gluconate, Lauryl Glucoside, Sodium Fluoride, Methyl Diisopropyl Propionamide, Iron Oxides (CI 77491, CI 77499), Vanillin, Benzyl Alcohol."
              },
              {
                "body": "Contains: Sodium fluoride 0.243% W/W (eq. 1100 ppm f.)"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "What makes this toothpaste different?",
              "content": [
                {
                  "body": "Hismile Toothpaste feels and tastes like a treat for your teeth - 2 minutes will never be enough. Multiple protection - our Fluoride+ formula has been developed with ingredients for a long lasting smile."
                }
              ]
            },
            {
              "title": "Can I use this as my everyday Toothpaste?",
              "content": [
                {
                  "body": "Yes, all of our Hismile Toothpastes are perfect to be used as your everyday toothpaste! We have included the highest quality ingredients to provide clean and long-lasting smile-care."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothpaste is not recommended for children 6 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "90011-SD@the-simpsons-pink-donut-toothpaste",
    {
      "attributes": {
        "sku": "90011-SD",
        "productHandle": "the-simpsons-pink-donut-toothpaste",
        "categoryDetails": {
          "primaryCategory": "toothpaste",
          "type": "flavour",
          "typeValue": "the-simpsons-pink-donut"
        },
        "productTags": [
          "toothpaste",
          "fluoride"
        ]
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_01_-_Simpsons_Pink_Donut.png?v=1773890808",
              "alt": "The Simpsons Pink Donut Toothpaste",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_02_-_Simpsons_Pink_Donut.png?v=1773890808",
              "alt": "The Simpsons Pink Donut Toothpaste on Toothbrush",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_03_-_Simpsons_Pink_Donut.png?v=1773890808",
              "alt": "The Simpsons Pink Donut Toothpaste",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_04_-_Simpsons_Pink_Donut.png?v=1773890808",
              "alt": "The Simpsons Pink Donut",
              "height": 900,
              "width": 900
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/1525/9766/files/Selector_-_Simpsons.png?v=1773888911",
            "height": 100,
            "width": 100,
            "alt": "The Simpsons Pink Donut selector image"
          }
        },
        "customProductAsset": {
          "bundleImage": {
            "default": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/FBB_-_The_Simpsons_Pink_Donut_100g_fd94e2f8-f650-4cc3-a3f1-635e9cfb8fee.png?v=1777436065",
              "height": 500,
              "width": 500
            }
          }
        }
      },
      "content": {
        "styleTags": [
          "themed"
        ],
        "description": {
          "title": "D'oh-lightfully delicious.",
          "body": "This is brushing with a bite. The Simpsons Pink Donut Toothpaste captures that sweet, frosted donut flavour you know and love, reimagined for your smile. Rich, creamy and instantly recognisable, it delivers a playful punch of dessert-inspired flavour with every brush. It’s bold, fun and impossible not to grin about.",
          "bulletpoints": [
            "Flavour with a burst of freshness",
            "Fluoride+ formula for an effective clean",
            "Long-lasting smile-care"
          ],
          "customBlurb": {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/simpsons_disclaimer_black.png?v=1758073791",
              "height": 45,
              "width": 192,
              "alt": "The Simpsons disclaimer"
            }
          }
        },
        "colourScheme": {
          "backgroundColour": "rgba(255, 163, 195, 1)",
          "primaryColour": "rgba(255, 210, 0, 1)",
          "secondaryFontColour": "rgba(253, 30, 109, 1)"
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/a80cefa531cb932fba17ed1726958132.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Fluoride+ <br> formula"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/b61f64479226187079c502eaccf16154.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Sensitivity <br> free"
          }
        ],
        "productAccordions": [
          {
            "title": "What makes this toothpaste different?",
            "content": [
              {
                "body": "It’s everything you love about that iconic pink donut, now made for brushing. The sweet, frosting-inspired flavour turns your routine into something way more fun while still delivering a powerful clean. It’s nostalgic, playful and guaranteed to make you say “mmm… donuts” every time you brush."
              }
            ]
          },
          {
            "title": "*What’s included?",
            "content": [
              {
                "body": "1x The Simpsons Pink Donut Toothpaste.\n                               <br> Total Net Contents: 100g | 3.5 oz. <br><br>*Based on a 65% increase in net product weight when compared to our previous Hismile Fluoride+ Flavoured Toothpaste 60g bottle."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, Glycerin, Hydrated Silica, Xylitol, Sorbitol, Flavour/Aroma, Cellulose Gum, 1,2-Hexanediol, Sodium Lauroyl Sarcosinate, Tetrapotassium Pyrophosphate, Sucralose, Caprylyl Glycol, Sodium Phosphate, Zinc Gluconate, Lauryl Glucoside, Sodium Fluoride, Methyl Diisopropyl Propionamide, D&C Red No. 33 (CI 17200), Titanium Dioxide (CI 77891), Benzyl Alcohol."
              },
              {
                "body": "Contains: Sodium fluoride 0.243% W/W (eq. 1100 ppm f.)"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "What makes this toothpaste different?",
              "content": [
                {
                  "body": "Hismile Toothpaste feels and tastes like a treat for your teeth - 2 minutes will never be enough. Multiple protection - our Fluoride+ formula has been developed with ingredients for a long lasting smile."
                }
              ]
            },
            {
              "title": "Can I use this as my everyday Toothpaste?",
              "content": [
                {
                  "body": "Yes, all of our Hismile Toothpastes are perfect to be used as your everyday toothpaste! We have included the highest quality ingredients to provide clean and long-lasting smile-care."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothpaste is not recommended for children 6 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "90014-PM@barbie-pink-marshmallow-toothpaste",
    {
      "attributes": {
        "sku": "90014-PM",
        "productHandle": "barbie-pink-marshmallow-toothpaste",
        "categoryDetails": {
          "primaryCategory": "toothpaste",
          "type": "flavour",
          "typeValue": "barbie-pink-marshmallow"
        },
        "productTags": [
          "toothpaste",
          "fluoride"
        ]
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_01_-_Barbie_Pink_Marshmallow.png?v=1772065612",
              "alt": "Barbie Pink Marshmallow Flavour Toothpaste",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_02_-_Barbie_Pink_Marshmallow.png?v=1772065612",
              "alt": "Barbie Pink Marshmallow Toothpaste on Toothbrush",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_03_-_Barbie_Pink_Marshmallow.png?v=1772065612",
              "alt": "Barbie Pink Marshmallow Flavour Toothpaste",
              "height": 900,
              "width": 900
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_04_-_Barbie_Pink_Marshmallow.png?v=1772065612",
              "alt": "Barbie Pink Marshmallow",
              "height": 900,
              "width": 900
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Selector_-_Barbie_Pink_Marshmallow.png?v=1772065612",
            "height": 100,
            "width": 100,
            "alt": "Barbie Pink Marshmallow selector image"
          }
        },
        "customProductAsset": {
          "bundleImage": {
            "default": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/FBB_-_Barbie_Pink_Marshmallow_100g_ed5e4437-cdce-4ee7-b8eb-0e101634cd30.png?v=1777435809",
              "height": 500,
              "width": 500
            }
          }
        }
      },
      "content": {
        "styleTags": [
          "themed"
        ],
        "description": {
          "title": "Think pink. Brush sweet.",
          "body": "This is brushing, but make it Barbie. Barbie Pink Marshmallow Toothpaste brings fluffy, sugary marshmallow flavour wrapped in a bold pink moment. Sweet, smooth and unapologetically fun, it turns your everyday routine into a glam treat. Every squeeze delivers soft, candy-like sweetness made to leave you smiling in style.",
          "bulletpoints": [
            "Flavour with a burst of freshness",
            "Fluoride+ formula for an effective clean",
            "Long-lasting smile-care"
          ],
          "customBlurb": {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/MAT21BG_LOGO_TM_01.png?v=1719980056",
              "height": 40,
              "width": 40,
              "alt": "©2024 Mattel.",
              "customWidth": "3rem"
            },
            "text": "©2024 Mattel."
          }
        },
        "colourScheme": {
          "backgroundColour": "rgba(255, 212, 221, 1)",
          "primaryColour": "rgba(255, 156, 209, 1)",
          "secondaryFontColour": "rgba(255, 255, 255, 1)"
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/a80cefa531cb932fba17ed1726958132.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Fluoride+ <br> formula"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/b61f64479226187079c502eaccf16154.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Sensitivity <br> free"
          }
        ],
        "productAccordions": [
          {
            "title": "What makes this toothpaste different?",
            "content": [
              {
                "body": "It’s sweet, iconic and made to stand out. Inspired by Barbie’s world of pink perfection, this marshmallow-flavoured toothpaste adds a playful twist to your routine while delivering a superior clean. It’s nostalgic, sweet and designed to make brushing your most fabulous habit."
              }
            ]
          },
          {
            "title": "*What’s included?",
            "content": [
              {
                "body": "1x Barbie Pink Marshmallow Toothpaste.\n                               <br> Total Net Contents: 100g | 3.5 oz. <br><br>*Based on a 65% increase in net product weight when compared to our previous Hismile Fluoride+ Flavoured Toothpaste 60g bottle."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, Glycerin, Hydrated Silica, Xylitol, Sorbitol, Cellulose Gum, Flavour/Aroma, 1,2-Hexanediol, Tetrapotassium Pyrophosphate, Sodium Lauroyl Sarcosinate, Sucralose, Caprylyl Glycol, Zinc Gluconate, Lauryl Glucoside, Sodium Fluoride, Methyl Diisopropyl Propionamide, Titanium Dioxide (CI 77891), D&C Red No. 33 (CI 17200), Vanillin."
              },
              {
                "body": "Contains: Sodium fluoride 0.243% W/W (eq. 1100 ppm f.)"
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "What makes this toothpaste different?",
              "content": [
                {
                  "body": "Hismile Toothpaste feels and tastes like a treat for your teeth - 2 minutes will never be enough. Multiple protection - our Fluoride+ formula has been developed with ingredients for a long lasting smile."
                }
              ]
            },
            {
              "title": "Can I use this as my everyday Toothpaste?",
              "content": [
                {
                  "body": "Yes, all of our Hismile Toothpastes are perfect to be used as your everyday toothpaste! We have included the highest quality ingredients to provide clean and long-lasting smile-care."
                }
              ]
            },
            {
              "title": "Can I purchase this for my children?",
              "content": [
                {
                  "body": "Hismile toothpaste is not recommended for children 6 years and younger."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "AFFORDABLE_WHITENING_SET@affordable-whitening-set",
    {
      "attributes": {
        "sku": "AFFORDABLE_WHITENING_SET",
        "productHandle": "affordable-whitening-set",
        "categoryDetails": {
          "primaryCategory": "bundle"
        },
        "age": 11
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_01_-_Affordable_Whitening_Set_AWS.png?v=1779764471",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_02_-_Affordable_Whitening_Set_AWS.png?v=1779764471",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Stain_Mouthwash_-_PP.png?v=1784864978",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_04_-_Affordable_Whitening_Set_AWS.png?v=1779764471",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_05_-_Affordable_Whitening_Set_AWS.png?v=1779764472",
              "height": 414,
              "width": 656
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Collection_-_Affordable_Whitening_Set_AWS_-_Double-Wide.png?v=1779764471",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "styleTags": [
          "price-asterisk"
        ],
        "description": {
          "default": {
            "title": "Whiten. Remove Gunk. Protect + receive iD Stain Whitening Mouthwash for FREE",
            "body": "Three products. One routine. Every angle of your oral care covered, from surface whitening to enamel support and a cleaner, fresher mouth.<br><br><span style=\"font-weight: 500;\">What's in the Bundle:</span><br><br>\n<span style=\"font-weight: 500;\">Tooth Armour Toothpaste Serum:</span> Tooth Armour is engineered to elevate your oral care. Powered by NH-10, a concentrated blend of 6 actives including Nano-Hydroxyapatite, together with hydrated silica, xylitol, hyaluronic acid, niacinamide, and zinc gluconate. Add it to your existing toothpaste or use alone. Either way, it's the upgrade your routine has been missing.\n<ul>\n<li>Powered with Nano-Hydroxyapatite, an ingredient engineered to mirror the mineral that makes up 97% of your enamel</li>\n<li>Supports strong teeth, and a hydrated mouth</li>\n<li>Works with your current routine or as a standalone</li>\n</ul>\n<span style=\"font-weight: 500;\">V34 Whitening Strips:</span> Whiter teeth in one use. Hismile's V34 Strips combine V34 colour correction with PAP+ technology to deliver whiter teeth. Simply apply, wait 30 minutes, then peel and brush off the residue to reveal results. This dual active technology pairs instant visual improvement with targeted stain removal, unlike anything you'll find off the shelf.\n<ul>\n<li>Immediate cosmetic colour correction</li>\n<li>Visible whitening after just 30 minutes</li>\n<li>14 applications per pack</li>\n</ul>\n<span style=\"font-weight: 500;\">FREE: iD Stain Whitening Mouthwash:</span> iD Stain is not your average mouthwash. As you rinse, the formula binds to gunk and oral residue in your mouth, pulling them into visible particles you can actually see in the sink, that's what your toothbrush didn't catch. Hydrogen peroxide maintains your white smile from the very first rinse, while essential oil actives leave your mouth feeling cleaner and fresher.\n<ul>\n<li>Helps Maintain White Teeth</li>\n<li>Removes gunk and oral residue</li>\n<li>Essential oils for a lasting fresh feeling</li>\n</ul>\n\nTogether, these three steps cover what no single product can: target the surface stains, support the enamel, and clear the build-up regular brushing leaves behind. This is your complete routine.<br><br>\nSee individual product pages for full product information."
          }
        },
        "productAccordions": [
          {
            "title": "*What's included",
            "content": {
              "default": [
                {
                  "body": "1x Tooth Armour Toothpaste Serum {{10065-TA}}<br>\n              1x V34 Whitening Strips {{10060-VS}}<br>\n              1x iD Stain Whitening Mouthwash - Free<br><br>\n              For the cost of a single Tooth Armour and V34 Strips, you'll get all three products in this bundle!\n              "
                }
              ]
            }
          },
          {
            "title": "List of ingredients",
            "content": {
              "default": [
                {
                  "head": "Tooth Armour Toothpaste Serum",
                  "body": "Aqua/Water, Glycerin, Hydrated Silica, Hydroxyapatite (nano), Xylitol, Sodium Hyaluronate, Niacinamide, Zinc Gluconate, Hydroxyethylcellulose, Silica, Caprylyl Glycol, 1,2-Hexanediol, Hydroxypropyl Methylcellulose, Potassium Chloride, Lauryl Glucoside, Flavour/Aroma, Sucralose, Carmine (CI 75470) , Menthol, Carvone, Mentha Piperita Oil, Anethole."
                },
                {
                  "head": "V34 Whitening Strips",
                  "body": "\n              Glycerin, Aqua/Water, Cellulose Gum, Hydroxypropyl Methylcellulose, Phthalimidoperoxycaproic Acid, Disodium EDTA, Sodium Hydroxide, Menthol, Monosodium Citrate, Xanthan Gum, PVM/MA Copolymer, C12-15 Pareth-3, D&C Red No. 33 (CI 17200), FD&C Blue No. 1 (CI 42090).\n              "
                },
                {
                  "head": "iD Stain Whitening Mouthwash",
                  "body": "\n              Aqua/Water, PEG-40 Hydrogenated Castor Oil, Glycerin, Citric Acid, Sodium Benzoate, Sucralose, Menthol, Flavour/Aroma, Potassium Sorbate, Xylitol, Sodium Citrate, Eucalyptus Globulus Leaf Oil, Hydrogen Peroxide, Sodium Phytate, Thymol, Caramel, Methyl Salicylate.\n              "
                }
              ]
            }
          }
        ]
      }
    }
  ],
  [
    "ALT_ID_MOUTHWASH@id-stain-mouthwash-b",
    {
      "attributes": {
        "sku": "ALT_ID_MOUTHWASH",
        "productHandle": "id-stain-mouthwash-b",
        "categoryDetails": {
          "primaryCategory": "id-stain-mouthwash"
        },
        "age": 7
      },
      "media": {
        "carousel": {
          "au": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Stain_Mouthwash_-_CWH_-_PP_498bc6fa-5c31-4088-a2cb-f403b7fd7292.png?v=1784243564",
              "height": 512,
              "width": 352,
              "alt": "#1 mouthwash by units sold at Chemist Warehouse Australia"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Stain_Mouthwash_-_PP.png?v=1784864978",
              "height": 512,
              "width": 352,
              "alt": "New whitening mouthwash. Reveals buildup brushing may miss."
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04-Stain_Mouthwash-PP-20260127_86d7fc7b-1ef9-4c27-a4f7-207165db39c9.png?v=1771796961",
              "height": 512,
              "width": 352,
              "alt": "5 star Amazon review"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03-Stain_Mouthwash-PP_9e9530c6-4c66-4cb3-9caf-284f8796ff9d.jpg?v=1771983369",
              "height": 512,
              "width": 352,
              "alt": "Before and after image of mouthwash"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-05-Stain_Mouthwash_a18b98b9-8c9a-4dae-a069-bed46d0291a1.jpg?v=1771796961",
              "height": 414,
              "width": 656,
              "alt": "Model using mouthwash. Use as directed - results may variy, whitening results are not immediate, staff results"
            }
          ],
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Stain_Mouthwash_-_ttshop_-_PP_ab6fa348-f87d-4b83-88fa-1b09838177d1.png?v=1784243558",
              "height": 512,
              "width": 352,
              "alt": "#1 Mouthwash by units sold* at TikTok Shop US"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01-Stain_Mouthwash-PP_8f1a014d-fd2e-4540-93b0-efc0ab416a2b_1.jpg?v=1772080135",
              "height": 512,
              "width": 352,
              "alt": "New whitening mouthwash. Reveals buildup brushing may miss."
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04-Stain_Mouthwash-PP-20260127_86d7fc7b-1ef9-4c27-a4f7-207165db39c9.png?v=1771796961",
              "height": 512,
              "width": 352,
              "alt": "5 star Amazon review"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03-Stain_Mouthwash-PP_9e9530c6-4c66-4cb3-9caf-284f8796ff9d.jpg?v=1771983369",
              "height": 512,
              "width": 352,
              "alt": "Before and after image of mouthwash"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-05-Stain_Mouthwash_a18b98b9-8c9a-4dae-a069-bed46d0291a1.jpg?v=1771796961",
              "height": 414,
              "width": 656,
              "alt": "Model using mouthwash. Use as directed - results may variy, whitening results are not immediate, staff results"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/mouthwashupsellimage.png?v=1776045233"
              }
            ]
          }
        }
      },
      "content": {
        "productImageBadge": {
          "position": "bottom-left",
          "media": "global"
        },
        "pill": {
          "variant": "information",
          "text": "Best Seller"
        },
        "styleTags": [
          "alt-bulletpoints",
          "amazon-feature"
        ],
        "productOptionSelector": [
          {
            "sku": "10068-PO8"
          }
        ],
        "textBelowProductTitle": "4.3 · 2,784 reviews on Amazon",
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Detoxes_mouth.png?v=1765748912",
              "height": 30,
              "width": 20
            },
            "text": "Freshens <br> breath"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/application-icon.png?v=1755142734",
              "height": 30,
              "width": 20
            },
            "text": "Removes hidden gunk"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Tooth.png?v=1750650505",
              "height": 30,
              "width": 20
            },
            "text": "Helps maintain white teeth"
          }
        ],
        "description": {
          "default": {
            "title": "White. Freshen. Rinse away the gunk.",
            "body": "iD Stain Whitening Mouthwash targets the gunk your toothbrush left behind and pulls it into visible clumps you can actually see in the sink. Powered by hydrogen peroxide and essential oil actives, iD Stain helps maintain white teeth and leaves your mouth feeling seriously fresh from the first rinse.<br><br>\n        <i>*“#1 Mouthwash” based on units sold on TikTok Shop US in the category ‘Beauty & Personal Care - Nasal & Oral Care - Mouthwash’ as at currenat (17/07/2026).</i><br><br>\n        <i>^Based on current reviews on amazon.au as at 16/07/2026 for iD Stain Whitening Mouthwash.</i>",
            "bulletpoints": [
              "Helps Maintain White Teeth",
              "Target gunk in the mouth",
              "Freshen breath at the source"
            ]
          },
          "au": {
            "title": "White. Freshen. Rinse away the gunk.",
            "body": "iD Stain Whitening Mouthwash targets the gunk your toothbrush left behind and pulls it into visible clumps you can actually see in the sink. Powered by hydrogen peroxide and essential oil actives, iD Stain helps maintain white teeth and leaves your mouth feeling seriously fresh from the first rinse. <br><br>\n        <i>*Based on AU Chemist Warehouse sales reported by IQVIA for period 24/08/2022 to 16/07/2026, calculated by reference to the highest number of single-unit mouthwash sales recorded in a single calendar week during the period.</i><br><br>\n        <i>^Based on current reviews on amazon.au as at 16/07/2026 for iD Stain Whitening Mouthwash.</i>",
            "bulletpoints": [
              "Helps Maintain White Teeth",
              "Target gunk in the mouth",
              "Freshen breath at the source"
            ]
          }
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "iD Stain is not your average mouthwash.<br><br>This oral rinse works with your routine to help maintain white teeth, freshen breath, and lift build-up from the areas brushing can miss. As you rinse, the formula interacts with oral debris, pulling them into visible particles you can actually see in the sink. That’s what your toothbrush didn’t catch.<br><br>Use as directed as part of your daily oral care routine. Visible residue is not guaranteed and depends on individual factors. Results may vary between individuals."
              }
            ]
          },
          {
            "title": "Our origin story",
            "content": [
              {
                "head": "Japanese-inspired. Reimagined for the Western world.",
                "body": "We took inspiration from Japan’s popular propolis-based rinses – a post-brushing swish loved for lifting the residue a toothbrush misses and revealing it right in the sink. That idea became our starting point, not our finish line. To make our formula 100% vegan, we removed the propolis and developed our own elevated blend instead, combining essential oil components for freshness, with hydrogen peroxide for whitening maintenance. The result? iD Stain Whitening Mouthwash – inspired by Japanese oral care, reimagined to target and reveal the gunk brushing leaves behind while helping maintain your white smile."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, PEG-40 Hydrogenated Castor Oil, Glycerin, Citric Acid, Sodium Benzoate, Sucralose, Menthol, Flavour/Aroma, Potassium Sorbate, Xylitol, Sodium Citrate, Eucalyptus Globulus Leaf Oil, Hydrogen Peroxide, Sodium Phytate, Thymol, Caramel, Methyl Salicylate."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "1 x iD Stain Whitening Mouthwash <br> Total Net Contents: 237 ml | 8 fl. oz."
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "What Brushing May Miss",
                      "description": "Stain iD Whitening Mouthwash lifts hidden debris from your mouth and shows it back to you. The opaque formula interacts with oral debris, forming visible particles when you spit the mouthwash out. It’s instant proof of what brushing can miss."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_01_-_Stain_Mouthwash.jpg?v=1765345193",
                      "height": 560,
                      "width": 560,
                      "alt": "Trapped impurities"
                    }
                  },
                  {
                    "content": {
                      "title": "Fresh Breath, Whitening Formula",
                      "description": "The formula lifts hidden debris so your mouth feels lighter, cleaner and noticeably fresher. Tongue, cheeks and gum line feel genuinely refreshed. Charged with hydrogen peroxide to help maintain your white smile."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_02_-_Stain_Mouthwash.jpg?v=1765345288",
                      "height": 560,
                      "width": 560,
                      "alt": "Stain ID Whitening Mouthwash"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "ALT_TOOTH_ARMOUR@tooth-armour-b",
    {
      "attributes": {
        "sku": "ALT_TOOTH_ARMOUR",
        "productHandle": "tooth-armour-b",
        "categoryDetails": {
          "primaryCategory": "tooth-armour"
        },
        "age": 10
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Tooth_Armour_-_CWH_-_PP_c7ad6c4f-0fa5-42f5-8474-50ba528d443c.png?v=1784243558",
              "height": 512,
              "width": 352,
              "alt": "#1 fluoride-free toothpaste by revenue at Chemist Warehouse Australia"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 512,
              "width": 352,
              "alt": "Visualisation of Tooth Armour Toothpaste Serum being applied to toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 512,
              "width": 352,
              "alt": "Microscopic Visualisation of Nano-Hydroxyapatite on teeth"
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/b7e01de4063d4e7cb868f4ea1225ff42.mp4",
              "height": 512,
              "width": 352,
              "alt": "Tooth Armour Toothpaste Serum video"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 414,
              "width": 656,
              "alt": "Key points about Tooth Armour Toothpaste Serum"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "styleTags": [
          "alt-bulletpoints"
        ],
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Shield_Icon_d970d5d6-c449-40a3-81d3-ac30fc9a53d2.png?v=1774930587",
              "height": 45,
              "width": 30
            },
            "text": "Nano- <br>Hydroxyapatite",
            "customHeight": 45,
            "customWidth": 30
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Replace_Toothpaste_Icon_2.png?v=1774930580",
              "height": 45,
              "width": 30
            },
            "text": "Replace Your <br> Toothpaste",
            "customHeight": 45,
            "customWidth": 30
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/dna_emoji_png_6186eebf-e3f6-41b8-a69f-2a787d86b28b.png?v=1774934225",
              "height": 45,
              "width": 30
            },
            "text": "Supercharged <br> Vitamin Formula",
            "customHeight": 45,
            "customWidth": 30
          }
        ],
        "description": {
          "title": "White. Freshen. Rinse away the gunk.",
          "body": "<i>*Through mechanical action with regular brushing</i><br><br>\n      Tooth Armour elevates your oral care. Powered by NH-10, a concentrated blend of 6 actives including Nano-Hydroxyapatite, an ingredient engineered to mirror the mineral your enamel is mostly made of, together with Hydrated Silica, Xylitol, Hyaluronic Acid, Niacinamide (Vitamin B3) and Zinc Gluconate. Add Tooth Armour to your existing toothpaste or use it on its own. Either way, your routine just got a serious upgrade.<br><br>\n      <i>^Based on AU Chemist Warehouse toothpaste revenue reported by IQVIA for the period 27/05/2026 to 15/07/2026. Claim is based on the highest-ranked toothpaste by revenue during the period that does not contain fluoride.</i>",
          "bulletpoints": [
            "<strong>Powered with Nano-Hydroxyapatite</strong>, an ingredient engineered to mirror the mineral that makes up 97% of your enamel.",
            "<strong>6 actives.</strong> 1 serum.",
            "Helps maintain <strong>white teeth*</strong>"
          ]
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "Tooth Armour is a toothpaste serum, designed to be used as part of your daily brushing routine. Add to your regular toothpaste or use on its own. Brush for 2 minutes, then expel.<br><br>Use as directed as part of your oral care routine. Any benefits associated with Tooth Armour are derived from continued daily use, together with a good oral care routine."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, Glycerin, Hydrated Silica, Hydroxyapatite (nano), Xylitol, Sodium Hyaluronate, Niacinamide, Zinc Gluconate, Hydroxyethylcellulose, Silica, Caprylyl Glycol, 1,2-Hexanediol, Hydroxypropyl Methylcellulose, Potassium Chloride, Lauryl Glucoside, Flavour/Aroma, Sucralose, Carmine (CI 75470) , Menthol, Carvone, Mentha Piperita Oil, Anethole."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "1 x Tooth Armour Toothpaste Serum<br>Total Net Contents: 20 ml | 0.67 fl. oz."
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "The Upgrade Your Routine Wants",
                      "description": "A few drops directly to your brush, or layered over your regular toothpaste. Tooth Armour introduces advanced actives to your oral care routine - and it's never looked better for it."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_01_-_Tooth_Armour_6fff633b-4e8a-4e56-a2f7-e799007040a3.png?v=1774326787",
                      "height": 560,
                      "width": 560,
                      "alt": "Tooth Armour Toothpaste Serum"
                    }
                  },
                  {
                    "content": {
                      "title": "Advanced Enamel Support",
                      "description": "Tooth Armour includes Nano-Hydroxyapatite, an enamel-like mineral, mimicking a key component naturally found in your tooth's external structure."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_02_-_Tooth_Armour_51bfa066-2a18-4e2c-8e8d-bcb7987dd2f1.png?v=1774326788",
                      "height": 560,
                      "width": 560,
                      "alt": "Microscopic Visualisation of Nano-Hydroxyapatite on teeth"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "battery-electric-toothbrush@battery-electric-toothbrush",
    {
      "attributes": {
        "sku": "battery-electric-toothbrush",
        "productHandle": "battery-electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/v34Serum-ProductPage_26e00517-a733-41a0-8a04-d641a41b7385.png?v=1746740211",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/a2f06b7d355b41f88ef393dfb5c05f49.mp4",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-3_a7237219-45b8-4c7b-9fe2-5603c693848f.jpg?v=1746740235",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-4_fb5dab33-b8df-429c-bd4c-9861f332f1d7.jpg?v=1746740248",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/05-V34-PP_3e81af6e-fdf8-48dc-9b3c-b9b1f36a7fa7.jpg?v=1746740253",
              "height": 512,
              "width": 352
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "featureImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/LipBalmBundle-Cart.png?v=1734578273",
            "height": 500,
            "width": 500
          }
        }
      },
      "content": {
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 30
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 30
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 30
            },
            "text": "Flavour & <br> freshness"
          }
        ],
        "productAccordions": [
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Barbie Pink Bubblegum Toothpaste. Total Net Contents: 60g | 2.1 oz"
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, Sorbitol, Glycerin"
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-media",
            "location": "section-below-the-fold",
            "props": {
              "assets": {
                "default": [
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_01_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_01_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 712,
                      "alt": "Barbie"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_02_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste on the Barbie Electric Toothbrush"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_02_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 712,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste on the Barbie Electric Toothbrush"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_03_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste Bottle"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_03_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 1440,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste Bottle"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "BEST_SELLER_3_PACK@best-seller-bundle-3-pack",
    {
      "attributes": {
        "sku": "BEST_SELLER_3_PACK",
        "productHandle": "best-seller-bundle-3-pack"
      },
      "media": {
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Cart-BSBB-3Pack.png?v=1781146755",
            "height": 100,
            "width": 100,
            "alt": "3 pack"
          }
        }
      },
      "content": {}
    }
  ],
  [
    "BEST_SELLER_5_PACK@best-seller-bundle-5-pack",
    {
      "attributes": {
        "sku": "BEST_SELLER_5_PACK",
        "productHandle": "best-seller-bundle-5-pack"
      },
      "media": {
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Cart-BSBB-5Pack.png?v=1781146773",
            "height": 100,
            "width": 100,
            "alt": "5 pack"
          }
        }
      },
      "content": {}
    }
  ],
  [
    "BEST_SELLER_7_PACK@best-seller-bundle-7-pack",
    {
      "attributes": {
        "sku": "BEST_SELLER_7_PACK",
        "productHandle": "best-seller-bundle-7-pack"
      },
      "media": {
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Cart-BSBB-7Pack.png?v=1781146792",
            "height": 100,
            "width": 100,
            "alt": "7 pack"
          }
        }
      },
      "content": {}
    }
  ],
  [
    "BEST_SELLER_BUNDLE@best-seller-bundle",
    {
      "attributes": {
        "sku": "BEST_SELLER_BUNDLE",
        "productHandle": "best-seller-bundle",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-01-DDB_b22b27a4-fa22-473c-8066-dfe3bead94e7.gif?v=1747004928",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-02-DDB_c7aa7f94-fe46-483a-8b22-fbebde7ddf57.png?v=1747004925",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-03-DDB_b34485bd-b41f-4889-a2b1-5c5f6bb84259.png?v=1747004923",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-04-DDB_46570463-be82-4901-847e-3c6de26a8b6f.png?v=1747004920",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-05-DDB_997a11a1-c693-4aea-93bd-09588d4dc73a.png?v=1747004921",
              "height": 897,
              "width": 1400
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Collection_-_BSBB_-_Double.png?v=1781226007",
            "height": 368,
            "width": 616
          },
          "ca": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Collection_-_BSBB_-_Double_-_CA.png?v=1781227951",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          }
        ],
        "productAccordions": [
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Barbie Pink Bubblegum Toothpaste. Total Net Contents: 60g | 2.1 oz"
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-media",
            "location": "section-below-the-fold",
            "props": {
              "images": {
                "default": [
                  {
                    "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/BTF_-_01_-_Blue_Raspberry_Lip_Balm.png?v=1734328253",
                    "height": 600,
                    "width": 414,
                    "alt": "Model holding bottle of Blue Raspberry Lip Balm"
                  },
                  {
                    "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/BTF_-_02_-_Blue_Raspberry_Lip_Balm.png?v=1734328253",
                    "height": 600,
                    "width": 414,
                    "alt": "Blue Raspberry Lip Balm with Blue Raspberries"
                  },
                  {
                    "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/BTF_-_03_-_Blue_Raspberry_Lip_Balm_-_D.png?v=1734328253",
                    "height": 1000,
                    "width": 1440,
                    "alt": "Blue Raspberry Lip Balm in glossy blue"
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "BUNDLE-DAILY_DUO_BUNDLE@bundle-product-daily-duo",
    {
      "attributes": {
        "sku": "BUNDLE-DAILY_DUO_BUNDLE",
        "productHandle": "bundle-product-daily-duo",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-01-DDB_b22b27a4-fa22-473c-8066-dfe3bead94e7.gif?v=1747004928",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-02-DDB_c7aa7f94-fe46-483a-8b22-fbebde7ddf57.png?v=1747004925",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-03-DDB_b34485bd-b41f-4889-a2b1-5c5f6bb84259.png?v=1747004923",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-04-DDB_46570463-be82-4901-847e-3c6de26a8b6f.png?v=1747004920",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-05-DDB_997a11a1-c693-4aea-93bd-09588d4dc73a.png?v=1747004921",
              "height": 512,
              "width": 352
            }
          ]
        }
      },
      "content": {
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          }
        ],
        "productAccordions": [
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Barbie Pink Bubblegum Toothpaste. Total Net Contents: 60g | 2.1 oz"
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-media",
            "location": "section-below-the-fold",
            "props": {
              "assets": {
                "default": [
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_01_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_01_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 712,
                      "alt": "Barbie"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_02_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste on the Barbie Electric Toothbrush"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_02_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 712,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste on the Barbie Electric Toothbrush"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_03_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste Bottle"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_03_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 1440,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste Bottle"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "DAILY_WHITENING_BUNDLE@daily-whitening-bundle",
    {
      "attributes": {
        "sku": "DAILY_WHITENING_BUNDLE",
        "productHandle": "daily-whitening-bundle",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-01-DDB_b22b27a4-fa22-473c-8066-dfe3bead94e7.gif?v=1747004928",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-02-DDB_c7aa7f94-fe46-483a-8b22-fbebde7ddf57.png?v=1747004925",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-03-DDB_b34485bd-b41f-4889-a2b1-5c5f6bb84259.png?v=1747004923",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-04-DDB_46570463-be82-4901-847e-3c6de26a8b6f.png?v=1747004920",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-05-DDB_997a11a1-c693-4aea-93bd-09588d4dc73a.png?v=1747004921",
              "height": 512,
              "width": 352
            }
          ]
        }
      },
      "content": {
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          }
        ],
        "productAccordions": [
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Barbie Pink Bubblegum Toothpaste. Total Net Contents: 60g | 2.1 oz"
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-media",
            "location": "section-below-the-fold",
            "props": {
              "images": {
                "default": [
                  {
                    "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/BTF_-_01_-_Barbie_Pink_Bubblegum_Lip_Balm.png?v=1734328271",
                    "height": 600,
                    "width": 414,
                    "alt": "Model holding bottle of Barbie Pink Bubblegum Lip Balm"
                  },
                  {
                    "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/BTF_-_02_-_Barbie_Pink_Bubblegum_Lip_Balm_1d08a712-5d24-4cfc-8408-63918dafbf07.png?v=1736125511",
                    "height": 600,
                    "width": 414,
                    "alt": "Barbie Pink Bubblegum Lip Balm with shiny pink balls"
                  },
                  {
                    "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/BTF_-_03_-_Barbie_Pink_Bubblegum_Lip_Balm_-_D.png?v=1734328272",
                    "height": 1000,
                    "width": 1440,
                    "alt": "Barbie Pink Bubblegum Lip Balm on Glossy Pink"
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "electric-toothbrush@electric-toothbrush",
    {
      "attributes": {
        "sku": "electric-toothbrush",
        "productHandle": "electric-toothbrush",
        "categoryDetails": {
          "primaryCategory": "electric-toothbrush"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/v34Serum-ProductPage_26e00517-a733-41a0-8a04-d641a41b7385.png?v=1746740211",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/a2f06b7d355b41f88ef393dfb5c05f49.mp4",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-3_a7237219-45b8-4c7b-9fe2-5603c693848f.jpg?v=1746740235",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-4_fb5dab33-b8df-429c-bd4c-9861f332f1d7.jpg?v=1746740248",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/05-V34-PP_3e81af6e-fdf8-48dc-9b3c-b9b1f36a7fa7.jpg?v=1746740253",
              "height": 512,
              "width": 352
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          }
        ],
        "productAccordions": [
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Barbie Pink Bubblegum Toothpaste. Total Net Contents: 60g | 2.1 oz"
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-media",
            "location": "section-below-the-fold",
            "props": {
              "assets": {
                "default": [
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_01_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_01_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 712,
                      "alt": "Barbie"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_02_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste on the Barbie Electric Toothbrush"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_02_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 712,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste on the Barbie Electric Toothbrush"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_03_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste Bottle"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_03_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 1440,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste Bottle"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "ES_BEST_SELLER_3_PACK@paquete-mas-vendido-3-pack",
    {
      "attributes": {
        "sku": "ES_BEST_SELLER_3_PACK",
        "productHandle": "paquete-mas-vendido-3-pack"
      },
      "media": {
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Cart-BSBB-3Pack.png?v=1781146755",
            "height": 100,
            "width": 100,
            "alt": "Pack de 3"
          }
        }
      },
      "content": {}
    }
  ],
  [
    "ES_BEST_SELLER_5_PACK@paquete-mas-vendido-5-pack",
    {
      "attributes": {
        "sku": "ES_BEST_SELLER_5_PACK",
        "productHandle": "paquete-mas-vendido-5-pack"
      },
      "media": {
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Cart-BSBB-5Pack.png?v=1781146773",
            "height": 100,
            "width": 100,
            "alt": "Pack de 5"
          }
        }
      },
      "content": {}
    }
  ],
  [
    "ES_BEST_SELLER_7_PACK@paquete-mas-vendido-7-pack",
    {
      "attributes": {
        "sku": "ES_BEST_SELLER_7_PACK",
        "productHandle": "paquete-mas-vendido-7-pack"
      },
      "media": {
        "selectorImage": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Cart-BSBB-7Pack.png?v=1781146792",
            "height": 100,
            "width": 100,
            "alt": "Pack de 7"
          }
        }
      },
      "content": {}
    }
  ],
  [
    "ES_BEST_SELLER_BUNDLE@paquete-mas-vendido",
    {
      "attributes": {
        "sku": "ES_BEST_SELLER_BUNDLE",
        "productHandle": "paquete-mas-vendido",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-01-DDB_b22b27a4-fa22-473c-8066-dfe3bead94e7.gif?v=1747004928",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-02-DDB_c7aa7f94-fe46-483a-8b22-fbebde7ddf57.png?v=1747004925",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-03-DDB_b34485bd-b41f-4889-a2b1-5c5f6bb84259.png?v=1747004923",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-04-DDB_46570463-be82-4901-847e-3c6de26a8b6f.png?v=1747004920",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-05-DDB_997a11a1-c693-4aea-93bd-09588d4dc73a.png?v=1747004921",
              "height": 897,
              "width": 1400
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Collection_-_BSBB_-_Double_-_Spanish_708cf18b-ad8a-4ff0-853c-7647026e263c.png?v=1788328226",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "customButtonText": "Añadir al carrito"
      }
    }
  ],
  [
    "ES_V34_STRIPS@tiras-blanqueadoras-v34",
    {
      "attributes": {
        "sku": "ES_V34_STRIPS",
        "productHandle": "tiras-blanqueadoras-v34",
        "categoryDetails": {
          "primaryCategory": "v34-whitening-strips"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-01-Spanish-V34Strips.jpg?v=1773788610",
              "height": 512,
              "width": 352,
              "alt": "Best Selling V34 Whitening Strips"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-02-Spanish-V34Strips.jpg?v=1773788633",
              "height": 512,
              "width": 352,
              "alt": "In a study, 96% of participants had 2 or more shades whiter teeth*"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-03-Spanish-V34Strips.jpg?v=1773788633",
              "height": 512,
              "width": 352,
              "alt": "Top teeth results"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-04-Spanish-V34Strips.jpg?v=1773788633",
              "height": 512,
              "width": 352,
              "alt": "Amazon reviews"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-05-Spanish-V34Strips.jpg?v=1773788633",
              "height": 414,
              "width": 656,
              "alt": "Before. Apply. After. Strips"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "styleTags": [
          "alt-bulletpoints",
          "selling-fast-pill",
          "blue-atc-button"
        ],
        "customButtonText": "Añadir al carrito",
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/money-icon.png?v=1755142733",
              "height": 30,
              "width": 20
            },
            "text": "Garantía de<br>devolución del<br>dinero"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/application-icon.png?v=1755142734",
              "height": 30,
              "width": 20
            },
            "text": "$2.50 por cada<br> aplicación"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Tooth.png?v=1750650505",
              "height": 30,
              "width": 20
            },
            "text": "Expertos en<br>blanqueamientos"
          }
        ],
        "description": {
          "title": "Whiter teeth after just one use.",
          "body": "",
          "bulletpoints": [
            "Dientes más blancos después de <strong style=\"font-weight: 500\">un solo uso*</strong>",
            "¿No está satisfecho? <strong style=\"font-weight: 500\">¡Te devolvemos tu dinero!^</strong>",
            "Blanqueamiento después de <strong style=\"font-weight: 500\">30 minutos*</strong>"
          ]
        },
        "productAccordions": [
          {
            "title": "¿Cómo funcionan las tiras V34?",
            "content": [
              {
                "body": "Esta innovadora tecnología de doble activo es diferente a los productos blanqueadores que encuentras en el supermercado. Combina la corrección de color instantánea de V34, que proporciona una mejora visual temporal, con el blanqueamiento PAP+ para tratar las manchas superficiales y lograr resultados visibles.<br><br>Incluye 14 aplicaciones individuales."
              }
            ]
          },
          {
            "title": "Lista de ingredientes",
            "content": [
              {
                "body": "Glicerina, Aqua/Agua, Goma de celulosa, Hidroxipropilmetilcelulosa, Ácido ftalimidoperoxicaproico, EDTA disódico, Hidróxido de sodio, Mentol, Citrato monosódico, Goma xantana, Copolímero PVM/MA, C12-15 Pareth-3, Rojo D&C n.° 33 (CI 17200), Azul FD&C n.° 1 (CI 42090)."
              }
            ]
          },
          {
            "title": "^Garantía de devolución de dinero",
            "content": [
              {
                "body": "Hismile ofrece una garantía de devolución de dinero para las tiras blanqueadoras V34. Estamos seguros de que te encantará el producto, pero si no quedas satisfecho, te reembolsaremos el precio de compra (sin incluir los gastos de envío), sujeto a los términos y condiciones.<br><br>Esta oferta solo aplica a las compras realizadas a través de www.hismileteeth.com. Las solicitudes de devolución deben enviarse dentro de los siete (7) días posteriores a la recepción de su pedido. Los clientes son responsables de los gastos de envío de la devolución. Esta oferta se suma a cualquier derecho que le corresponda según las leyes de protección al consumidor aplicables.<br><br>Los términos y condiciones completos, incluidas las instrucciones sobre cómo realizar la reclamación, se pueden encontrar <a style=\"text-decoration: underline\" href='/pages/terms-conditions'>aqui</a>."
              }
            ]
          },
          {
            "title": "*Probado para obtener resultados",
            "content": [
              {
                "body": "\n                Las tiras blanqueadoras V34 de Hismile fueron evaluadas en un estudio clínico ciego, controlado con placebo, con 60 participantes, analizados inmediatamente después y 24 horas tras una aplicación de 30 minutos.<br><br>Después de la aplicación, todos los participantes presentaron una mejora de 2 o más tonos. A las 24 horas, el 96% de los participantes mostró una mejora de 2 o más tonos.Las evaluaciones se basaron en la escala VITA Bleachguide 3D-MASTER®.<br><br>Los resultados no están garantizados para todas las personas y pueden variar. Los resultados inmediatos son temporales y el blanqueamiento no es permanente. \n                "
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "¿Tienes preguntas? Tenemos las respuestas.",
          "accordions": [
            {
              "title": "¿Cuántos tonos diferentes debería ver?",
              "content": [
                {
                  "body": "Los resultados varían, algunos ven una diferencia visible después de un solo uso, siendo estos los efectos temporales de corrección de color."
                }
              ]
            },
            {
              "title": "¿Cómo los utilizo?",
              "content": [
                {
                  "body": "Comience por secar bien sus dientes. Aplique la tira larga V34 en los dientes superiores, presionando firmemente para que se adhiera bien. Repita el procedimiento con la tira corta en los dientes inferiores. Deje las tiras puestas durante 30 minutos para que la fórmula de doble acción haga efecto. Retire las tiras, cepille cualquier residuo morado restante y enjuague si es necesario."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "ETB_VALUE_PACK@electric-toothbrush-value-pack",
    {
      "attributes": {
        "sku": "ETB_VALUE_PACK",
        "productHandle": "electric-toothbrush-value-pack",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_VALUE_PACK_BLACK.png?v=1785127096"
              }
            ],
            "us": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_VALUE_PACK_PURPLE.png?v=1785127093"
              }
            ],
            "eu": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/ETB_VALUE_PACK_PURPLE.png?v=1785127093"
              }
            ]
          }
        }
      },
      "content": {}
    }
  ],
  [
    "FREE_MYSTERY_GIFT@free-mystery-gift",
    {
      "attributes": {
        "sku": "FREE_MYSTERY_GIFT",
        "productHandle": "free-mystery-gift",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "FREE_V34_SERUM@free-v34-serum",
    {
      "attributes": {
        "sku": "FREE_V34_SERUM",
        "productHandle": "free-v34-serum",
        "categoryDetails": {
          "primaryCategory": "colour-corrector"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01-V34ColourCorrector-PP.jpg?v=1759817336",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/a2f06b7d355b41f88ef393dfb5c05f49.mp4",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-3_a7237219-45b8-4c7b-9fe2-5603c693848f.jpg?v=1746740235",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-4_fb5dab33-b8df-429c-bd4c-9861f332f1d7.jpg?v=1746740248",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/05-V34-PP_3e81af6e-fdf8-48dc-9b3c-b9b1f36a7fa7.jpg?v=1746740253",
              "height": 1536,
              "width": 2160
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "description": {
          "title": "Utilises colour correction technology",
          "body": "V34 Colour Corrector Serum is a teeth whitener and brightener that's peroxide-free, designed to work exactly like concealer, but for your teeth. Using colour correcting technology, it’s designed to temporarily conceal the yellow tones in your teeth to reveal a perceivably whiter smile. The results are entirely on the tooth surface, and it’s a non-invasive alternative to bleaching!",
          "bulletpoints": []
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/a4b3fd07d12bb98c276b9ee37f0b4a01.svg?v=1685928674",
              "height": 30,
              "width": 20
            },
            "text": "Colour correcting <br> technology"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1685928673",
              "height": 30,
              "width": 20
            },
            "text": "Brightening <br> boost"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Non-invasive <br> treatment"
          }
        ],
        "productAccordions": [
          {
            "title": "How does V34 Colour Corrector work?",
            "content": [
              {
                "body": "V34 Colour Corrector Serum is your go-to for a brightening and whitening boost, using colour correction to temporarily enhance the appearance of your smile! The results are entirely on the tooth surface, and it’s a non-invasive alternative to bleaching. Re-apply the V34 Serum as needed, individual results may vary."
              }
            ]
          },
          {
            "title": "How and when should I use V34 Colour Corrector Serum?",
            "content": [
              {
                "body": "The best results are achieved with direct application of the V34 Serum through a tool such as a cotton swab or soft bristled toothbrush. It’s important to gently polish the serum onto your teeth for 30 seconds, specifically focusing on the spots that are the most yellow, before wiping the leftover residue or rinsing with water if needed. V34 Serum can be reapplied as needed, and is recommended just before going out as a temporary concealer for yellow tones and a whitening boost to your smile."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x V34 Colour Corrector Serum<br>Total Net Contents: 30ml | 1 fl oz"
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Glycerin, Aqua/Water, Sorbitol, Hydrated Silica, Xylitol, Polysorbate 80, Cellulose Gum, Mentha Piperita (Peppermint) Oil, Phenoxyethanol, Sucralose, Tetrasodium Pyrophosphate, CI17200/D&C Red No. 33, CI42090/FD&C Blue No.1, Ethylhexylglycerin."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "What is V34 Colour Corrector Serum?",
              "content": [
                {
                  "body": "V34 Serum is a temporary teeth whitener that’s designed to work exactly like a concealer, but for your teeth. Using colour correcting technology, it's designed to conceal the yellow tones in your teeth to improve and enhance the perceived brightness and whiteness of your smile.<br><br>V34 Serum is for people who have yellow tones in their teeth and are looking for a concealer that can be applied as often as needed to temporarily reduce the appearance of yellow tones, leaving you with a perceivably whiter smile. If you are looking for a longer term whitening product, check out our <a style=\"text-decoration: underline\" href=\"/products/whitening-strips\">PAP+ Whitening Strips</a>"
                }
              ]
            },
            {
              "title": "Can I use V34 with veneers, caps, implants, bridges, or bonded teeth?",
              "content": [
                {
                  "body": "V34 is perfectly safe to be used on dental work as it is a non-abrasive form of whitening, however we would recommend to avoid brushing it onto these teeth, as only natural teeth can be colour-corrected.<br><br>We always advise checking with your dentist before using, to ensure it is a suitable product for you."
                }
              ]
            }
          ]
        },
        "customComponents": [
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "Heard of purple shampoo? Bet you haven't tried it for your teeth. Here's how it works:",
                      "description": "Colour correction all starts on the colour wheel, where purple and yellow are complementary colours opposite to each other. Using a similar concept to purple shampoo, applying purple onto your teeth can temporarily neutralise the yellow undertones to conceal them, revealing a perceptively whiter shade. Pretty cool right?"
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/v34_Toothbrush_Drip.mp4?v=1632715790",
                      "height": 560,
                      "width": 560,
                      "alt": "V34 Colour Corrector Serum on toothbrush"
                    }
                  },
                  {
                    "content": {
                      "title": "We developed the perfect shade of deep violet purple, that neutralises yellow.",
                      "description": "V34 Serum is the perfect non-invasive whitening boost designed to temporarily conceal those pesky yellow stains. The best part is that it acts entirely on the tooth surface!"
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/V34_-_Content_-_Block_-_1.jpg?v=1632715890",
                      "height": 560,
                      "width": 560,
                      "alt": "Colour corrected teeth covered in V34 Colour Corrector Serum and home teeth whitened"
                    }
                  },
                  {
                    "content": {
                      "title": "Want a daily whitener that works in 30-seconds? V34 is for you",
                      "description": "A convenient solution designed for daily use, the same way you would use a concealer for your skin. Re-apply as needed for your go-to whitening boost!"
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/v34_UGC_Below_the_Fold.mp4?v=1632961072",
                      "height": 560,
                      "width": 560
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "LIP_BALM_BUNDLE@lip-balm-bundle",
    {
      "attributes": {
        "sku": "LIP_BALM_BUNDLE",
        "productHandle": "lip-balm-bundle",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {},
      "content": {}
    }
  ],
  [
    "MOUTH_RESET_BUNDLE@mouth-reset-bundle",
    {
      "attributes": {
        "sku": "MOUTH_RESET_BUNDLE",
        "productHandle": "mouth-reset-bundle",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_01_-_Mouth_Detox.png?v=1789531313",
              "height": 512,
              "width": 352,
              "alt": "Tooth Armour Toothpaste Serum and iD Stain Mouthwash with Packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_02_-_Mouth_Detox.png?v=1789531313",
              "height": 512,
              "width": 352,
              "alt": "iD Mouthwash bottle pictured, new product."
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_03_-_Mouth_Detox.png?v=1789531314",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_04_-_Mouth_Detox.png?v=1789531313",
              "height": 512,
              "width": 352,
              "alt": "Tooth armour powered with Nano-Hydroxyapatite"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_05_-_Mouth_Detox.png?v=1789531313",
              "height": 414,
              "width": 656,
              "alt": "Tooth armour and id Mouthwash benefits"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Collection_-_Whitening_Protocol_-_Double-Wide.png?v=1789531313",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "styleTags": [
          "show-value"
        ],
        "disclaimer": "*Value based on full price of products purchased separately.",
        "description": {
          "default": {
            "title": "Mouth Reset Bundle",
            "body": "Bundle and save 50% on this offer^, which targets the whole mouth and lasting freshness.<br><br><span style=\"font-weight: 500;\">What's in the Bundle:</span><br><br>\n<span style=\"font-weight: 500;\">iD Stain Whitening Mouthwash:</span> iD Stain is not your average mouthwash. As you rinse, the formula binds to gunk and oral residue in your mouth, pulling them into visible particles you can actually see in the sink, that's what your toothbrush didn't catch. Hydrogen peroxide maintains your white smile from the very first rinse, while essential oil actives leave your mouth feeling cleaner and fresher.\n<ul>\n<li>Helps Maintain White Teeth</li>\n<li>Removes gunk and oral residue</li>\n<li>Essential oils for a lasting fresh feeling</li>\n</ul>\n<span style=\"font-weight: 500;\">Tooth Armour Toothpaste Serum:</span> Tooth Armour is engineered to elevate your oral care. Powered by NH-10, a concentrated blend of 6 actives including Nano-Hydroxyapatite, together with hydrated silica, xylitol, hyaluronic acid, niacinamide, and zinc gluconate. Add it to your existing toothpaste or use alone. Either way, it's the upgrade your routine has been missing.\n<ul>\n<li>Powered with Nano-Hydroxyapatite, an ingredient engineered to mirror the mineral that makes up 97% of your enamel</li>\n<li>Supports strong teeth, and a hydrated mouth</li>\n<li>Works with your current routine or as a standalone</li>\n</ul>\n<br>\nSee individual product pages for full product information.\n<br><br>\n^\"Save 50%\" in this bundle compared to purchasing items individually at full price."
          }
        },
        "productAccordions": [
          {
            "title": "What's included",
            "content": {
              "default": [
                {
                  "body": "1x iD Stain Whitening Mouthwash {{10068-PO}}<br>\n              1x Tooth Armour Toothpaste Serum {{10065-TA}}\n              "
                }
              ]
            }
          },
          {
            "title": "List of ingredients",
            "content": {
              "default": [
                {
                  "head": "iD Stain Whitening Mouthwash",
                  "body": "\n              Aqua/Water, PEG-40 Hydrogenated Castor Oil, Glycerin, Citric Acid, Sodium Benzoate, Sucralose, Menthol, Flavour/Aroma, Potassium Sorbate, Xylitol, Sodium Citrate, Eucalyptus Globulus Leaf Oil, Hydrogen Peroxide, Sodium Phytate, Thymol, Caramel, Methyl Salicylate.\n              "
                },
                {
                  "head": "Tooth Armour Toothpaste Serum",
                  "body": "Aqua/Water, Glycerin, Hydrated Silica, Hydroxyapatite (nano), Xylitol, Sodium Hyaluronate, Niacinamide, Zinc Gluconate, Hydroxyethylcellulose, Silica, Caprylyl Glycol, 1,2-Hexanediol, Hydroxypropyl Methylcellulose, Potassium Chloride, Lauryl Glucoside, Flavour/Aroma, Sucralose, Carmine (CI 75470) , Menthol, Carvone, Mentha Piperita Oil, Anethole."
                }
              ]
            }
          }
        ]
      }
    }
  ],
  [
    "MOUTHWASH_TRIPLE_VALUE_SET@mouthwash-triple-value-set",
    {
      "attributes": {
        "sku": "MOUTHWASH_TRIPLE_VALUE_SET",
        "productHandle": "mouthwash-triple-value-set",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_01_-_Mouthwash_Triple_Value_Set.png?v=1783547729",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Stain_Mouthwash_-_PP.png?v=1784864978",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04-Stain_Mouthwash-PP-20260127_86d7fc7b-1ef9-4c27-a4f7-207165db39c9.png?v=1771796961",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03-Stain_Mouthwash-PP_9e9530c6-4c66-4cb3-9caf-284f8796ff9d.jpg?v=1771983369",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-05-Stain_Mouthwash_a18b98b9-8c9a-4dae-a069-bed46d0291a1.jpg?v=1771796961",
              "height": 414,
              "width": 656
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Collection_-_Mouthwash_Triple_Value_Set_-_Double-Wide.png?v=1784775996",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "disclaimer": "*Value based on full price of 3 Mouthwashes purchased separately.",
        "styleTags": [
          "show-value",
          "alt-bulletpoints"
        ],
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Detoxes_mouth.png?v=1765748912",
              "height": 30,
              "width": 20
            },
            "text": "Freshens <br> breath"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/application-icon.png?v=1755142734",
              "height": 30,
              "width": 20
            },
            "text": "Removes hidden gunk"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Tooth.png?v=1750650505",
              "height": 30,
              "width": 20
            },
            "text": "Helps maintain white teeth"
          }
        ],
        "description": {
          "title": "White. Freshen. Rinse away the gunk.",
          "body": "iD Stain Whitening Mouthwash targets the gunk your toothbrush left behind and pulls it into visible clumps you can actually see in the sink. Powered by hydrogen peroxide and essential oil actives, iD Stain helps maintain white teeth and leaves your mouth feeling seriously fresh from the first rinse.<br><br>Not after a value pack? You can buy a single mouthwash at full price  <a href=\"/products/id-stain-mouthwash\" style=\"text-decoration: underline;\">here</a>.",
          "bulletpoints": [
            "Helps Maintain White Teeth",
            "Target gunk in the mouth",
            "Freshen breath at the source"
          ]
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "iD Stain is not your average mouthwash.<br><br>This oral rinse works with your routine to help maintain white teeth, freshen breath, and lift build-up from the areas brushing can miss. As you rinse, the formula interacts with oral debris, pulling them into visible particles you can actually see in the sink. That’s what your toothbrush didn’t catch.<br><br>Use as directed as part of your daily oral care routine. Visible residue is not guaranteed and depends on individual factors. Results may vary between individuals."
              }
            ]
          },
          {
            "title": "Our origin story",
            "content": [
              {
                "head": "Japanese-inspired. Reimagined for the Western world.",
                "body": "We took inspiration from Japan’s popular propolis-based rinses – a post-brushing swish loved for lifting the residue a toothbrush misses and revealing it right in the sink. That idea became our starting point, not our finish line. To make our formula 100% vegan, we removed the propolis and developed our own elevated blend instead, combining essential oil components for freshness, with hydrogen peroxide for whitening maintenance. The result? iD Stain Whitening Mouthwash – inspired by Japanese oral care, reimagined to target and reveal the gunk brushing leaves behind while helping maintain your white smile."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, PEG-40 Hydrogenated Castor Oil, Glycerin, Citric Acid, Sodium Benzoate, Sucralose, Menthol, Flavour/Aroma, Potassium Sorbate, Xylitol, Sodium Citrate, Eucalyptus Globulus Leaf Oil, Hydrogen Peroxide, Sodium Phytate, Thymol, Caramel, Methyl Salicylate."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "3 x iD Stain Whitening Mouthwash <br> Total Net Contents: 237 ml | 8 fl. oz."
              }
            ]
          }
        ]
      }
    }
  ],
  [
    "MOUTHWASH_VALUE_SET@mouthwash-value-set",
    {
      "attributes": {
        "sku": "MOUTHWASH_VALUE_SET",
        "productHandle": "mouthwash-value-set",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_01_-_Mouthwash_Value_Set.png?v=1780362419",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Stain_Mouthwash_-_PP.png?v=1784864978",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04-Stain_Mouthwash-PP-20260127_86d7fc7b-1ef9-4c27-a4f7-207165db39c9.png?v=1771796961",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03-Stain_Mouthwash-PP_9e9530c6-4c66-4cb3-9caf-284f8796ff9d.jpg?v=1771983369",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-05-Stain_Mouthwash_a18b98b9-8c9a-4dae-a069-bed46d0291a1.jpg?v=1771796961",
              "height": 414,
              "width": 656
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Collection_-_Mouthwash_Value_Set_-_Double-Wide.png?v=1784508632",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "pill": {
          "variant": "promotion",
          "text": "2 FREE PRODUCTS"
        },
        "styleTags": [
          "price-asterisk",
          "alt-bulletpoints"
        ],
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Detoxes_mouth.png?v=1765748912",
              "height": 30,
              "width": 20
            },
            "text": "Freshens <br> breath"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/application-icon.png?v=1755142734",
              "height": 30,
              "width": 20
            },
            "text": "Removes hidden gunk"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Tooth.png?v=1750650505",
              "height": 30,
              "width": 20
            },
            "text": "Helps maintain white teeth"
          }
        ],
        "description": {
          "title": "",
          "body": "Not after a value pack? You can buy a single mouthwash at full price  <a href=\"/products/id-stain-mouthwash\" style=\"text-decoration: underline;\">here</a>.",
          "bulletpoints": [
            "Helps Maintain White Teeth",
            "Target gunk in the mouth",
            "Freshen breath at the source"
          ]
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "iD Stain is not your average mouthwash. <br><br>This oral rinse works with your routine to help maintain white teeth, freshen breath, and lift build-up from the areas brushing can miss. As you rinse, the formula interacts with oral debris, pulling them into visible particles you can actually see in the sink. That’s what your toothbrush didn’t catch.<br><br>Use as directed as part of your daily oral care routine. Visible residue is not guaranteed and depends on individual factors. Results may vary between individuals."
              }
            ]
          },
          {
            "title": "Our origin story",
            "content": [
              {
                "head": "Japanese-inspired. Reimagined for the Western world.",
                "body": "We took inspiration from Japan’s popular propolis-based rinses – a post-brushing swish loved for lifting the residue a toothbrush misses and revealing it right in the sink. That idea became our starting point, not our finish line. To make our formula 100% vegan, we removed the propolis and developed our own elevated blend instead, combining essential oil components for freshness, with hydrogen peroxide for whitening maintenance. The result? iD Stain Whitening Mouthwash – inspired by Japanese oral care, reimagined to target and reveal the gunk brushing leaves behind while helping maintain your white smile."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, PEG-40 Hydrogenated Castor Oil, Glycerin, Citric Acid, Sodium Benzoate, Sucralose, Menthol, Flavour/Aroma, Potassium Sorbate, Xylitol, Sodium Citrate, Eucalyptus Globulus Leaf Oil, Hydrogen Peroxide, Sodium Phytate, Thymol, Caramel, Methyl Salicylate."
              }
            ]
          },
          {
            "title": "*What's included",
            "content": {
              "us": [
                {
                  "body": "\n              3x iD Stain Whitening Mouthwash {{10068-PO*3}}<br>\n              2x iD Stain Whitening Mouthwash - Free<br><br>\n              For the cost of 3x iD Stain Whitening Mouthwash, you'll get all five bottles in this bundle!\n              "
                }
              ],
              "uk": [
                {
                  "body": "\n              3x iD Stain Whitening Mouthwash {{10068-PO*3}}<br>\n              2x iD Stain Whitening Mouthwash - Free<br><br>\n              For the cost of 3x iD Stain Whitening Mouthwash, you'll get all five bottles in this bundle!\n              "
                }
              ],
              "eu": [
                {
                  "body": "\n              3x iD Stain Whitening Mouthwash {{10068-PO*3}}<br>\n              2x iD Stain Whitening Mouthwash - Free<br><br>\n              For the cost of 3x iD Stain Whitening Mouthwash, you'll get all five bottles in this bundle!\n              "
                }
              ],
              "default": [
                {
                  "body": "\n              3x iD Stain Whitening Mouthwash {{10068-PO*3}}<br>\n              2x iD Stain Whitening Mouthwash - Free<br><br>\n              For the cost of 3x iD Stain Whitening Mouthwash, you'll get all five bottles in this bundle!\n              "
                }
              ]
            }
          }
        ],
        "customComponents": [
          {
            "name": "ui-pill",
            "location": "below-atc-content",
            "props": {
              "variant": "money-back-pill",
              "text": "BUY 3 GET 2 FREE*"
            }
          },
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "What Brushing May Miss",
                      "description": "Stain iD Whitening Mouthwash lifts hidden debris from your mouth and shows it back to you. The opaque formula interacts with oral debris, forming visible particles when you spit the mouthwash out. It’s instant proof of what brushing can miss."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_01_-_Stain_Mouthwash.jpg?v=1765345193",
                      "height": 560,
                      "width": 560,
                      "alt": "Trapped impurities"
                    }
                  },
                  {
                    "content": {
                      "title": "Fresh Breath, Whitening Formula",
                      "description": "The formula lifts hidden debris so your mouth feels lighter, cleaner and noticeably fresher. Tongue, cheeks and gum line feel genuinely refreshed. Charged with hydrogen peroxide to help maintain your white smile."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_02_-_Stain_Mouthwash.jpg?v=1765345288",
                      "height": 560,
                      "width": 560,
                      "alt": "Stain ID Whitening Mouthwash"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "PAP_STRIPS_BARGAIN_PACK@pap-strips-bargain-pack",
    {
      "attributes": {
        "sku": "PAP_STRIPS_BARGAIN_PACK",
        "productHandle": "pap-strips-bargain-pack",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/pap-strips-upsell.png?v=1788307713"
              }
            ]
          }
        }
      },
      "content": {}
    }
  ],
  [
    "PERFECT_PAIR_SET@perfect-pair-set",
    {
      "attributes": {
        "sku": "PERFECT_PAIR_SET",
        "productHandle": "perfect-pair-set",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_01_-_Perfect_Pair_Set.png?v=1780362408",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_02_-_Affordable_Whitening_Set_AWS.png?v=1779764471",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Stain_Mouthwash_-_PP.png?v=1784864978",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03-Stain_Mouthwash-PP_9e9530c6-4c66-4cb3-9caf-284f8796ff9d.jpg?v=1771983369",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_05_-_Affordable_Whitening_Set_AWS.png?v=1779764472",
              "height": 414,
              "width": 656
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Collection_-_Affordable_Whitening_Set_AWS_-_Double-Wide.png?v=1779764471",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "pill": {
          "variant": "promotion",
          "text": "FREE PRODUCT"
        },
        "styleTags": [
          "price-asterisk"
        ],
        "description": {
          "default": {
            "title": "Whiten. Remove Gunk. The Perfect Whitening Pair + FREE V34 Whitening Strips",
            "body": "Three products. One routine. Every angle of your oral health covered, from surface whitening to deep enamel support and a cleaner, fresher mouth.<br><br><span style=\"font-weight: 500;\">What's in the Bundle:</span><br><br>\n<span style=\"font-weight: 500;\">2x iD Stain Whitening Mouthwash:</span> Rinse Smarter iD Stain is not your average mouthwash. As you rinse, the formula binds to proteins and debris in your mouth, pulling visible build-up into particles you can actually see in the sink, the grime your toothbrush didn't catch. Hydrogen peroxide maintains your white smile from the very first rinse, while four essential oil actives leave your mouth feeling cleaner and fresher.\n<ul>\n<li>Visibly whitens with hydrogen peroxide</li>\n<li>Propolis technology binds and removes bacteria</li>\n<li>Four active oils for a lasting fresh feeling</li>\n</ul>\n<span style=\"font-weight: 500;\">FREE: V34 Whitening Strips:</span> Whiter teeth in one use. Hismile's V34 Strips combine V34 colour correction with PAP+ technology to deliver whiter teeth. Simply apply, wait 30 minutes, then peel and brush off the residue to reveal results. This dual active technology pairs instant visual improvement with targeted stain removal, unlike anything you'll find off the shelf.\n<ul>\n<li>Immediate cosmetic colour correction</li>\n<li>Visible whitening after just 30 minutes</li>\n<li>14 applications per pack</li>\n</ul>\n\nTogether, this is the perfect whitening pairing."
          }
        },
        "productAccordions": [
          {
            "title": "*What's included",
            "content": {
              "default": [
                {
                  "body": "\n              2x iD Stain Whitening Mouthwash {{10068-PO*2}}<br>\n              1x V34 Whitening Strips - Free<br><br>\n              For the cost of 2x iD Stain Whitening Mouthwash, you'll get all three products in this bundle!\n              "
                }
              ]
            }
          },
          {
            "title": "List of ingredients",
            "content": {
              "default": [
                {
                  "head": "V34 Whitening Strips",
                  "body": "\n              Glycerin, Aqua/Water, Cellulose Gum, Hydroxypropyl Methylcellulose, Phthalimidoperoxycaproic Acid, Disodium EDTA, Sodium Hydroxide, Menthol, Monosodium Citrate, Xanthan Gum, PVM/MA Copolymer, C12-15 Pareth-3, D&C Red No. 33 (CI 17200), FD&C Blue No. 1 (CI 42090).\n              "
                },
                {
                  "head": "iD Stain Whitening Mouthwash",
                  "body": "\n              Aqua/Water, PEG-40 Hydrogenated Castor Oil, Glycerin, Citric Acid, Sodium Benzoate, Sucralose, Menthol, Flavour/Aroma, Potassium Sorbate, Xylitol, Sodium Citrate, Eucalyptus Globulus Leaf Oil, Hydrogen Peroxide, Sodium Phytate, Thymol, Caramel, Methyl Salicylate.\n              "
                }
              ]
            }
          }
        ]
      }
    }
  ],
  [
    "replacement-heads@replacement-heads",
    {
      "attributes": {
        "sku": "replacement-heads",
        "productHandle": "replacement-heads",
        "categoryDetails": {
          "primaryCategory": "replacement-heads"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/v34Serum-ProductPage_26e00517-a733-41a0-8a04-d641a41b7385.png?v=1746740211",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/a2f06b7d355b41f88ef393dfb5c05f49.mp4",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-3_a7237219-45b8-4c7b-9fe2-5603c693848f.jpg?v=1746740235",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-4_fb5dab33-b8df-429c-bd4c-9861f332f1d7.jpg?v=1746740248",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/05-V34-PP_3e81af6e-fdf8-48dc-9b3c-b9b1f36a7fa7.jpg?v=1746740253",
              "height": 512,
              "width": 352
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          }
        ],
        "productAccordions": [
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Barbie Pink Bubblegum Toothpaste. Total Net Contents: 60g | 2.1 oz"
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-media",
            "location": "section-below-the-fold",
            "props": {
              "assets": {
                "default": [
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_01_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_01_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 712,
                      "alt": "Barbie"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_02_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste on the Barbie Electric Toothbrush"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_02_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 712,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste on the Barbie Electric Toothbrush"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_03_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste Bottle"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_03_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 1440,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste Bottle"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "STAIN_MOUTHWASH_BARGAIN_PACK@hot-deal-id-stain-whitening-mouthwash",
    {
      "attributes": {
        "sku": "STAIN_MOUTHWASH_BARGAIN_PACK",
        "productHandle": "hot-deal-id-stain-whitening-mouthwash",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/mw-upsell-hotdeal.png?v=1784850176"
              }
            ]
          }
        }
      },
      "content": {}
    }
  ],
  [
    "STAIN_MOUTHWASH_BUNDLE_PACK@id-mouthwash-btgo",
    {
      "attributes": {
        "sku": "STAIN_MOUTHWASH_BUNDLE_PACK",
        "productHandle": "id-mouthwash-btgo",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-01-Mouthwash-Buy2Get1Free.png?v=1776376076",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Stain_Mouthwash_-_PP.png?v=1784864978",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/04-Stain_Mouthwash-PP-20260127_86d7fc7b-1ef9-4c27-a4f7-207165db39c9.png?v=1771796961",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03-Stain_Mouthwash-PP_9e9530c6-4c66-4cb3-9caf-284f8796ff9d.jpg?v=1771983369",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-05-Stain_Mouthwash_a18b98b9-8c9a-4dae-a069-bed46d0291a1.jpg?v=1771796961",
              "height": 414,
              "width": 656
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Collection_-_Mouthwash_BTGO_-_Double-Wide.png?v=1784508611",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "pill": {
          "variant": "promotion",
          "text": "FREE PRODUCT"
        },
        "styleTags": [
          "alt-bulletpoints",
          "show-value",
          "hide-upsell"
        ],
        "disclaimer": "*Value based on full price of 3 items purchased separately.",
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Detoxes_mouth.png?v=1765748912",
              "height": 30,
              "width": 20
            },
            "text": "Freshens <br> breath"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/application-icon.png?v=1755142734",
              "height": 30,
              "width": 20
            },
            "text": "Removes hidden gunk"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Tooth.png?v=1750650505",
              "height": 30,
              "width": 20
            },
            "text": "Helps maintain white teeth"
          }
        ],
        "description": {
          "title": "",
          "body": "Not after a value pack? You can buy a single mouthwash at full price  <a href=\"/products/id-stain-mouthwash\" style=\"text-decoration: underline;\">here</a>.",
          "bulletpoints": [
            "Helps Maintain White Teeth",
            "Target gunk in the mouth",
            "Freshen breath at the source"
          ]
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "iD Stain is not your average mouthwash. <br><br>This oral rinse works with your routine to help maintain white teeth, freshen breath, and lift build-up from the areas brushing can miss. As you rinse, the formula interacts with oral debris, pulling them into visible particles you can actually see in the sink. That’s what your toothbrush didn’t catch.<br><br>Use as directed as part of your daily oral care routine. Visible residue is not guaranteed and depends on individual factors. Results may vary between individuals."
              }
            ]
          },
          {
            "title": "Our origin story",
            "content": [
              {
                "head": "Japanese-inspired. Reimagined for the Western world.",
                "body": "We took inspiration from Japan’s popular propolis-based rinses – a post-brushing swish loved for lifting the residue a toothbrush misses and revealing it right in the sink. That idea became our starting point, not our finish line. To make our formula 100% vegan, we removed the propolis and developed our own elevated blend instead, combining essential oil components for freshness, with hydrogen peroxide for whitening maintenance. The result? iD Stain Whitening Mouthwash – inspired by Japanese oral care, reimagined to target and reveal the gunk brushing leaves behind while helping maintain your white smile."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, PEG-40 Hydrogenated Castor Oil, Glycerin, Citric Acid, Sodium Benzoate, Sucralose, Menthol, Flavour/Aroma, Potassium Sorbate, Xylitol, Sodium Citrate, Eucalyptus Globulus Leaf Oil, Hydrogen Peroxide, Sodium Phytate, Thymol, Caramel, Methyl Salicylate."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "3 x iD Stain Whitening Mouthwash <br> Total Net Contents: 237 ml | 8 fl. oz."
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "ui-pill",
            "location": "below-atc-content",
            "props": {
              "variant": "money-back-pill",
              "text": "BUY 2 GET 1 FREE"
            }
          },
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "What Brushing May Miss",
                      "description": "Stain iD Whitening Mouthwash lifts hidden debris from your mouth and shows it back to you. The opaque formula interacts with oral debris, forming visible particles when you spit the mouthwash out. It’s instant proof of what brushing can miss."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_01_-_Stain_Mouthwash.jpg?v=1765345193",
                      "height": 560,
                      "width": 560,
                      "alt": "Trapped impurities"
                    }
                  },
                  {
                    "content": {
                      "title": "Fresh Breath, Whitening Formula",
                      "description": "The formula lifts hidden debris so your mouth feels lighter, cleaner and noticeably fresher. Tongue, cheeks and gum line feel genuinely refreshed. Charged with hydrogen peroxide to help maintain your white smile."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_02_-_Stain_Mouthwash.jpg?v=1765345288",
                      "height": 560,
                      "width": 560,
                      "alt": "Stain ID Whitening Mouthwash"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "STAIN_MOUTHWASH_VALUE_PACK_SHIPPING@id-mouthwash-value-pack-free-shipping",
    {
      "attributes": {
        "sku": "STAIN_MOUTHWASH_VALUE_PACK_SHIPPING",
        "productHandle": "id-mouthwash-value-pack-free-shipping",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "mobile": {
                  "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/iD_Mouthwash_Value_Pack_M.png?v=1778112803"
                },
                "desktop": {
                  "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/MouthwashUpselld3.png?v=1776054510"
                }
              }
            ]
          }
        }
      },
      "content": {}
    }
  ],
  [
    "STAIN_MOUTHWASH_VALUE_PACK@stain-whitening-mouthwash-value-pack",
    {
      "attributes": {
        "sku": "STAIN_MOUTHWASH_VALUE_PACK",
        "productHandle": "stain-whitening-mouthwash-value-pack",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "mobile": {
                  "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/iD_Mouthwash_Value_Pack_M.png?v=1778112803"
                },
                "desktop": {
                  "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/MouthwashUpselld3.png?v=1776054510"
                }
              }
            ]
          }
        }
      },
      "content": {}
    }
  ],
  [
    "THE_STARTER_BUNDLE@starter-bundle",
    {
      "attributes": {
        "sku": "THE_STARTER_BUNDLE",
        "productHandle": "starter-bundle",
        "categoryDetails": {
          "primaryCategory": "bundle"
        },
        "age": 8
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_01_-_Starter_Bundle_APD.png?v=1778537161",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-02-StarterBundlePOCWSS.png?v=1768361273",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Stain_Mouthwash_-_PP.png?v=1784864978",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-03-StarterBundlePOCWSS.png?v=1772080135",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-05-StarterBundlePOCWSS.png?v=1768361273",
              "height": 414,
              "width": 656
            }
          ]
        },
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "mobile": {
                  "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Starter_Bundle_-_Upsell_Image_-_M.png?v=1778115334"
                },
                "desktop": {
                  "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Starter_Bundle_-_Upsell_Image_-_Dupdated.png?v=1778115072"
                }
              }
            ]
          }
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Collection_-_Starter_Bundle_APD_-_Double-Wide_5562c3a6-0921-4499-b9fd-3df9eba23b72.png?v=1778537272",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "description": {
          "default": {
            "title": "Your everyday whitening routine now includes a FREE Toothpaste.",
            "body": "The Starter Bundle now includes everything you need to kick off a brighter smile in one easy bundle. This simple, 3-step routine works together to conceal stains, boost brightness and maintain your everyday oral health, keeping you feeling fresh day after day.<br><br>\n  \n        Start with your Hismile Toothpaste for your everyday cleaning, before using iD Stain Whitening Mouthwash to remove the things that brushing misses, while neutralising bad breath. Then follow up with our V34 Whitening Strips for whiter-looking teeth after just one use^.<br><br>\n  \n        Simple to use. Great value. Easy to start your whitening routine.<br><br>\n  \n        <i>^Immediate results are temporary and whitening is not permanent. Results may vary.<br>\n        Terms and Conditions: Available toothpaste flavours are subject to availability and change. See current selection for availability. </i><br><br>"
          }
        },
        "productAccordions": [
          {
            "title": "*What's included",
            "content": {
              "default": [
                {
                  "body": "1x V34 Whitening Strips {{10060-VS}}<br>\n              1x iD Stain Whitening Mouthwash {{10068-PO}}<br>\n              1x Flavoured Toothpaste - Free"
                }
              ]
            }
          },
          {
            "title": "List of ingredients",
            "content": {
              "default": [
                {
                  "head": "V34 Whitening Strips",
                  "body": "\n              Glycerin, Aqua/Water, Cellulose Gum, Hydroxypropyl Methylcellulose, Phthalimidoperoxycaproic Acid, Disodium EDTA, Sodium Hydroxide, Menthol, Monosodium Citrate, Xanthan Gum, PVM/MA Copolymer, C12-15 Pareth-3, D&C Red No. 33 (CI 17200), FD&C Blue No. 1 (CI 42090).\n              "
                },
                {
                  "head": "iD Stain Whitening Mouthwash",
                  "body": "\n              Aqua/Water, PEG-40 Hydrogenated Castor Oil, Glycerin, Citric Acid, Sodium Benzoate, Sucralose, Menthol, Flavour/Aroma, Potassium Sorbate, Xylitol, Sodium Citrate, Eucalyptus Globulus Leaf Oil, Hydrogen Peroxide, Sodium Phytate, Thymol, Caramel, Methyl Salicylate.\n              "
                },
                {
                  "head": "Flavoured Toothpaste",
                  "body": "\n              See individual product pages for full product information and ingredient listing.\n              "
                }
              ]
            }
          }
        ]
      }
    }
  ],
  [
    "THE_VAULT@the-vault",
    {
      "attributes": {
        "sku": "THE_VAULT",
        "productHandle": "the-vault",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-01-DDB_b22b27a4-fa22-473c-8066-dfe3bead94e7.gif?v=1747004928",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-02-DDB_c7aa7f94-fe46-483a-8b22-fbebde7ddf57.png?v=1747004925",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-03-DDB_b34485bd-b41f-4889-a2b1-5c5f6bb84259.png?v=1747004923",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-04-DDB_46570463-be82-4901-847e-3c6de26a8b6f.png?v=1747004920",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP-05-DDB_997a11a1-c693-4aea-93bd-09588d4dc73a.png?v=1747004921",
              "height": 897,
              "width": 1400
            }
          ]
        }
      },
      "content": {
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          }
        ],
        "productAccordions": [
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Barbie Pink Bubblegum Toothpaste. Total Net Contents: 60g | 2.1 oz"
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-media",
            "location": "section-below-the-fold",
            "props": {
              "images": {
                "default": [
                  {
                    "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/BTF_-_01_-_Blue_Raspberry_Lip_Balm.png?v=1734328253",
                    "height": 600,
                    "width": 414,
                    "alt": "Model holding bottle of Blue Raspberry Lip Balm"
                  },
                  {
                    "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/BTF_-_02_-_Blue_Raspberry_Lip_Balm.png?v=1734328253",
                    "height": 600,
                    "width": 414,
                    "alt": "Blue Raspberry Lip Balm with Blue Raspberries"
                  },
                  {
                    "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/BTF_-_03_-_Blue_Raspberry_Lip_Balm_-_D.png?v=1734328253",
                    "height": 1000,
                    "width": 1440,
                    "alt": "Blue Raspberry Lip Balm in glossy blue"
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "TOOTH_ARMOUR_BARGAIN_PACK@hot-deal-tooth-armour-toothpaste-serum",
    {
      "attributes": {
        "sku": "TOOTH_ARMOUR_BARGAIN_PACK",
        "productHandle": "hot-deal-tooth-armour-toothpaste-serum",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/TA_-_Upsell_Image_-_Du.png?v=1778117628"
              }
            ]
          }
        }
      },
      "content": {}
    }
  ],
  [
    "TOOTH_ARMOUR_BFGS@buy-four-get-six-free-tooth-armour",
    {
      "attributes": {
        "sku": "TOOTH_ARMOUR_BFGS",
        "productHandle": "buy-four-get-six-free-tooth-armour",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_01_-_B4G6_-_TA.png?v=1789961687",
              "height": 512,
              "width": 352,
              "alt": "Tooth Armour Toothpaste Serum with Packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 512,
              "width": 352,
              "alt": "Visualisation of Tooth Armour Toothpaste Serum being applied to toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 512,
              "width": 352,
              "alt": "Microscopic Visualisation of Nano-Hydroxyapatite on teeth"
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/b7e01de4063d4e7cb868f4ea1225ff42.mp4",
              "height": 512,
              "width": 352,
              "alt": "Tooth Armour Toothpaste Serum video"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 414,
              "width": 656,
              "alt": "Key points about Tooth Armour Toothpaste Serum"
            }
          ]
        }
      },
      "content": {
        "disclaimer": "^Value based on full price of 10 Serums purchased separately.",
        "styleTags": [
          "show-value",
          "compare-carrot",
          "hide-badge",
          "alt-bulletpoints"
        ],
        "valuePrice": [
          {
            "sku": "10065-TA",
            "quantity": 10
          }
        ],
        "productOptionSelectorDetails": {
          "productQuantity": 10,
          "productType": {
            "single": "serum",
            "singleText": "6-week supply*",
            "plural": "serums",
            "pluralText": "12-month supply*",
            "showIcons": true,
            "freeProducts": 6
          },
          "dealMessage": "Buy 4, get 6 free",
          "productTerms": "*Based on 1 x 20mL bottle providing 100 uses, used twice daily as directed, providing up to 6 weeks’ supply.",
          "showValuePrice": true,
          "valuePriceLabel": "Bundle valued at",
          "showPercentageOff": true,
          "adDefault": true
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Shield_Icon_d970d5d6-c449-40a3-81d3-ac30fc9a53d2.png?v=1774930587",
              "height": 45,
              "width": 30
            },
            "text": "Nano- <br>Hydroxyapatite",
            "customHeight": 45,
            "customWidth": 30
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Replace_Toothpaste_Icon_2.png?v=1774930580",
              "height": 45,
              "width": 30
            },
            "text": "Replace Your <br> Toothpaste",
            "customHeight": 45,
            "customWidth": 30
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/dna_emoji_png_6186eebf-e3f6-41b8-a69f-2a787d86b28b.png?v=1774934225",
              "height": 45,
              "width": 30
            },
            "text": "Supercharged <br> Vitamin Formula",
            "customHeight": 45,
            "customWidth": 30
          }
        ],
        "description": {
          "title": "White. Freshen. Rinse away the gunk.",
          "body": "<i>*Through mechanical action with regular brushing</i><br><br>\n      Tooth Armour elevates your oral care. Powered by NH-10, a concentrated blend of 6 actives including Nano-Hydroxyapatite, an ingredient engineered to mirror the mineral your enamel is mostly made of, together with Hydrated Silica, Xylitol, Hyaluronic Acid, Niacinamide (Vitamin B3) and Zinc Gluconate. Add Tooth Armour to your existing toothpaste or use it on its own. Either way, your routine just got a serious upgrade.<br><br>\n      Not after a value pack? You can buy a single Tooth Armour at full price <a href=\"/products/tooth-armour\" style=\"text-decoration: underline;\">here</a>.",
          "bulletpoints": [
            "<strong>Powered with Nano-Hydroxyapatite</strong>, an ingredient engineered to mirror the mineral that makes up 97% of your enamel.",
            "<strong>6 actives.</strong> 1 serum.",
            "Helps maintain <strong>white teeth*</strong>"
          ]
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "Tooth Armour is a toothpaste serum, designed to be used as part of your daily brushing routine. Add to your regular toothpaste or use on its own. Brush for 2 minutes, then expel.<br><br>Use as directed as part of your oral care routine. Any benefits associated with Tooth Armour are derived from continued daily use, together with a good oral care routine."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, Glycerin, Hydrated Silica, Hydroxyapatite (nano), Xylitol, Sodium Hyaluronate, Niacinamide, Zinc Gluconate, Hydroxyethylcellulose, Silica, Caprylyl Glycol, 1,2-Hexanediol, Hydroxypropyl Methylcellulose, Potassium Chloride, Lauryl Glucoside, Flavour/Aroma, Sucralose, Carmine (CI 75470) , Menthol, Carvone, Mentha Piperita Oil, Anethole."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "10 x Tooth Armour Toothpaste Serum<br>Total Net Contents: 10x (20 ml | 0.67 fl. oz.)"
              }
            ]
          }
        ]
      }
    }
  ],
  [
    "TOOTH_ARMOUR_BOGO@tooth-armour-bogo",
    {
      "attributes": {
        "sku": "TOOTH_ARMOUR_BOGO",
        "productHandle": "tooth-armour-bogo",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_01_-_Tooth_Armour_Bogo.png?v=1789433628",
              "height": 512,
              "width": 352,
              "alt": "2 bottles of Tooth Armour"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 512,
              "width": 352,
              "alt": "Visualisation of Tooth Armour Toothpaste Serum being applied to toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 512,
              "width": 352,
              "alt": "Microscopic Visualisation of Nano-Hydroxyapatite on teeth"
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/b7e01de4063d4e7cb868f4ea1225ff42.mp4",
              "height": 512,
              "width": 352,
              "alt": "Tooth Armour Toothpaste Serum video"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 414,
              "width": 656,
              "alt": "Key points about Tooth Armour Toothpaste Serum"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "styleTags": [
          "alt-bulletpoints",
          "low-stock-pill",
          "show-value",
          "hide-upsell"
        ],
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Shield_Icon_d970d5d6-c449-40a3-81d3-ac30fc9a53d2.png?v=1774930587",
              "height": 45,
              "width": 30
            },
            "text": "Nano- <br>Hydroxyapatite",
            "customHeight": 45,
            "customWidth": 30
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Replace_Toothpaste_Icon_2.png?v=1774930580",
              "height": 45,
              "width": 30
            },
            "text": "Replace Your <br> Toothpaste",
            "customHeight": 45,
            "customWidth": 30
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/dna_emoji_png_6186eebf-e3f6-41b8-a69f-2a787d86b28b.png?v=1774934225",
              "height": 45,
              "width": 30
            },
            "text": "Supercharged <br> Vitamin Formula",
            "customHeight": 45,
            "customWidth": 30
          }
        ],
        "disclaimer": "*Value based on full-price purchase of two bottles.",
        "description": {
          "title": "White. Freshen. Rinse away the gunk.",
          "body": "<i>*Through mechanical action with regular brushing</i><br><br>\n      Tooth Armour elevates your oral care. Powered by NH-10, a concentrated blend of 6 actives including Nano-Hydroxyapatite, an ingredient engineered to mirror the mineral your enamel is mostly made of, together with Hydrated Silica, Xylitol, Hyaluronic Acid, Niacinamide (Vitamin B3) and Zinc Gluconate. Add Tooth Armour to your existing toothpaste or use it on its own. Either way, your routine just got a serious upgrade.",
          "bulletpoints": [
            "<strong>Powered with Nano-Hydroxyapatite</strong>, an ingredient engineered to mirror the mineral that makes up 97% of your enamel.",
            "<strong>6 actives.</strong> 1 serum.",
            "Helps maintain <strong>white teeth*</strong>"
          ]
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "Tooth Armour is a toothpaste serum, designed to be used as part of your daily brushing routine. Add to your regular toothpaste or use on its own. Brush for 2 minutes, then expel.<br><br>Use as directed as part of your oral care routine. Any benefits associated with Tooth Armour are derived from continued daily use, together with a good oral care routine."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, Glycerin, Hydrated Silica, Hydroxyapatite (nano), Xylitol, Sodium Hyaluronate, Niacinamide, Zinc Gluconate, Hydroxyethylcellulose, Silica, Caprylyl Glycol, 1,2-Hexanediol, Hydroxypropyl Methylcellulose, Potassium Chloride, Lauryl Glucoside, Flavour/Aroma, Sucralose, Carmine (CI 75470) , Menthol, Carvone, Mentha Piperita Oil, Anethole."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "2 x Tooth Armour Toothpaste Serum<br>Total Net Contents: 20 ml | 0.67 fl. oz."
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "The Upgrade Your Routine Wants",
                      "description": "A few drops directly to your brush, or layered over your regular toothpaste. Tooth Armour introduces advanced actives to your oral care routine - and it's never looked better for it."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_01_-_Tooth_Armour_6fff633b-4e8a-4e56-a2f7-e799007040a3.png?v=1774326787",
                      "height": 560,
                      "width": 560,
                      "alt": "Tooth Armour Toothpaste Serum"
                    }
                  },
                  {
                    "content": {
                      "title": "Advanced Enamel Support",
                      "description": "Tooth Armour includes Nano-Hydroxyapatite, an enamel-like mineral, mimicking a key component naturally found in your tooth's external structure."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_02_-_Tooth_Armour_51bfa066-2a18-4e2c-8e8d-bcb7987dd2f1.png?v=1774326788",
                      "height": 560,
                      "width": 560,
                      "alt": "Microscopic Visualisation of Nano-Hydroxyapatite on teeth"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "TOOTH_ARMOUR_BUNDLE_PACK@tooth-armour-btgo",
    {
      "attributes": {
        "sku": "TOOTH_ARMOUR_BUNDLE_PACK",
        "productHandle": "tooth-armour-btgo",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-01-ToothArmour-Buy2Get1Free.png?v=1776637524",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/b7e01de4063d4e7cb868f4ea1225ff42.mp4",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 414,
              "width": 656
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Collection_-_Tooth_Armour_BTGO_-_Double-Wide.png?v=1784508611",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "pill": {
          "variant": "promotion",
          "text": "FREE PRODUCT"
        },
        "disclaimer": "*Value based on full price of 3 serums purchased separately.",
        "styleTags": [
          "alt-bulletpoints",
          "show-value",
          "hide-upsell"
        ],
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Shield_Icon_d970d5d6-c449-40a3-81d3-ac30fc9a53d2.png?v=1774930587",
              "height": 45,
              "width": 30
            },
            "text": "Nano- <br>Hydroxyapatite",
            "customHeight": 45,
            "customWidth": 30
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1685928673",
              "height": 45,
              "width": 30
            },
            "text": "Replace Your <br> Toothpaste",
            "customHeight": 45,
            "customWidth": 30
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/dna_emoji_png_f4694067-1886-4fa5-ab4c-ae6d510825f3.png?v=1774930056",
              "height": 45,
              "width": 30
            },
            "text": "Supercharged <br> Vitamin Formula",
            "customHeight": 45,
            "customWidth": 30
          }
        ],
        "description": {
          "title": "",
          "body": "\n      <i>*Through mechanical action with regular brushing</i><br><br>\n            Tooth Armour elevates your oral care. Powered by NH-10, a concentrated blend of 6 actives including Nano-Hydroxyapatite, an ingredient engineered to mirror the mineral your enamel is mostly made of, together with Hydrated Silica, Xylitol, Hyaluronic Acid, Niacinamide (Vitamin B3) and Zinc Gluconate. Add Tooth Armour to your existing toothpaste or use it on its own. Either way, your routine just got a serious upgrade.<br><br>\n            Not after a value pack? You can buy a single Tooth Armour Toothpaste Serum at full price <a href=\"/products/tooth-armour\" style=\"text-decoration: underline;\">here</a>.",
          "bulletpoints": [
            "<strong>Powered with Nano-Hydroxyapatite,</strong> an ingredient engineered to mirror the mineral that makes up <strong>97% of your enamel.</strong>",
            "<strong>6 actives.</strong> 1 serum.",
            "Helps maintain <strong>white teeth*</strong>"
          ]
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "Tooth Armour is a toothpaste serum, designed to be used as part of your daily brushing routine. Add to your regular toothpaste or use on its own. Brush for 2 minutes, then expel.<br><br>Use as directed as part of your oral care routine. Any benefits associated with Tooth Armour are derived from continued daily use, together with a good oral care routine."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, Glycerin, Hydrated Silica, Hydroxyapatite (nano), Xylitol, Sodium Hyaluronate, Niacinamide, Zinc Gluconate, Hydroxyethylcellulose, Silica, Caprylyl Glycol, 1,2-Hexanediol, Hydroxypropyl Methylcellulose, Potassium Chloride, Lauryl Glucoside, Flavour/Aroma, Sucralose, Carmine (CI 75470) , Menthol, Carvone, Mentha Piperita Oil, Anethole."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "3 x Tooth Armour Toothpaste Serum <br> Total Net Contents: 20 ml | 0.67 fl. oz."
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "ui-pill",
            "location": "below-atc-content",
            "props": {
              "variant": "money-back-pill",
              "text": "BUY 2 GET 1 FREE"
            }
          },
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "The Upgrade Your Routine Wants",
                      "description": "A few drops directly to your brush, or layered over your regular toothpaste. Tooth Armour introduces advanced actives to your oral care routine - and it's never looked better for it."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_01_-_Tooth_Armour_6fff633b-4e8a-4e56-a2f7-e799007040a3.png?v=1774326787",
                      "height": 560,
                      "width": 560,
                      "alt": "Tooth Armour Toothpaste Serum"
                    }
                  },
                  {
                    "content": {
                      "title": "Advanced Enamel Support",
                      "description": "Tooth Armour includes Nano-Hydroxyapatite, an enamel-like mineral, mimicking a key component naturally found in your tooth's external structure."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_02_-_Tooth_Armour_51bfa066-2a18-4e2c-8e8d-bcb7987dd2f1.png?v=1774326788",
                      "height": 560,
                      "width": 560,
                      "alt": "Microscopic Visualisation of Nano-Hydroxyapatite on teeth"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "TOOTH_ARMOUR_SERUM_PARENT@tooth-armour-toothpaste-serum-parent",
    {
      "attributes": {
        "sku": "TOOTH_ARMOUR_SERUM_PARENT",
        "productHandle": "tooth-armour-toothpaste-serum-parent",
        "productTags": [
          "collection-hidden"
        ],
        "categoryDetails": {
          "primaryCategory": "tooth-armour"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Collection-ToothArmour_a98f1800-c081-4d09-848e-de72bd0ea249.png?v=1776741087",
              "height": 352,
              "width": 352,
              "alt": "Tooth Armour Toothpaste Serum with packaging"
            },
            {
              "src": " https://cdn.shopify.com/videos/c/o/v/61bd20487a834f1598f90b03f8fa86e2.mp4",
              "height": 352,
              "width": 352,
              "alt": "Tooth Armour Toothpaste Serum Video"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        },
        "customProductAsset": {
          "overlayImage": {
            "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/TA_-_Parent_Landing_Page_-_Buddy_Image.png?v=1777005230",
            "height": 300,
            "width": 300
          }
        }
      },
      "content": {
        "pill": {
          "variant": "information",
          "text": "New"
        },
        "styleTags": [
          "alt-bulletpoints",
          "low-stock-pill"
        ],
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Enamel_Safe_Icon_9863c549-e966-46d7-b6df-cbd719373288.png?v=1776735051",
              "height": 45,
              "width": 30
            },
            "text": "<span style='font-weight:500;'>Enamel-safe</span> <br>N-HA Formula"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Fluoride-Free_Icon_fb7f6112-aa0c-4e59-8445-b56febc57c42.png?v=1776735052",
              "height": 45,
              "width": 30
            },
            "text": "<span style='font-weight:500;'>Fluoride-free</span> <br>Gentle Daily Use"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/7_Icon_62558c43-035a-465a-9ca6-04f1f1fce72f.png?v=1776735052",
              "height": 45,
              "width": 30
            },
            "text": "<span style='font-weight:500;'>Ages 7+</span> <br>Child suitable"
          }
        ],
        "description": {
          "title": "",
          "body": "",
          "bulletpoints": [
            "<span style=\"font-weight: 500\">Nano-Hydroxyapatite</span> - engineered to mirror the mineral that makes up your child's enamel.",
            "<span style=\"font-weight: 500\">Fluoride-free</span> - no harsh chemicals, worry-free for kids still learning to spit.",
            "<span style=\"font-weight: 500\">Ages 7+</span> - low-abrasion formula designed for developing enamel."
          ]
        },
        "productAccordions": [
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, Glycerin, Hydrated Silica, Hydroxyapatite (nano), Xylitol, Sodium Hyaluronate, Niacinamide, Zinc Gluconate, Hydroxyethylcellulose, Silica, Caprylyl Glycol, 1,2-Hexanediol, Hydroxypropyl Methylcellulose, Potassium Chloride, Lauryl Glucoside, Flavour/Aroma, Sucralose, Carmine (CI 75470) , Menthol, Carvone, Mentha Piperita Oil, Anethole."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "\n            1 × Tooth Armour Toothpaste Serum<br>\n            Total Net Contents: 20ml | 0.67 fl. oz."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Mum questions, answered",
          "accordions": [
            {
              "title": "When can my child start using it?",
              "content": [
                {
                  "body": "Tooth Armour Kids is suitable from age 7+ when children can reliably brush and spit on their own, and should be used under supervision."
                }
              ]
            },
            {
              "title": "How is it different to regular kids toothpaste?",
              "content": [
                {
                  "body": "Nano-Hydroxyapatite is a fluoride alternative. It can support developing enamel of growing teeth, and a healthy smile. Consult your dentist about what’s best for your circumstances."
                }
              ]
            }
          ]
        },
        "customComponents": [
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "The Upgrade Your Routine Wants",
                      "description": "A few drops directly to your brush, or layered over your regular toothpaste. Tooth Armour introduces advanced actives to your oral care routine - and it's never looked better for it."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_01_-_Tooth_Armour_6fff633b-4e8a-4e56-a2f7-e799007040a3.png?v=1774326787",
                      "height": 560,
                      "width": 560,
                      "alt": "Tooth Armour Toothpaste Serum"
                    }
                  },
                  {
                    "content": {
                      "title": "Advanced Enamel Support",
                      "description": "Tooth Armour includes Nano-Hydroxyapatite, an enamel-like mineral, mimicking a key component naturally found in your tooth's external structure."
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/BTF_-_02_-_Tooth_Armour_51bfa066-2a18-4e2c-8e8d-bcb7987dd2f1.png?v=1774326788",
                      "height": 560,
                      "width": 560,
                      "alt": "Microscopic Visualisation of Nano-Hydroxyapatite on teeth"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "TOOTH_ARMOUR_TRIPLE_VALUE_SET@tooth-armour-triple-value-set",
    {
      "attributes": {
        "sku": "TOOTH_ARMOUR_TRIPLE_VALUE_SET",
        "productHandle": "tooth-armour-triple-value-set",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_01_-_Tooth_Armour_Triple_Value_Set.png?v=1783547729",
              "height": 512,
              "width": 352,
              "alt": "Tooth Armour Toothpaste Serum with Packaging"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 512,
              "width": 352,
              "alt": "Visualisation of Tooth Armour Toothpaste Serum being applied to toothbrush"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 512,
              "width": 352,
              "alt": "Microscopic Visualisation of Nano-Hydroxyapatite on teeth"
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/b7e01de4063d4e7cb868f4ea1225ff42.mp4",
              "height": 512,
              "width": 352,
              "alt": "Tooth Armour Toothpaste Serum video"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_Tooth_Armour_-_PP.png?v=1774930437",
              "height": 414,
              "width": 656,
              "alt": "Key points about Tooth Armour Toothpaste Serum"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Collection_-_Tooth_Armour_Triple_Value_Set_-_Double-Wide.png?v=1784775997",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "disclaimer": "*Value based on full price of 3 Serums purchased separately.",
        "styleTags": [
          "show-value",
          "alt-bulletpoints"
        ],
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Shield_Icon_d970d5d6-c449-40a3-81d3-ac30fc9a53d2.png?v=1774930587",
              "height": 45,
              "width": 30
            },
            "text": "Nano- <br>Hydroxyapatite",
            "customHeight": 45,
            "customWidth": 30
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Replace_Toothpaste_Icon_2.png?v=1774930580",
              "height": 45,
              "width": 30
            },
            "text": "Replace Your <br> Toothpaste",
            "customHeight": 45,
            "customWidth": 30
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/dna_emoji_png_6186eebf-e3f6-41b8-a69f-2a787d86b28b.png?v=1774934225",
              "height": 45,
              "width": 30
            },
            "text": "Supercharged <br> Vitamin Formula",
            "customHeight": 45,
            "customWidth": 30
          }
        ],
        "description": {
          "title": "White. Freshen. Rinse away the gunk.",
          "body": "<i>*Through mechanical action with regular brushing</i><br><br> Tooth Armour elevates your oral care. Powered by NH-10, a concentrated blend of 6 actives including Nano-Hydroxyapatite, an ingredient engineered to mirror the mineral your enamel is mostly made of, together with Hydrated Silica, Xylitol, Hyaluronic Acid, Niacinamide (Vitamin B3) and Zinc Gluconate. Add Tooth Armour to your existing toothpaste or use it on its own. Either way, your routine just got a serious upgrade.<br><br>Not after a value pack? You can buy a single Tooth Armour at full price <a href=\"/products/tooth-armour\" style=\"text-decoration: underline;\">here</a>.",
          "bulletpoints": [
            "<strong>Powered with Nano-Hydroxyapatite</strong>, an ingredient engineered to mirror the mineral that makes up 97% of your enamel.",
            "<strong>6 actives.</strong> 1 serum.",
            "Helps maintain <strong>white teeth*</strong>"
          ]
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "Tooth Armour is a toothpaste serum, designed to be used as part of your daily brushing routine. Add to your regular toothpaste or use on its own. Brush for 2 minutes, then expel.<br><br>Use as directed as part of your oral care routine. Any benefits associated with Tooth Armour are derived from continued daily use, together with a good oral care routine."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, Glycerin, Hydrated Silica, Hydroxyapatite (nano), Xylitol, Sodium Hyaluronate, Niacinamide, Zinc Gluconate, Hydroxyethylcellulose, Silica, Caprylyl Glycol, 1,2-Hexanediol, Hydroxypropyl Methylcellulose, Potassium Chloride, Lauryl Glucoside, Flavour/Aroma, Sucralose, Carmine (CI 75470) , Menthol, Carvone, Mentha Piperita Oil, Anethole."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "3 x Tooth Armour Toothpaste Serum<br>Total Net Contents: 20 ml | 0.67 fl. oz."
              }
            ]
          }
        ]
      }
    }
  ],
  [
    "TOOTH_ARMOUR_VALUE_PACK_SHIPPING@tooth-armour-value-pack-free-shipping",
    {
      "attributes": {
        "sku": "TOOTH_ARMOUR_VALUE_PACK_SHIPPING",
        "productHandle": "tooth-armour-value-pack-free-shipping",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/TA_2x_-_Upsell_Image_-_DB.png?v=1778113615"
              }
            ]
          }
        }
      },
      "content": {}
    }
  ],
  [
    "TOOTH_ARMOUR_VALUE_PACK@tooth-armour-value-pack",
    {
      "attributes": {
        "sku": "TOOTH_ARMOUR_VALUE_PACK",
        "productHandle": "tooth-armour-value-pack",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/TA_2x_-_Upsell_Image_-_DB.png?v=1778113615"
              }
            ]
          }
        }
      },
      "content": {}
    }
  ],
  [
    "TOOTH_WIPES_BARGAIN_PACK@tooth-wipes-hot-deal",
    {
      "attributes": {
        "sku": "TOOTH_WIPES_BARGAIN_PACK",
        "productHandle": "tooth-wipes-hot-deal",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": []
        }
      },
      "content": {}
    }
  ],
  [
    "TOOTH_WIPES_TRIPLE_VALUE_SET@tooth-wipes-triple-value-set",
    {
      "attributes": {
        "sku": "TOOTH_WIPES_TRIPLE_VALUE_SET",
        "productHandle": "tooth-wipes-triple-value-set",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_01_-_Tooth_Wipes_Triple_Value_Set.png?v=1786494970",
              "height": 512,
              "width": 352,
              "alt": "Exfoliating tooth wipes"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/02_-_Tooth_Wipes_-_PP.png?v=1779940429",
              "height": 512,
              "width": 352,
              "alt": "Tooth wipe on finger"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/03_-_Tooth_Wipes_-_PP.png?v=1779940429",
              "height": 512,
              "width": 352,
              "alt": "Zoom in on tooth and tooth wipe"
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/c8ea21fa50ac45d186fd9afbf3d6a973.mp4",
              "height": 512,
              "width": 352,
              "alt": "Tooth wipe demonstration video"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/05_-_Tooth_Wipes_-_PP_14283ca8.png?v=1780525424",
              "height": 414,
              "width": 656,
              "alt": "Key points about tooth wipes"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Collection_-_Tooth_Wipes_Triple_Value_Set_-_Double-Wide.png?v=1786494969",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "disclaimer": "*Value based on full price of 3 Tooth Wipe packs purchased separately.",
        "styleTags": [
          "show-value",
          "alt-bulletpoints"
        ],
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Hydroxyapatite_Icon_ef9bc6d9-dcf0-4a68-ac6b-b7973dbd103e.png?v=1779940436",
              "height": 30,
              "width": 20
            },
            "text": "Infused with<br>Hydroxyapatite"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Sprinter_icon_82a6cfa4-2d66-4710-9fca-f29b91d7ff51.png?v=1779940436",
              "height": 30,
              "width": 20
            },
            "text": "Brushing<br>On-The-Go"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Plane_Icon_1e26336e-bcc7-4bf3-b0c5-2dc5254de2f4.png?v=1779940436",
              "height": 30,
              "width": 20
            },
            "text": "Travel<br>Friendly"
          }
        ],
        "description": {
          "title": "Exfoliating Tooth Wipes",
          "body": "\n      Introducing Tooth Wipes, the convenient brush that allows you to wipe in the time where it actually matters - the 12 to 14 hours between regular brushing of untouched food build-up that can stain - that occurs to the surface layer of your teeth.<br><br>\n      That is what Tooth Wipes are built for. A wipe with an engineered textured surface that is designed to help to physically lift the surface build-up off your teeth. Wipe away the surface plaque. A similar mechanical action to brushing. No water. No paste. No sink.<br><br>\n      Infused with hydroxyapatite and xylitol, our Tooth Wipes are made to complement your everyday oral care routine. Easy to use anytime, anywhere, they leave your mouth feeling fresh and clean.<br><br>\n      Slide Tooth Wipes on your finger and wipe away stains before they set. <br><br>Not after a value pack? You can buy a single mouthwash at full price  <a href=\"/products/exfoliating-tooth-wipes\" style=\"text-decoration: underline;\">here</a>.",
          "bulletpoints": [
            "Engineered to physically lift the day's build-up off your teeth",
            "Infused with hydroxyapatite and xylitol for that freshly-brushed feeling in the middle of your day",
            "Designed to support your tooth surface in one easy wipe"
          ]
        },
        "productAccordions": [
          {
            "title": "How it works",
            "content": [
              {
                "body": "Tooth Wipes are designed to be used alongside your everyday oral care routine. Add to your daily regimen to assist with maintaining a healthy smile.<br><br>\n            Use as directed as part of your oral care routine. Any benefits associated with Tooth Wipes are derived from continued daily use, together with a good oral care routine.<br><br>\n            <i>Not designed to replace your toothbrush.</i>\n            "
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Aqua/Water, Polysorbate 20, Xylitol, Pentasodium Triphosphate, Hydroxyapatite, Sodium Bicarbonate, Calcium Carbonate, Flavour/Aroma, Sodium Chloride, Caprylyl Glycol, Gluconolactone, Sucralose, Menthol, Hydroxyacetophenone, Citric Acid, Sodium Citrate, Anethole, Camphor, Carvone, Mentha Piperita Oil, Pinene."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "3 x 14pk Tooth Wipes<br>\n            Total Net Contents: 42 applications"
              }
            ]
          }
        ]
      }
    }
  ],
  [
    "TOOTH_WIPES_VALUE_PACK@tooth-wipes-value-pack",
    {
      "attributes": {
        "sku": "TOOTH_WIPES_VALUE_PACK",
        "productHandle": "tooth-wipes-value-pack",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": []
        }
      },
      "content": {}
    }
  ],
  [
    "toothpaste@toothpaste",
    {
      "attributes": {
        "sku": "toothpaste",
        "productHandle": "toothpaste",
        "categoryDetails": {
          "primaryCategory": "toothpaste"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/v34Serum-ProductPage_26e00517-a733-41a0-8a04-d641a41b7385.png?v=1746740211",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/a2f06b7d355b41f88ef393dfb5c05f49.mp4",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-3_a7237219-45b8-4c7b-9fe2-5603c693848f.jpg?v=1746740235",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-4_fb5dab33-b8df-429c-bd4c-9861f332f1d7.jpg?v=1746740248",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/05-V34-PP_3e81af6e-fdf8-48dc-9b3c-b9b1f36a7fa7.jpg?v=1746740253",
              "height": 512,
              "width": 352
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          }
        ],
        "productAccordions": [
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Barbie Pink Bubblegum Toothpaste. Total Net Contents: 60g | 2.1 oz"
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-media",
            "location": "section-below-the-fold",
            "props": {
              "assets": {
                "default": [
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_01_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_01_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 712,
                      "alt": "Barbie"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_02_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste on the Barbie Electric Toothbrush"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_02_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 712,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste on the Barbie Electric Toothbrush"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_03_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste Bottle"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_03_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 1440,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste Bottle"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "ULTIMATE_BUNDLE@ultimate-bundle",
    {
      "attributes": {
        "sku": "ULTIMATE_BUNDLE",
        "productHandle": "ultimate-bundle",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_01_-_UB_5b3d225a-591d-4dc0-a26a-d0034dfdd376.png?v=1782447352",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_02_-_Affordable_Whitening_Set_AWS.png?v=1779764471",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/01_-_Stain_Mouthwash_-_PP.png?v=1784864978",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_04_-_Affordable_Whitening_Set_AWS.png?v=1779764471",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_05_-_Affordable_Whitening_Set_AWS.png?v=1779764472",
              "height": 414,
              "width": 656
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Collection_-_UB_-_Double_d2918b13-b55e-486d-b717-21f6f813b715.png?v=1782447351",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "styleTags": [
          "price-asterisk"
        ],
        "description": {
          "default": {
            "title": "Whiten. Brighten. Remove Gunk. Protect + receive a mystery coloured Hismile Electric Toothbrush for FREE",
            "body": "\n        Five products. One routine. Every angle of your oral care covered, from surface whitening to enamel support and a cleaner, fresher mouth.<br><br><span style=\"font-weight: 500;\">What's in the Bundle:</span><br><br>\n<span style=\"font-weight: 500;\">Tooth Armour Toothpaste Serum:</span> Tooth Armour is engineered to elevate your oral care. Powered by NH-10, a concentrated blend of 6 actives including Nano-Hydroxyapatite, together with hydrated silica, xylitol, hyaluronic acid, niacinamide, and zinc gluconate. Add it to your existing toothpaste or use alone. Either way, it's the upgrade your routine has been missing.\n<ul>\n<li>Powered with Nano-Hydroxyapatite, an ingredient engineered to mirror the mineral that makes up 97% of your enamel</li>\n<li>Supports strong teeth, and a hydrated mouth</li>\n<li>Works with your current routine or as a standalone</li>\n</ul>\n<span style=\"font-weight: 500;\">V34 Whitening Strips:</span> Whiter teeth in one use. Hismile's V34 Strips combine V34 colour correction with PAP+ technology to deliver whiter teeth. Simply apply, wait 30 minutes, then peel and brush off the residue to reveal results. This dual active technology pairs instant visual improvement with targeted stain removal, unlike anything you'll find off the shelf.\n<ul>\n<li>Immediate cosmetic colour correction</li>\n<li>Visible whitening after just 30 minutes</li>\n<li>14 applications per pack</li>\n</ul>\n<span style=\"font-weight: 500;\">iD Stain Whitening Mouthwash:</span> iD Stain is not your average mouthwash. As you rinse, the formula binds to gunk and oral residue in your mouth, pulling them into visible particles you can actually see in the sink, that's what your toothbrush didn't catch. Hydrogen peroxide maintains your white smile from the very first rinse, while essential oil actives leave your mouth feeling cleaner and fresher.\n<ul>\n<li>Helps Maintain White Teeth</li>\n<li>Removes gunk and oral residue</li>\n<li>Essential oils for a lasting fresh feeling</li>\n</ul>\n<span style=\"font-weight: 500;\">V34 Colour Corrector Serum:</span> V34 Colour Corrector Serum is a teeth whitener and brightener that's peroxide-free, designed to work exactly like concealer, but for your teeth. Using colour correcting technology, it's designed to temporarily conceal the yellow tones in your teeth to reveal a perceivably whiter smile. The results are entirely on the tooth surface, and it's a non-invasive alternative to bleaching!.\n<ul>\n<li>Uses colour correction technology</li>\n<li>Non-invasive whitening and brightening boost</li>\n</ul>\n<span style=\"font-weight: 500;\">FREE! Mystery coloured Hismile Electric Toothbrush:</span> Combining three intelligent cleaning modes, the Hismile Electric Toothbrush will provide you with a powerful and effective clean.\n<ul>\n<li>Three powerful cleaning modes</li>\n<li>Built-in timer for convenience</li>\n<li>Soft-tapered bristles for effective cleaning</li>\n<li>Mode memory to suit your brushing needs</li>\n</ul>\nSee individual product pages for full product information."
          }
        },
        "productAccordions": [
          {
            "title": "*What's included",
            "content": {
              "default": [
                {
                  "body": "1x Tooth Armour Toothpaste Serum {{10065-TA}}<br>\n              1x V34 Whitening Strips {{10060-VS}}<br>\n              1x V34 Colour Corrector Serum {{10018-CC}}<br>\n              1x iD Stain Whitening Mouthwash {{10068-PO}}<br>\n              1x Mystery coloured Electric Toothbrush valued at {{41004-ET-PU}} - FREE<br><br>\n              "
                }
              ]
            }
          },
          {
            "title": "List of ingredients",
            "content": {
              "default": [
                {
                  "head": "Tooth Armour Toothpaste Serum",
                  "body": "Aqua/Water, Glycerin, Hydrated Silica, Hydroxyapatite (nano), Xylitol, Sodium Hyaluronate, Niacinamide, Zinc Gluconate, Hydroxyethylcellulose, Silica, Caprylyl Glycol, 1,2-Hexanediol, Hydroxypropyl Methylcellulose, Potassium Chloride, Lauryl Glucoside, Flavour/Aroma, Sucralose, Carmine (CI 75470) , Menthol, Carvone, Mentha Piperita Oil, Anethole."
                },
                {
                  "head": "V34 Whitening Strips",
                  "body": "\n              Glycerin, Aqua/Water, Cellulose Gum, Hydroxypropyl Methylcellulose, Phthalimidoperoxycaproic Acid, Disodium EDTA, Sodium Hydroxide, Menthol, Monosodium Citrate, Xanthan Gum, PVM/MA Copolymer, C12-15 Pareth-3, D&C Red No. 33 (CI 17200), FD&C Blue No. 1 (CI 42090).\n              "
                },
                {
                  "head": "iD Stain Whitening Mouthwash",
                  "body": "\n              Aqua/Water, PEG-40 Hydrogenated Castor Oil, Glycerin, Citric Acid, Sodium Benzoate, Sucralose, Menthol, Flavour/Aroma, Potassium Sorbate, Xylitol, Sodium Citrate, Eucalyptus Globulus Leaf Oil, Hydrogen Peroxide, Sodium Phytate, Thymol, Caramel, Methyl Salicylate.\n              "
                },
                {
                  "head": "V34 Colour Corrector Serum",
                  "body": "\n              Glycerin, Aqua/Water, Sorbitol, Hydrated Silica, Xylitol, Polysorbate 80, Cellulose Gum, Mentha Piperita (Peppermint) Oil, Phenoxyethanol, Sucralose, Tetrasodium Pyrophosphate, CI17200/D&C Red No. 33, CI42090/FD&C Blue No.1, Ethylhexylglycerin.\n              "
                }
              ]
            }
          }
        ]
      }
    }
  ],
  [
    "V34_SERUM_BOGO@v34-serum-bogo",
    {
      "attributes": {
        "sku": "V34_SERUM_BOGO",
        "productHandle": "v34-serum-bogo",
        "categoryDetails": {
          "primaryCategory": "bundle"
        },
        "productTags": [
          "collection-hidden"
        ]
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_01_-_V34_Serum_Value_Set.png?v=1783547729",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/a2f06b7d355b41f88ef393dfb5c05f49.mp4",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-3_a7237219-45b8-4c7b-9fe2-5603c693848f.jpg?v=1746740235",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-4_fb5dab33-b8df-429c-bd4c-9861f332f1d7.jpg?v=1746740248",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/05-V34-PP_3e81af6e-fdf8-48dc-9b3c-b9b1f36a7fa7.jpg?v=1746740253",
              "height": 1536,
              "width": 2160
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "pill": {
          "variant": "promotion",
          "text": "FREE PRODUCT"
        },
        "disclaimer": "*Value based on full price of 2 serums purchased separately.",
        "styleTags": [
          "show-value",
          "hide-upsell"
        ],
        "description": {
          "title": "Utilises colour correction technology",
          "body": "V34 Colour Corrector Serum is a teeth brightener that's peroxide-free, designed to work exactly like concealer, but for your teeth. Using colour correcting technology, it’s designed to temporarily conceal the yellow tones in your teeth to reveal a perceivably whiter smile. The results are entirely on the tooth surface, and it’s a non-invasive alternative to bleaching!<br><br>Not after a value pack? You can buy a single V34 Colour Corrector Serum at full price <a href=\"/products/colour-corrector\" style=\"text-decoration: underline;\">here</a>."
        },
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/a4b3fd07d12bb98c276b9ee37f0b4a01.svg?v=1685928674",
              "height": 30,
              "width": 20
            },
            "text": "Colour correcting <br> technology"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1685928673",
              "height": 30,
              "width": 20
            },
            "text": "Brightening <br> boost"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Non-invasive <br> treatment"
          }
        ],
        "productAccordions": [
          {
            "title": "How does V34 Colour Corrector work?",
            "content": [
              {
                "body": "V34 Colour Corrector Serum is your go-to for a brightening boost, using colour correction to temporarily enhance the appearance of your smile! The results are entirely on the tooth surface, and it’s a non-invasive alternative to bleaching. Re-apply the V34 Serum as needed, individual results may vary."
              }
            ]
          },
          {
            "title": "How and when should I use V34 Colour Corrector Serum?",
            "content": [
              {
                "body": "The best results are achieved with direct application of the V34 Serum through a tool such as a cotton swab or soft bristled toothbrush. It’s important to gently polish the serum onto your teeth for 30 seconds, specifically focusing on the spots that are the most yellow, before wiping the leftover residue or rinsing with water if needed. V34 Serum can be reapplied as needed, and is recommended just before going out as a temporary concealer for yellow tones and a brightening boost to your smile."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "2x V34 Colour Corrector Serum<br>Total Net Contents: 30ml | 1 fl oz"
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Glycerin, Aqua/Water, Sorbitol, Hydrated Silica, Xylitol, Polysorbate 80, Cellulose Gum, Mentha Piperita (Peppermint) Oil, Phenoxyethanol, Sucralose, Tetrasodium Pyrophosphate, CI17200/D&C Red No. 33, CI42090/FD&C Blue No.1, Ethylhexylglycerin."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "What is V34 Colour Corrector Serum?",
              "content": [
                {
                  "body": "V34 Serum is a temporary teeth brightener that’s designed to work exactly like a concealer, but for your teeth. Using colour correcting technology, it’s designed to conceal the yellow tones in your teeth to improve and enhance the perceived brightness of your smile.<br><br>V34 Serum is for people who have yellow tones in their teeth and are looking for a concealer that can be applied as often as needed to temporarily reduce the appearance of yellow tones, leaving you with a perceivably whiter smile. If you are looking for a longer term whitening product, check our our <a style=\"text-decoration: underline\" href=\"/products/whitening-strips\">PAP+ Whitening Strips</a>"
                }
              ]
            },
            {
              "title": "Can I use V34 with veneers, caps, implants, bridges, or bonded teeth?",
              "content": [
                {
                  "body": "V34 is perfectly safe to be used on dental work as it is a non-abrasive form of brightening, however we would recommend to avoid brushing it onto these teeth, as only natural teeth can be colour-corrected.<br><br>We always advise checking with your dentist before using, to ensure it is a suitable product for you."
                }
              ]
            }
          ]
        },
        "customComponents": [
          {
            "name": "product-split-content",
            "location": "section-below-the-fold",
            "props": {
              "details": {
                "default": [
                  {
                    "content": {
                      "title": "Heard of purple shampoo? Bet you haven't tried it for your teeth. Here's how it works:",
                      "description": "Colour correction all starts on the colour wheel, where purple and yellow are complementary colours opposite to each other. Using a similar concept to purple shampoo, applying purple onto your teeth can temporarily neutralise the yellow undertones to conceal them, revealing a perceptively whiter shade. Pretty cool right?"
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/v34_Toothbrush_Drip.mp4?v=1632715790",
                      "height": 560,
                      "width": 560,
                      "alt": "V34 Colour Corrector Serum on toothbrush"
                    }
                  },
                  {
                    "content": {
                      "title": "We developed the perfect shade of deep violet purple, that neutralises yellow.",
                      "description": "V34 Serum is the perfect non-invasive brightening boost designed to temporarily conceal those pesky yellow stains. The best part is that it acts entirely on the tooth surface!"
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/V34_-_Content_-_Block_-_1.jpg?v=1632715890",
                      "height": 560,
                      "width": 560,
                      "alt": "Colour corrected teeth covered in V34 Colour Corrector Serum and home teeth whitened"
                    }
                  },
                  {
                    "content": {
                      "title": "Want a daily brightener that works in 30-seconds? V34 is for you",
                      "description": "A convenient solution designed for daily use, the same way you would use a concealer for your skin. Re-apply as needed for your go-to brightening boost!"
                    },
                    "media": {
                      "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/v34_UGC_Below_the_Fold.mp4?v=1632961072",
                      "height": 560,
                      "width": 560
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "V34_STRIPS_BARGAIN_PACK@v34-whitening-strips-value-pack-copy",
    {
      "attributes": {
        "sku": "V34_STRIPS_BARGAIN_PACK",
        "productHandle": "v34-whitening-strips-value-pack-copy",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/v34strips-upsell-hot-deal.png?v=1784850910"
              }
            ]
          }
        }
      },
      "content": {}
    }
  ],
  [
    "V34_STRIPS_BUNDLE_PACK@v34-whitening-strips-btgo",
    {
      "attributes": {
        "sku": "V34_STRIPS_BUNDLE_PACK",
        "productHandle": "v34-whitening-strips-btgo",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-01-v34strips-Buy2Get1Free.png?v=1776375940",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_02_-_V34_Strips_e0285166-6b3f-4728-ab16-321fad14795b.png?v=1769052241",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_03_-_V34_Strips_-_updated_22_10_25.png?v=1769052255",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_04_-_V34_Strips_-_updated_22_10_25.png?v=1769052262",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_05_-_V34_Strips_-_updated_22_10_25.png?v=1769052285",
              "height": 414,
              "width": 656
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Collection_-_V34_Strips_BTGO_-_Double-Wide.png?v=1784508611",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "pill": {
          "variant": "promotion",
          "text": "FREE PRODUCT"
        },
        "styleTags": [
          "alt-bulletpoints",
          "show-value",
          "hide-upsell",
          "blue-atc-button"
        ],
        "disclaimer": "*Value based on full price of 3 packs purchased separately.",
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/a4b3fd07d12bb98c276b9ee37f0b4a01.svg?v=1685928674",
              "height": 30,
              "width": 20
            },
            "text": "Colour correcting <br> technology"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0115/0985/8404/files/7e81922d8855af8b4d108b62edf5590e.svg?v=1685928673",
              "height": 30,
              "width": 20
            },
            "text": "Brightening <br> boost"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Non-invasive <br> treatment"
          }
        ],
        "description": {
          "title": "Whiter teeth after just one use.",
          "body": "Not after a value pack? You can buy a single pack at full price <a href=\"/products/v34-whitening-strips\" style=\"text-decoration: underline;\">here</a>.",
          "bulletpoints": [
            "Whiter Teeth after <strong>Just One Use*</strong>",
            "Not Satisfied? <strong>Get Your Money Back^</strong>",
            "Whitening After <strong>30-minutes*</strong>"
          ]
        },
        "productAccordions": [
          {
            "title": "How do V34 Strips work",
            "content": [
              {
                "body": "This innovative dual-active technology is unlike your supermarket whitening products, it combines V34’s instant colour correction which delivers a temporary visual improvement with PAP+ whitening to target surface stains for visible results.<br><br>Includes 42 individual applications."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Glycerin, Aqua/Water, Cellulose Gum, Hydroxypropyl Methylcellulose, Phthalimidoperoxycaproic Acid, Disodium EDTA, Sodium Hydroxide, Menthol, Monosodium Citrate, Xanthan Gum, PVM/MA Copolymer, C12-15 Pareth-3, D&C Red No. 33 (CI 17200), FD&C Blue No. 1 (CI 42090)."
              }
            ]
          },
          {
            "title": "^Money Back Guarantee",
            "content": [
              {
                "body": "Hismile is offering a Money Back Guarantee for the V34 Whitening Strips. We’re confident you’ll love the product, but if you're not satisfied, we're offering a refund of the purchase price (excluding shipping), subject to the terms and conditions.<br><br>This offer applies only to purchases made via www.hismileteeth.com. Return requests must be submitted within seven (7) days of receiving your order. Customers are responsible for return shipping costs. This offer is in addition to any rights under applicable consumer protection laws.<br><br>Full terms & conditions, including instructions on how to claim, can be found <a style=\"text-decoration: underline\" href='/pages/terms-conditions'>here</a>."
              }
            ]
          },
          {
            "title": "*Tested for results",
            "content": [
              {
                "body": "\n                Hismile’s V34 Whitening Strips were tested in a blinded placebo controlled clinical study of 60 participants tested immediately and 24 hours after a 30-minute application. After application, all participants had 2 or more shades improvement. At 24 hours, 96% of participants had 2 or more shades improvement. Assessments were based on a VITA Bleachguide 3D-MASTER® assessment. \n                "
              },
              {
                "body": "\n                Results are not guaranteed for all individuals, and individual results may vary. Immediate results are temporary and whitening is not permanent.\n                "
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Got questions? We've got answers",
          "accordions": [
            {
              "title": "How many shades different should I see?",
              "content": [
                {
                  "body": "Results vary, some see a visible difference after one use being the temporary colour correction effects"
                }
              ]
            },
            {
              "title": "How do I use them?",
              "content": [
                {
                  "body": "Start by thoroughly drying your teeth. Apply the long V34 Strip to your upper teeth, pressing firmly for a secure fit. Repeat with short strip on bottom teeth. Leave strips on for 30 minutes to allow the dual-active formula to work. Remove strips and brush in any remaining purple residue and rinse if needed."
                }
              ]
            }
          ]
        },
        "customComponents": [
          {
            "name": "ui-pill",
            "location": "below-atc-content",
            "props": {
              "variant": "money-back-pill",
              "text": "BUY 2 GET 1 FREE"
            }
          }
        ]
      }
    }
  ],
  [
    "V34_STRIPS_TRIPLE_VALUE_SET@v34-strips-triple-value-set",
    {
      "attributes": {
        "sku": "V34_STRIPS_TRIPLE_VALUE_SET",
        "productHandle": "v34-strips-triple-value-set",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_01_-_V34_Strips_Triple_Value_Set.png?v=1783547729",
              "height": 512,
              "width": 352,
              "alt": "Best Selling V34 Whitening Strips"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_02_-_V34_Strips_e0285166-6b3f-4728-ab16-321fad14795b.png?v=1769052241",
              "height": 512,
              "width": 352,
              "alt": "In a study, 96% of participants had 2 or more shades whiter teeth*"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_03_-_V34_Strips_-_updated_22_10_25.png?v=1769052255",
              "height": 512,
              "width": 352,
              "alt": "Top teeth results"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_04_-_V34_Strips_-_updated_22_10_25.png?v=1769052262",
              "height": 512,
              "width": 352,
              "alt": "Amazon reviews"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP_-_05_-_V34_Strips_-_updated_22_10_25.png?v=1769052285",
              "height": 414,
              "width": 656,
              "alt": "Before. Apply. After. Strips"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Collection_-_V34_Strips_Triple_Value_Set_-_Double-Wide.png?v=1784775997",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "disclaimer": "*Value based on full price of 3 packs purchased separately.",
        "styleTags": [
          "show-value",
          "blue-atc-button",
          "alt-bulletpoints"
        ],
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/money-icon.png?v=1755142733",
              "height": 30,
              "width": 20
            },
            "text": "Money back<br>guarantee"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/application-icon.png?v=1755142734",
              "height": 30,
              "width": 20
            },
            "text": "$2.79 per<br> application"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Tooth.png?v=1750650505",
              "height": 30,
              "width": 20
            },
            "text": "Experts in whitening"
          }
        ],
        "description": {
          "title": "Whiter teeth after just one use.",
          "body": "Not after a value pack? You can buy a single pack of strips at full price <a href=\"/products/v34-whitening-strips\" style=\"text-decoration: underline;\">here</a>.",
          "bulletpoints": [
            "Whiter Teeth after <strong style=\"font-weight: 500\">Just One Use*</strong>",
            "Not Satisfied? <strong style=\"font-weight: 500\">Get Your Money Back^</strong>",
            "Whitening After <strong style=\"font-weight: 500\">30-minutes*</strong>"
          ]
        },
        "productAccordions": [
          {
            "title": "How do V34 Strips work",
            "content": [
              {
                "body": "This innovative dual-active technology is unlike your supermarket whitening products, it combines V34’s instant colour correction which delivers a temporary visual improvement with PAP+ whitening to target surface stains for visible results.<br><br>Includes 42 individual applications."
              }
            ]
          },
          {
            "title": "List of ingredients",
            "content": [
              {
                "body": "Glycerin, Aqua/Water, Cellulose Gum, Hydroxypropyl Methylcellulose, Phthalimidoperoxycaproic Acid, Disodium EDTA, Sodium Hydroxide, Menthol, Monosodium Citrate, Xanthan Gum, PVM/MA Copolymer, C12-15 Pareth-3, D&C Red No. 33 (CI 17200), FD&C Blue No. 1 (CI 42090)."
              }
            ]
          },
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "3x boxes of v34 Whitening Strips"
              }
            ]
          },
          {
            "title": "^Money Back Guarantee",
            "content": [
              {
                "body": "Hismile is offering a Money Back Guarantee for the V34 Whitening Strips. We’re confident you’ll love the product, but if you're not satisfied, we're offering a refund of the purchase price (excluding shipping), subject to the terms and conditions.<br><br>This offer applies only to purchases made via www.hismileteeth.com. Return requests must be submitted within seven (7) days of receiving your order. Customers are responsible for return shipping costs. This offer is in addition to any rights under applicable consumer protection laws.<br><br>Full terms & conditions, including instructions on how to claim, can be found <a style=\"text-decoration: underline\" href='/pages/terms-conditions'>here</a>."
              }
            ]
          },
          {
            "title": "*Tested for results",
            "content": [
              {
                "body": "\n                Hismile’s V34 Whitening Strips were tested in a blinded placebo controlled clinical study of 60 participants tested immediately and 24 hours after a 30-minute application. After application, all participants had 2 or more shades improvement. At 24 hours, 96% of participants had 2 or more shades improvement. Assessments were based on a VITA Bleachguide 3D-MASTER® assessment.\n                "
              },
              {
                "body": "\n                Results are not guaranteed for all individuals, and individual results may vary. Immediate results are temporary and whitening is not permanent.\n                "
              }
            ]
          }
        ]
      }
    }
  ],
  [
    "V34_STRIPS_VALUE_DEAL@v34-whitening-strips-bfd",
    {
      "attributes": {
        "sku": "V34_STRIPS_VALUE_DEAL",
        "productHandle": "v34-whitening-strips-bfd",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/CCWS_-_Upsell_Image_-_DUTT.png?v=1778117326"
              }
            ]
          }
        }
      },
      "content": {}
    }
  ],
  [
    "V34_STRIPS_VALUE_PACK@v34-strips-value-bundle",
    {
      "attributes": {
        "sku": "V34_STRIPS_VALUE_PACK",
        "productHandle": "v34-strips-value-bundle",
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "customProductAsset": {
          "upsellImage": {
            "default": [
              {
                "mobile": {
                  "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/v34strips-upsell-m.png?v=1784846851"
                },
                "desktop": {
                  "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/v34strips-upsell-d.png?v=1784846962"
                }
              }
            ]
          }
        }
      },
      "content": {}
    }
  ],
  [
    "VARIANT-BLUE-RASPBERRY@variant-product-blue-raspberry",
    {
      "attributes": {
        "sku": "VARIANT-BLUE-RASPBERRY",
        "productHandle": "variant-product-blue-raspberry",
        "categoryDetails": {
          "primaryCategory": "toothpaste"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/v34Serum-ProductPage_26e00517-a733-41a0-8a04-d641a41b7385.png?v=1746740211",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/videos/c/o/v/a2f06b7d355b41f88ef393dfb5c05f49.mp4",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-3_a7237219-45b8-4c7b-9fe2-5603c693848f.jpg?v=1746740235",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/V34ProductPageRefresh-4_fb5dab33-b8df-429c-bd4c-9861f332f1d7.jpg?v=1746740248",
              "height": 512,
              "width": 352
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/05-V34-PP_3e81af6e-fdf8-48dc-9b3c-b9b1f36a7fa7.jpg?v=1746740253",
              "height": 512,
              "width": 352
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "",
            "height": 100,
            "width": 200
          }
        }
      },
      "content": {
        "specialFeatures": [
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          },
          {
            "icon": {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/f54306d9b3ace345c3d7bccb17b64959.svg?v=1683509233",
              "height": 30,
              "width": 20
            },
            "text": "Flavour & <br> freshness"
          }
        ],
        "productAccordions": [
          {
            "title": "What’s included?",
            "content": [
              {
                "body": "1x Barbie Pink Bubblegum Toothpaste. Total Net Contents: 60g | 2.1 oz"
              }
            ]
          }
        ],
        "customComponents": [
          {
            "name": "product-split-media",
            "location": "section-below-the-fold",
            "props": {
              "assets": {
                "default": [
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_01_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_01_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 712,
                      "alt": "Barbie"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_02_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste on the Barbie Electric Toothbrush"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_02_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 712,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste on the Barbie Electric Toothbrush"
                    }
                  },
                  {
                    "mobile": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_03_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 600,
                      "width": 414,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste Bottle"
                    },
                    "desktop": {
                      "src": "https://cdn.shopify.com/s/files/1/1525/9812/files/Toothpaste_Product_Page_-_BTF_-_03_-_Barbie_Pink_Bubblegum_Toothpaste.png?v=1719968343",
                      "height": 1000,
                      "width": 1440,
                      "alt": "Barbie Pink Bubblegum Flavoured Toothpaste Bottle"
                    }
                  }
                ]
              }
            }
          }
        ]
      }
    }
  ],
  [
    "WHITENING_DUO_BUNDLE@whitening-duo-bundle",
    {
      "attributes": {
        "sku": "WHITENING_DUO_BUNDLE",
        "productHandle": "whitening-duo-bundle",
        "categoryDetails": {
          "primaryCategory": "bundle"
        },
        "age": 9
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-01-CC_WS.png?v=1768448827",
              "height": 1242,
              "width": 984
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-02-CC_WS.png?v=1768448827",
              "height": 1242,
              "width": 984
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-03-CC_WS_3941d263-0463-4afb-aea7-cfff0e2f1858.png?v=1768448827",
              "height": 1242,
              "width": 984
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-04-CC_WS.png?v=1768448828",
              "height": 1242,
              "width": 984
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/PP-05-CC_WS_c830e539-deaa-41a8-86a7-9efcd0879936.png?v=1768448827",
              "height": 414,
              "width": 656
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Collection_-_CC_WS_-_Double-Wide.png?v=1768438045",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "styleTags": [
          "percentage-off-pill"
        ],
        "pill": {
          "variant": "information",
          "text": "Bundle & Save"
        },
        "disclaimer": "*Save {{percentageOff}} compared to purchasing items individually at standard prices",
        "description": {
          "title": "Two steps to your brightest smile yet.",
          "body": "The Whitening Duo combines our V34 Colour Corrector Serum and PAP+ Whitening Strips for both an instant and long-lasting whitening effect. V34 uses colour correcting technology to neutralise yellow tones and give an immediate brightening boost, while PAP+ Strips work more gradually to whiten beneath the surface — no peroxide, no sensitivity. Use together for the ultimate non-invasive whitening routine.",
          "bulletpoints": []
        },
        "productAccordions": [
          {
            "title": "List of ingredients",
            "content": [
              {
                "head": "V34 Colour Corrector Serum",
                "body": "Glycerin, Aqua/Water, Sorbitol, Hydrated Silica, Xylitol, Polysorbate 80, Cellulose Gum, Mentha Piperita (Peppermint) Oil, Phenoxyethanol, Sucralose, Tetrasodium Pyrophosphate, CI17200/D&C Red No. 33, CI42090/FD&C Blue No.1, Ethylhexylglycerin."
              },
              {
                "head": "PAP+ Whitening Strips",
                "body": "Glycerin, Aqua/Water, PVP, Ethylcellulose, Alcohol, Sodium Polyacrylate, Phthalimidoperoxycaproic Acid (PAP), Xylitol, Potassium Citrate, Hydroxyapatite, Rebaudioside A, Menthol, Sodium Citrate, Xanthan Gum, PVM/MA Copolymer, C12-15 Pareth-3."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "<ul><li>1x PAP+ Whitening Strips</li><li>1x V34 Colour Corrector Serum</li></ul>"
              }
            ]
          }
        ]
      }
    }
  ],
  [
    "WHITENING_PROTOCOL_BUNDLE@whitening-protocol-bundle",
    {
      "attributes": {
        "sku": "WHITENING_PROTOCOL_BUNDLE",
        "productHandle": "whitening-protocol-bundle",
        "productFlags": [
          "expandBundleInCart"
        ],
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_01_-_Whitening_Protocol_MB_4c847445-73a1-4653-ac80-76f015c84630.png?v=1788329693",
              "height": 1536,
              "width": 1068,
              "alt": "Whitening Protocol Bundle with iD Stain Whitening Mouthwash, Exfoliating Tooth Wipes, Tooth Armour Toothpaste Serum and V34 Whitening Strips, plus a Money Back Guarantee badge"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_02_-_Whitening_Protocol_2749cb46-c738-4a29-ab61-e844c345ee10.png?v=1788397698",
              "height": 1536,
              "width": 1068,
              "alt": "Six close-up results of V34 Whitening Strips on top teeth. Temporary results, results may vary"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_03_-_Whitening_Protocol_56c637f3-82b2-48c4-b990-c9400b0a73e0.png?v=1788397698",
              "height": 1536,
              "width": 1068,
              "alt": "Before and after cups of iD Stain Whitening Mouthwash, with visible residue in the after cup. Use as directed, results may vary"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_04_-_Whitening_Protocol_f00bfba7-4429-4d96-9d43-1220ef86b1a8.png?v=1788397698",
              "height": 1536,
              "width": 1068,
              "alt": "Tooth Armour Toothpaste Serum box and bottle, powered with Nano-Hydroxyapatite"
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/PP_-_05_-_Whitening_Protocol_2e3707af-7c8f-4cb7-9652-7c4b1937e754.png?v=1788409667",
              "height": 1251,
              "width": 1968,
              "alt": "Tooth Armour Toothpaste Serum on a toothbrush and an Exfoliating Tooth Wipe on a finger, with the key benefits of each"
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/Collection_-_Whitening_Protocol_-_Double-Wide_c92701fb-5f1d-4bcb-b51e-59990070469b.png?v=1790741570",
            "height": 368,
            "width": 616,
            "alt": "Whitening Protocol Bundle with V34 Whitening Strips, iD Stain Whitening Mouthwash, Tooth Armour Toothpaste Serum and Exfoliating Tooth Wipes, plus a Money Back Guarantee badge"
          }
        }
      },
      "content": {
        "styleTags": [
          "show-value"
        ],
        "productCardBadge": {
          "position": "bottom-left",
          "media": "global"
        },
        "productImageBadge": {
          "position": "top-left",
          "media": "none"
        },
        "pill": {
          "variant": "information",
          "text": "Bundle & Save"
        },
        "disclaimer": "*Value based on full price of all four products purchased separately.",
        "description": {
          "title": "7 days. 4 steps. One complete routine.",
          "body": "4 products. One routine. Target surface stains, remove daily build-up, help maintain white teeth and support your everyday oral care routine.<br><br>\n<span style=\"font-weight: 500;\">The complete protocol for whiter-looking teeth.</span><br>\n<span style=\"font-weight: 500;\">Not satisfied? Get your money back.^</span><br><br>\n<span style=\"font-weight: 500;\">What’s included:</span><br><br>\n<span style=\"font-weight: 500;\">V34 Whitening Strips:</span> Visible whitening after just one use.* Dual-active technology combines PAP+ whitening with V34 colour correction. PAP+ targets surface stains for visible whitening, while V34 provides a temporary visual improvement by neutralising yellow tones. 14 individual applications included.<br><br>\n<span style=\"font-weight: 500;\">Exfoliating Tooth Wipes:</span> Wipe away stains before they set. Food, drinks and residue can build up during the 12–14 hours between regular brushing. The engineered textured surface helps physically lift surface plaque, residue and daily build-up from your teeth—without water, toothpaste or a sink. Infused with hydroxyapatite and xylitol to support your everyday oral care routine.<br><br>\n<span style=\"font-weight: 500;\">Tooth Armour:</span> 6 actives. 1 toothpaste serum. Powered by NH-10, a concentrated blend of six actives including Nano-Hydroxyapatite—an ingredient engineered to mirror the mineral your enamel is mostly made of. Use it with your regular toothpaste or on its own to elevate your daily brushing routine and help maintain white teeth.**<br><br>\n<span style=\"font-weight: 500;\">iD Stain Whitening Mouthwash:</span> See what your toothbrush left behind. iD Stain targets build-up in the areas brushing can miss and pulls it into visible particles you can actually see in the sink.† Powered by hydrogen peroxide and essential-oil actives, it helps maintain white teeth and freshens breath at the source. This is not your average mouthwash.<br><br>\n</ul>\nSee individual product pages for full product information.<br><br>\n*Individual results may vary. V34 colour correction provides a temporary visual improvement.<br>\n**Helps maintain white teeth through mechanical action with regular brushing.<br>\n^Eligibility requirements, claim periods and exclusions apply. See the 7-Day Whitening Protocol Money-Back Guarantee <a style=\"text-decoration: underline\" href='/pages/terms-conditions'>Terms and Conditions</a>.<br>\n†Visible residue following use of iD Stain Whitening Mouthwash is not guaranteed and depends on individual factors. <br><br><i>Use every product only as directed and as part of a good oral care routine.</i>",
          "bulletpoints": []
        },
        "productAccordions": [
          {
            "title": "List of ingredients",
            "content": [
              {
                "head": "Exfoliating Tooth Wipes",
                "body": "Aqua/Water, Polysorbate 20, Xylitol, Pentasodium Triphosphate, Hydroxyapatite, Sodium Bicarbonate, Calcium Carbonate, Flavour/Aroma, Sodium Chloride, Caprylyl Glycol, Gluconolactone, Sucralose, Menthol, Hydroxyacetophenone, Citric Acid, Sodium Citrate, Anethole, Camphor, Carvone, Mentha Piperita Oil, Pinene."
              },
              {
                "head": "Tooth Armour Toothpaste Serum",
                "body": "Aqua/Water, Glycerin, Hydrated Silica, Hydroxyapatite (nano), Xylitol, Sodium Hyaluronate, Niacinamide, Zinc Gluconate, Hydroxyethylcellulose, Silica, Caprylyl Glycol, 1,2-Hexanediol, Hydroxypropyl Methylcellulose, Potassium Chloride, Lauryl Glucoside, Flavour/Aroma, Sucralose, Carmine (CI 75470) , Menthol, Carvone, Mentha Piperita Oil, Anethole."
              },
              {
                "head": "iD Stain Whitening Mouthwash",
                "body": "Aqua/Water, PEG-40 Hydrogenated Castor Oil, Glycerin, Citric Acid, Sodium Benzoate, Sucralose, Menthol, Flavour/Aroma, Potassium Sorbate, Xylitol, Sodium Citrate, Eucalyptus Globulus Leaf Oil, Hydrogen Peroxide, Sodium Phytate, Thymol, Caramel, Methyl Salicylate."
              },
              {
                "head": "V34 Whitening Strips",
                "body": "Glycerin, Aqua/Water, Cellulose Gum, Hydroxypropyl Methylcellulose, Phthalimidoperoxycaproic Acid, Disodium EDTA, Sodium Hydroxide, Menthol, Monosodium Citrate, Xanthan Gum, PVM/MA Copolymer, C12-15 Pareth-3, D&C Red No. 33 (CI 17200), FD&C Blue No. 1 (CI 42090)."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "<ul><li>1x Exfoliating Tooth Wipes</li><li>1x Tooth Armour Toothpaste Serum</li><li>1x iD Stain Whitening Mouthwash</li><li>1x V34 Whitening Strips</li></ul>"
              }
            ]
          },
          {
            "title": "^Money Back Guarantee",
            "content": [
              {
                "body": "Hismile is offering a Money Back Guarantee for the Whitening Protocol Bundle. We're confident you'll love the products, but if you're not satisfied, we're offering a refund for the purchase price (excluding shipping), subject to the terms and conditions below.<br><br>This offer applies only to purchases made via <a style=\"text-decoration: underline\" href='/'>www.hismileteeth.com</a>. Return requests must be submitted within the timeframe stipulated in the terms and conditions. Customers are responsible for return shipping costs. This offer is in addition to any rights under applicable consumer protection laws.<br><br>Full terms and conditions, including instructions on how to claim, can be found <a style=\"text-decoration: underline\" href='/pages/terms-conditions'>here</a>."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Frequently asked questions",
          "accordions": [
            {
              "title": "What is the 7-Day Whitening Protocol?",
              "content": [
                {
                  "body": "The 7-Day Whitening Protocol is a complete routine featuring V34 Whitening Strips, Exfoliating Tooth Wipes, Tooth Armour and iD Stain Whitening Mouthwash.<br><br>Each product performs a different role within the protocol: whitening surface stains, temporarily correcting yellow tones, removing daily build-up and helping maintain white teeth."
                }
              ]
            },
            {
              "title": "How long does the protocol take?",
              "content": [
                {
                  "body": "The protocol is followed daily for seven consecutive days. V34 Whitening Strips are worn for 30 minutes, while the remaining products are incorporated into your morning, daytime and evening oral care routine."
                }
              ]
            },
            {
              "title": "When should I use each product?",
              "content": [
                {
                  "body": "Use Tooth Armour when brushing in the morning, an Exfoliating Tooth Wipe during the day, and iD Stain Whitening Mouthwash and V34 Whitening Strips as part of your evening routine.<br><br>Always follow the directions provided with each product."
                }
              ]
            },
            {
              "title": "Can I continue using the products after seven days?",
              "content": [
                {
                  "body": "Yes. Tooth Armour, Exfoliating Tooth Wipes and iD Stain Whitening Mouthwash are designed to complement an ongoing oral care routine. V34 Whitening Strips can be used according to the directions provided with the product."
                }
              ]
            },
            {
              "title": "What if I'm not satisfied?",
              "content": [
                {
                  "body": "Complete the 7-Day Whitening Protocol as directed. If you're not satisfied with your experience, you can submit a claim under our money-back guarantee.^<br><br>Eligibility requirements, claim periods and exclusions apply. See the full <a style=\"text-decoration: underline\" href='/pages/terms-conditions'>terms and conditions</a>."
                }
              ]
            }
          ]
        }
      }
    }
  ],
  [
    "WHITENING_PROTOCOL_LANDING@whitening-protocol-landing",
    {
      "attributes": {
        "sku": "WHITENING_PROTOCOL_LANDING",
        "productHandle": "whitening-protocol-landing",
        "productFlags": [
          "expandBundleInCart"
        ],
        "categoryDetails": {
          "primaryCategory": "bundle"
        }
      },
      "media": {
        "carousel": {
          "default": [
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/WPB_LP_-_Carousel_1_8374bf90-10ea-409b-8cba-1d1cd119e49a.png?v=1790571687",
              "height": 1000,
              "width": 1000
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/WPB_LP_-_Carousel_2.png?v=1790567253",
              "height": 1000,
              "width": 1000
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/WPB_LP_-_Carousel_3.png?v=1790567253",
              "height": 1000,
              "width": 1000
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/WPB_LP_-_Carousel_4.png?v=1790567254",
              "height": 1000,
              "width": 1000
            },
            {
              "src": "https://cdn.shopify.com/s/files/1/0916/4078/files/WPB_LP_-_Carousel_5.png?v=1790567254",
              "height": 1000,
              "width": 1000
            }
          ]
        },
        "doubleWide": {
          "default": {
            "src": "https://cdn.shopify.com/s/files/1/2502/5300/files/Collection_-_Whitening_Protocol_-_Double-Wide_d4a8efac-5575-40f5-891f-bb02aa98ea24.png?v=1788397698",
            "height": 368,
            "width": 616
          }
        }
      },
      "content": {
        "styleTags": [
          "show-value"
        ],
        "customButtonText": "Add to cart - Start the 7-day protocol",
        "productCardBadge": {
          "position": "bottom-left",
          "media": "global"
        },
        "productImageBadge": {
          "position": "top-left",
          "media": "none"
        },
        "pill": {
          "variant": "information",
          "text": "Bundle & Save"
        },
        "valuePrice": [
          {
            "sku": "10060-VS",
            "quantity": 1
          },
          {
            "sku": "10069-TW",
            "quantity": 1
          },
          {
            "sku": "10065-TA",
            "quantity": 1
          },
          {
            "sku": "10068-PO",
            "quantity": 1
          }
        ],
        "description": {
          "title": "7 days. 4 steps. One complete routine.",
          "body": "4 products. One routine. Target surface stains, remove daily build-up, help maintain white teeth and support your everyday oral care routine.<br><br>\n<span style=\"font-weight: 500;\">The complete protocol for whiter-looking teeth.</span><br>\n<span style=\"font-weight: 500;\">Not satisfied? Get your money back.^</span><br><br>\n<span style=\"font-weight: 500;\">What’s included:</span><br><br>\n<span style=\"font-weight: 500;\">V34 Whitening Strips:</span> Visible whitening after just one use.* Dual-active technology combines PAP+ whitening with V34 colour correction. PAP+ targets surface stains for visible whitening, while V34 provides a temporary visual improvement by neutralising yellow tones. 14 individual applications included.<br><br>\n<span style=\"font-weight: 500;\">Exfoliating Tooth Wipes:</span> Wipe away stains before they set. Food, drinks and residue can build up during the 12–14 hours between regular brushing. The engineered textured surface helps physically lift surface plaque, residue and daily build-up from your teeth—without water, toothpaste or a sink. Infused with hydroxyapatite and xylitol to support your everyday oral care routine.<br><br>\n<span style=\"font-weight: 500;\">Tooth Armour:</span> 6 actives. 1 toothpaste serum. Powered by NH-10, a concentrated blend of six actives including Nano-Hydroxyapatite—an ingredient engineered to mirror the mineral your enamel is mostly made of. Use it with your regular toothpaste or on its own to elevate your daily brushing routine and help maintain white teeth.**<br><br>\n<span style=\"font-weight: 500;\">iD Stain Whitening Mouthwash:</span> See what your toothbrush left behind. iD Stain targets build-up in the areas brushing can miss and pulls it into visible particles you can actually see in the sink.† Powered by hydrogen peroxide and essential-oil actives, it helps maintain white teeth and freshens breath at the source. This is not your average mouthwash.<br><br>\n</ul>\nSee individual product pages for full product information.<br><br>\n*Individual results may vary. V34 colour correction provides a temporary visual improvement.<br>\n**Helps maintain white teeth through mechanical action with regular brushing.<br>\n^Eligibility requirements, claim periods and exclusions apply. See the 7-Day Whitening Protocol Money-Back Guarantee <a style=\"text-decoration: underline\" href='/pages/terms-conditions'>Terms and Conditions</a>.<br>\n†Visible residue following use of iD Stain Whitening Mouthwash is not guaranteed and depends on individual factors. <br><br><i>Use every product only as directed and as part of a good oral care routine.</i>",
          "bulletpoints": []
        },
        "productAccordions": [
          {
            "title": "List of ingredients",
            "content": [
              {
                "head": "Exfoliating Tooth Wipes",
                "body": "Aqua/Water, Polysorbate 20, Xylitol, Pentasodium Triphosphate, Hydroxyapatite, Sodium Bicarbonate, Calcium Carbonate, Flavour/Aroma, Sodium Chloride, Caprylyl Glycol, Gluconolactone, Sucralose, Menthol, Hydroxyacetophenone, Citric Acid, Sodium Citrate, Anethole, Camphor, Carvone, Mentha Piperita Oil, Pinene."
              },
              {
                "head": "Tooth Armour Toothpaste Serum",
                "body": "Aqua/Water, Glycerin, Hydrated Silica, Hydroxyapatite (nano), Xylitol, Sodium Hyaluronate, Niacinamide, Zinc Gluconate, Hydroxyethylcellulose, Silica, Caprylyl Glycol, 1,2-Hexanediol, Hydroxypropyl Methylcellulose, Potassium Chloride, Lauryl Glucoside, Flavour/Aroma, Sucralose, Carmine (CI 75470) , Menthol, Carvone, Mentha Piperita Oil, Anethole."
              },
              {
                "head": "iD Stain Whitening Mouthwash",
                "body": "Aqua/Water, PEG-40 Hydrogenated Castor Oil, Glycerin, Citric Acid, Sodium Benzoate, Sucralose, Menthol, Flavour/Aroma, Potassium Sorbate, Xylitol, Sodium Citrate, Eucalyptus Globulus Leaf Oil, Hydrogen Peroxide, Sodium Phytate, Thymol, Caramel, Methyl Salicylate."
              },
              {
                "head": "V34 Whitening Strips",
                "body": "Glycerin, Aqua/Water, Cellulose Gum, Hydroxypropyl Methylcellulose, Phthalimidoperoxycaproic Acid, Disodium EDTA, Sodium Hydroxide, Menthol, Monosodium Citrate, Xanthan Gum, PVM/MA Copolymer, C12-15 Pareth-3, D&C Red No. 33 (CI 17200), FD&C Blue No. 1 (CI 42090)."
              }
            ]
          },
          {
            "title": "What's included",
            "content": [
              {
                "body": "<ul><li>1x Exfoliating Tooth Wipes</li><li>1x Tooth Armour Toothpaste Serum</li><li>1x iD Stain Whitening Mouthwash</li><li>1x V34 Whitening Strips</li></ul>"
              }
            ]
          },
          {
            "title": "^Money Back Guarantee",
            "content": [
              {
                "body": "Hismile is offering a Money Back Guarantee for the Whitening Protocol Bundle. We're confident you'll love the products, but if you're not satisfied, we're offering a refund for the purchase price (excluding shipping), subject to the terms and conditions below.<br><br>This offer applies only to purchases made via <a style=\"text-decoration: underline\" href='/'>www.hismileteeth.com</a>. Return requests must be submitted within the timeframe stipulated in the terms and conditions. Customers are responsible for return shipping costs. This offer is in addition to any rights under applicable consumer protection laws.<br><br>Full terms and conditions, including instructions on how to claim, can be found <a style=\"text-decoration: underline\" href='/pages/terms-conditions'>here</a>."
              }
            ]
          }
        ],
        "faqAccordion": {
          "title": "Frequently asked questions",
          "accordions": [
            {
              "title": "What is the 7-Day Whitening Protocol?",
              "content": [
                {
                  "body": "The 7-Day Whitening Protocol is a complete routine featuring V34 Whitening Strips, Exfoliating Tooth Wipes, Tooth Armour and iD Stain Whitening Mouthwash.<br><br>Each product performs a different role within the protocol: whitening surface stains, temporarily correcting yellow tones, removing daily build-up and helping maintain white teeth."
                }
              ]
            },
            {
              "title": "How long does the protocol take?",
              "content": [
                {
                  "body": "The protocol is followed daily for seven consecutive days. V34 Whitening Strips are worn for 30 minutes, while the remaining products are incorporated into your morning, daytime and evening oral care routine."
                }
              ]
            },
            {
              "title": "When should I use each product?",
              "content": [
                {
                  "body": "Use Tooth Armour when brushing in the morning, an Exfoliating Tooth Wipe during the day, and iD Stain Whitening Mouthwash and V34 Whitening Strips as part of your evening routine.<br><br>Always follow the directions provided with each product."
                }
              ]
            },
            {
              "title": "Can I continue using the products after seven days?",
              "content": [
                {
                  "body": "Yes. Tooth Armour, Exfoliating Tooth Wipes and iD Stain Whitening Mouthwash are designed to complement an ongoing oral care routine. V34 Whitening Strips can be used according to the directions provided with the product."
                }
              ]
            },
            {
              "title": "What if I'm not satisfied?",
              "content": [
                {
                  "body": "Complete the 7-Day Whitening Protocol as directed. If you're not satisfied with your experience, you can submit a claim under our money-back guarantee.^<br><br>Eligibility requirements, claim periods and exclusions apply. See the full <a style=\"text-decoration: underline\" href='/pages/terms-conditions'>terms and conditions</a>."
                }
              ]
            }
          ]
        }
      }
    }
  ]
]);